// Generated by scripts/get-device-tree.js
export const devices = [
  {
    "value": "Computers",
    "label": "Computers",
    "options": [
      {
        "image": require("./images/Computers/Apple MacBook Air/Device/Apple MacBook Air 13\" Gold.png"),
        "value": "./images/Computers/Apple MacBook Air/Device/Apple MacBook Air 13\" Gold.png",
        "label": "Apple MacBook Air 13\" Gold",
        "width": 3460,
        "height": 2060,
        "top": 103,
        "left": 262
      },
      {
        "image": require("./images/Computers/Apple MacBook Air/Device/Apple MacBook Air 13\" Silver.png"),
        "value": "./images/Computers/Apple MacBook Air/Device/Apple MacBook Air 13\" Silver.png",
        "label": "Apple MacBook Air 13\" Silver",
        "width": 3460,
        "height": 2060,
        "top": 103,
        "left": 262
      },
      {
        "image": require("./images/Computers/Apple MacBook Air/Device/Apple MacBook Air 13\" Space Grey.png"),
        "value": "./images/Computers/Apple MacBook Air/Device/Apple MacBook Air 13\" Space Grey.png",
        "label": "Apple MacBook Air 13\" Space Grey",
        "width": 3460,
        "height": 2060,
        "top": 103,
        "left": 262
      },
      {
        "image": require("./images/Computers/Apple MacBook Air/Device with Shadow/Apple MacBook Air 13\" Gold.png"),
        "value": "./images/Computers/Apple MacBook Air/Device with Shadow/Apple MacBook Air 13\" Gold.png",
        "label": "Apple MacBook Air 13\" Gold with shadow",
        "width": 3460,
        "height": 2060,
        "top": 103,
        "left": 262
      },
      {
        "image": require("./images/Computers/Apple MacBook Air/Device with Shadow/Apple MacBook Air 13\" Silver.png"),
        "value": "./images/Computers/Apple MacBook Air/Device with Shadow/Apple MacBook Air 13\" Silver.png",
        "label": "Apple MacBook Air 13\" Silver with shadow",
        "width": 3460,
        "height": 2060,
        "top": 103,
        "left": 262
      },
      {
        "image": require("./images/Computers/Apple MacBook Air/Device with Shadow/Apple MacBook Air 13\" Space Grey.png"),
        "value": "./images/Computers/Apple MacBook Air/Device with Shadow/Apple MacBook Air 13\" Space Grey.png",
        "label": "Apple MacBook Air 13\" Space Grey with shadow",
        "width": 3460,
        "height": 2060,
        "top": 103,
        "left": 262
      },
      {
        "image": require("./images/Computers/Apple MacBook Pro/Device/Apple Macbook Pro 13\" Silver.png"),
        "value": "./images/Computers/Apple MacBook Pro/Device/Apple Macbook Pro 13\" Silver.png",
        "label": "Apple Macbook Pro 13\" Silver",
        "width": 3460,
        "height": 2200,
        "top": 136,
        "left": 427
      },
      {
        "image": require("./images/Computers/Apple MacBook Pro/Device/Apple Macbook Pro 13\" Space Grey.png"),
        "value": "./images/Computers/Apple MacBook Pro/Device/Apple Macbook Pro 13\" Space Grey.png",
        "label": "Apple Macbook Pro 13\" Space Grey",
        "width": 3460,
        "height": 2200,
        "top": 136,
        "left": 427
      },
      {
        "image": require("./images/Computers/Apple MacBook Pro/Device/Apple Macbook Pro 15\" Silver.png"),
        "value": "./images/Computers/Apple MacBook Pro/Device/Apple Macbook Pro 15\" Silver.png",
        "label": "Apple Macbook Pro 15\" Silver",
        "width": 3880,
        "height": 2400,
        "top": 180,
        "left": 452
      },
      {
        "image": require("./images/Computers/Apple MacBook Pro/Device/Apple Macbook Pro 15\" Space Grey.png"),
        "value": "./images/Computers/Apple MacBook Pro/Device/Apple Macbook Pro 15\" Space Grey.png",
        "label": "Apple Macbook Pro 15\" Space Grey",
        "width": 3880,
        "height": 2400,
        "top": 180,
        "left": 452
      },
      {
        "image": require("./images/Computers/Apple MacBook Pro/Device with Shadow/Apple Macbook Pro 13\" Silver.png"),
        "value": "./images/Computers/Apple MacBook Pro/Device with Shadow/Apple Macbook Pro 13\" Silver.png",
        "label": "Apple Macbook Pro 13\" Silver with shadow",
        "width": 3460,
        "height": 2200,
        "top": 136,
        "left": 427
      },
      {
        "image": require("./images/Computers/Apple MacBook Pro/Device with Shadow/Apple Macbook Pro 13\" Space Grey.png"),
        "value": "./images/Computers/Apple MacBook Pro/Device with Shadow/Apple Macbook Pro 13\" Space Grey.png",
        "label": "Apple Macbook Pro 13\" Space Grey with shadow",
        "width": 3460,
        "height": 2200,
        "top": 136,
        "left": 427
      },
      {
        "image": require("./images/Computers/Apple MacBook Pro/Device with Shadow/Apple Macbook Pro 15\" Silver.png"),
        "value": "./images/Computers/Apple MacBook Pro/Device with Shadow/Apple Macbook Pro 15\" Silver.png",
        "label": "Apple Macbook Pro 15\" Silver with shadow",
        "width": 3880,
        "height": 2400,
        "top": 180,
        "left": 452
      },
      {
        "image": require("./images/Computers/Apple MacBook Pro/Device with Shadow/Apple Macbook Pro 15\" Space Grey.png"),
        "value": "./images/Computers/Apple MacBook Pro/Device with Shadow/Apple Macbook Pro 15\" Space Grey.png",
        "label": "Apple Macbook Pro 15\" Space Grey with shadow",
        "width": 3880,
        "height": 2400,
        "top": 180,
        "left": 452
      },
      {
        "image": require("./images/Computers/Apple Macbook/Device/Apple-Macbook-Gold.png"),
        "value": "./images/Computers/Apple Macbook/Device/Apple-Macbook-Gold.png",
        "label": "Apple-Macbook-Gold",
        "width": 3064,
        "height": 1799,
        "top": 128,
        "left": 380
      },
      {
        "image": require("./images/Computers/Apple Macbook/Device/Apple-Macbook-Space-Grey.png"),
        "value": "./images/Computers/Apple Macbook/Device/Apple-Macbook-Space-Grey.png",
        "label": "Apple-Macbook-Space-Grey",
        "width": 3064,
        "height": 1799,
        "top": 128,
        "left": 380
      },
      {
        "image": require("./images/Computers/Apple Macbook/Device with Shadow/Apple-Macbook-Gold.png"),
        "value": "./images/Computers/Apple Macbook/Device with Shadow/Apple-Macbook-Gold.png",
        "label": "Apple-Macbook-Gold with shadow",
        "width": 3064,
        "height": 1799,
        "top": 128,
        "left": 380
      },
      {
        "image": require("./images/Computers/Apple Macbook/Device with Shadow/Apple-Macbook-Space-Grey.png"),
        "value": "./images/Computers/Apple Macbook/Device with Shadow/Apple-Macbook-Space-Grey.png",
        "label": "Apple-Macbook-Space-Grey with shadow",
        "width": 3064,
        "height": 1799,
        "top": 128,
        "left": 380
      },
      {
        "image": require("./images/Computers/Apple iMac/Device/Apple iMac.png"),
        "value": "./images/Computers/Apple iMac/Device/Apple iMac.png",
        "label": "Apple iMac",
        "width": 2788,
        "height": 2351
      },
      {
        "image": require("./images/Computers/Apple iMac/Device with shadow/Apple iMac.png"),
        "value": "./images/Computers/Apple iMac/Device with shadow/Apple iMac.png",
        "label": "Apple iMac with shadow",
        "width": 2788,
        "height": 2351
      },
      {
        "image": require("./images/Computers/Apple iMac Pro/Device/Apple iMac Pro.png"),
        "value": "./images/Computers/Apple iMac Pro/Device/Apple iMac Pro.png",
        "label": "Apple iMac Pro",
        "width": 5776,
        "height": 4810
      },
      {
        "image": require("./images/Computers/Apple iMac Pro/Device with Shadow/Apple iMac Pro.png"),
        "value": "./images/Computers/Apple iMac Pro/Device with Shadow/Apple iMac Pro.png",
        "label": "Apple iMac Pro with shadow",
        "width": 5776,
        "height": 4810
      },
      {
        "image": require("./images/Computers/Apple iMac Retina/Device/Apple iMac Retina.png"),
        "value": "./images/Computers/Apple iMac Retina/Device/Apple iMac Retina.png",
        "label": "Apple iMac Retina",
        "width": 5577,
        "height": 4689
      },
      {
        "image": require("./images/Computers/Apple iMac Retina/Device with shadow/Apple iMac Retina.png"),
        "value": "./images/Computers/Apple iMac Retina/Device with shadow/Apple iMac Retina.png",
        "label": "Apple iMac Retina with shadow",
        "width": 5577,
        "height": 4689
      },
      {
        "image": require("./images/Computers/Dell XPS 13/Device/Dell XPS 13\".png"),
        "value": "./images/Computers/Dell XPS 13/Device/Dell XPS 13\".png",
        "label": "Dell XPS 13\"",
        "width": 3834,
        "height": 2256,
        "top": 86,
        "left": 317
      },
      {
        "image": require("./images/Computers/Dell XPS 13/Device with shadow/Dell XPS 13\".png"),
        "value": "./images/Computers/Dell XPS 13/Device with shadow/Dell XPS 13\".png",
        "label": "Dell XPS 13\" with shadow",
        "width": 3834,
        "height": 2256,
        "top": 86,
        "left": 317
      },
      {
        "image": require("./images/Computers/Dell XPS 15/Device/Dell XPS 15\".png"),
        "value": "./images/Computers/Dell XPS 15/Device/Dell XPS 15\".png",
        "label": "Dell XPS 15\"",
        "width": 5194,
        "height": 2768,
        "top": 130,
        "left": 677
      },
      {
        "image": require("./images/Computers/Dell XPS 15/Device with shadow/Dell XPS 15\".png"),
        "value": "./images/Computers/Dell XPS 15/Device with shadow/Dell XPS 15\".png",
        "label": "Dell XPS 15\" with shadow",
        "width": 5194,
        "height": 2768,
        "top": 130,
        "left": 677
      },
      {
        "image": require("./images/Computers/Microsoft Surface Book/Device/Microsoft Surface Book.png"),
        "value": "./images/Computers/Microsoft Surface Book/Device/Microsoft Surface Book.png",
        "label": "Microsoft Surface Book",
        "width": 4143,
        "height": 2456,
        "top": 187,
        "left": 574
      },
      {
        "image": require("./images/Computers/Microsoft Surface Book/Device with shadow/Microsoft Surface Book.png"),
        "value": "./images/Computers/Microsoft Surface Book/Device with shadow/Microsoft Surface Book.png",
        "label": "Microsoft Surface Book with shadow",
        "width": 4143,
        "height": 2456,
        "top": 187,
        "left": 574
      }
    ]
  },
  {
    "value": "Displays",
    "label": "Displays",
    "options": [
      {
        "image": require("./images/Displays/Apple Pro Display XDR/Device/Apple Pro Display XDR.png"),
        "value": "./images/Displays/Apple Pro Display XDR/Device/Apple Pro Display XDR.png",
        "label": "Apple Pro Display XDR",
        "width": 6316,
        "height": 4765,
        "top": 0,
        "left": 0
      },
      {
        "image": require("./images/Displays/Apple Pro Display XDR/Device with Shadow/Apple Pro Display XDR.png"),
        "value": "./images/Displays/Apple Pro Display XDR/Device with Shadow/Apple Pro Display XDR.png",
        "label": "Apple Pro Display XDR with shadow",
        "width": 6316,
        "height": 4765,
        "top": 0,
        "left": 0
      },
      {
        "image": require("./images/Displays/Apple Thunderbolt Display/Device/Apple Thunderbolt Display.png"),
        "value": "./images/Displays/Apple Thunderbolt Display/Device/Apple Thunderbolt Display.png",
        "label": "Apple Thunderbolt Display",
        "width": 2784,
        "height": 2156,
        "top": 129,
        "left": 114
      },
      {
        "image": require("./images/Displays/Apple Thunderbolt Display/Device with shadow/Apple Thunderbolt Display.png"),
        "value": "./images/Displays/Apple Thunderbolt Display/Device with shadow/Apple Thunderbolt Display.png",
        "label": "Apple Thunderbolt Display with shadow",
        "width": 2784,
        "height": 2156,
        "top": 129,
        "left": 114
      },
      {
        "image": require("./images/Displays/Dell UltraSharp HD 5K Monitor/Device/Dell UltraSharp 5K Monitor 27\" 90deg.png"),
        "value": "./images/Displays/Dell UltraSharp HD 5K Monitor/Device/Dell UltraSharp 5K Monitor 27\" 90deg.png",
        "label": "Dell UltraSharp 5K Monitor 27\" 90deg",
        "width": 3442,
        "height": 5936,
        "top": 194,
        "left": 281
      },
      {
        "image": require("./images/Displays/Dell UltraSharp HD 5K Monitor/Device/Dell UltraSharp 5K Monitor 27\".png"),
        "value": "./images/Displays/Dell UltraSharp HD 5K Monitor/Device/Dell UltraSharp 5K Monitor 27\".png",
        "label": "Dell UltraSharp 5K Monitor 27\"",
        "width": 5454,
        "height": 4391,
        "top": 178,
        "left": 167
      },
      {
        "image": require("./images/Displays/Dell UltraSharp HD 5K Monitor/Device with shadow/Dell UltraSharp 5K Monitor 27\" 90deg.png"),
        "value": "./images/Displays/Dell UltraSharp HD 5K Monitor/Device with shadow/Dell UltraSharp 5K Monitor 27\" 90deg.png",
        "label": "Dell UltraSharp 5K Monitor 27\" 90deg with shadow",
        "width": 3442,
        "height": 5936,
        "top": 194,
        "left": 281
      },
      {
        "image": require("./images/Displays/Dell UltraSharp HD 5K Monitor/Device with shadow/Dell UltraSharp 5K Monitor 27\".png"),
        "value": "./images/Displays/Dell UltraSharp HD 5K Monitor/Device with shadow/Dell UltraSharp 5K Monitor 27\".png",
        "label": "Dell UltraSharp 5K Monitor 27\" with shadow",
        "width": 5454,
        "height": 4391,
        "top": 178,
        "left": 167
      },
      {
        "image": require("./images/Displays/Dell UltraSharp Monitor/24\"/Device/Dell UltraSharp 24\" 90deg.png"),
        "value": "./images/Displays/Dell UltraSharp Monitor/24\"/Device/Dell UltraSharp 24\" 90deg.png",
        "label": "Dell UltraSharp 24\" 90deg",
        "width": 1347,
        "height": 2256,
        "top": 44,
        "left": 76
      },
      {
        "image": require("./images/Displays/Dell UltraSharp Monitor/24\"/Device/Dell UltraSharp 24\".png"),
        "value": "./images/Displays/Dell UltraSharp Monitor/24\"/Device/Dell UltraSharp 24\".png",
        "label": "Dell UltraSharp 24\"",
        "width": 1974,
        "height": 1751,
        "top": 27,
        "left": 27
      },
      {
        "image": require("./images/Displays/Dell UltraSharp Monitor/24\"/Device with shadow/Dell UltraSharp 24\" 90deg.png"),
        "value": "./images/Displays/Dell UltraSharp Monitor/24\"/Device with shadow/Dell UltraSharp 24\" 90deg.png",
        "label": "Dell UltraSharp 24\" 90deg with shadow",
        "width": 1347,
        "height": 2256,
        "top": 44,
        "left": 76
      },
      {
        "image": require("./images/Displays/Dell UltraSharp Monitor/24\"/Device with shadow/Dell UltraSharp 24\".png"),
        "value": "./images/Displays/Dell UltraSharp Monitor/24\"/Device with shadow/Dell UltraSharp 24\".png",
        "label": "Dell UltraSharp 24\" with shadow",
        "width": 1974,
        "height": 1782,
        "top": 27,
        "left": 27
      },
      {
        "image": require("./images/Displays/Dell UltraSharp Monitor/27\"/Device/Dell UltraSharp 27\" 90deg.png"),
        "value": "./images/Displays/Dell UltraSharp Monitor/27\"/Device/Dell UltraSharp 27\" 90deg.png",
        "label": "Dell UltraSharp 27\" 90deg",
        "width": 1619,
        "height": 2910,
        "top": 44,
        "left": 89
      },
      {
        "image": require("./images/Displays/Dell UltraSharp Monitor/27\"/Device/Dell UltraSharp 27\".png"),
        "value": "./images/Displays/Dell UltraSharp Monitor/27\"/Device/Dell UltraSharp 27\".png",
        "label": "Dell UltraSharp 27\"",
        "width": 2626,
        "height": 2099,
        "top": 59,
        "left": 33
      },
      {
        "image": require("./images/Displays/Dell UltraSharp Monitor/27\"/Device with shadow/Dell UltraSharp 27\" 90deg.png"),
        "value": "./images/Displays/Dell UltraSharp Monitor/27\"/Device with shadow/Dell UltraSharp 27\" 90deg.png",
        "label": "Dell UltraSharp 27\" 90deg with shadow",
        "width": 1619,
        "height": 2910,
        "top": 44,
        "left": 89
      },
      {
        "image": require("./images/Displays/Dell UltraSharp Monitor/27\"/Device with shadow/Dell UltraSharp 27\".png"),
        "value": "./images/Displays/Dell UltraSharp Monitor/27\"/Device with shadow/Dell UltraSharp 27\".png",
        "label": "Dell UltraSharp 27\" with shadow",
        "width": 2626,
        "height": 2099,
        "top": 59,
        "left": 33
      },
      {
        "image": require("./images/Displays/Sony W850C/Device/Sony W850C.png"),
        "value": "./images/Displays/Sony W850C/Device/Sony W850C.png",
        "label": "Sony W850C",
        "width": 1307,
        "height": 824,
        "top": 22,
        "left": 12
      },
      {
        "image": require("./images/Displays/Sony W850C/Device with shadow/Snony W850C.png"),
        "value": "./images/Displays/Sony W850C/Device with shadow/Snony W850C.png",
        "label": "Sony W850C with shadow",
        "width": 1307,
        "height": 824,
        "top": 22,
        "left": 12
      }
    ]
  },
  {
    "value": "Phones",
    "label": "Phones",
    "options": [
      {
        "image": require("./images/Phones/Apple iPhone 11/Device/Apple iPhone 11 Black.png"),
        "value": "./images/Phones/Apple iPhone 11/Device/Apple iPhone 11 Black.png",
        "label": "Apple iPhone 11 Black",
        "width": 1028,
        "height": 1992,
        "top": 0,
        "left": 0
      },
      {
        "image": require("./images/Phones/Apple iPhone 11/Device/Apple iPhone 11 Green.png"),
        "value": "./images/Phones/Apple iPhone 11/Device/Apple iPhone 11 Green.png",
        "label": "Apple iPhone 11 Green",
        "width": 1028,
        "height": 1992,
        "top": 0,
        "left": 0
      },
      {
        "image": require("./images/Phones/Apple iPhone 11/Device/Apple iPhone 11 Purple.png"),
        "value": "./images/Phones/Apple iPhone 11/Device/Apple iPhone 11 Purple.png",
        "label": "Apple iPhone 11 Purple",
        "width": 1028,
        "height": 1992,
        "top": 0,
        "left": 0
      },
      {
        "image": require("./images/Phones/Apple iPhone 11/Device/Apple iPhone 11 Red.png"),
        "value": "./images/Phones/Apple iPhone 11/Device/Apple iPhone 11 Red.png",
        "label": "Apple iPhone 11 Red",
        "width": 1028,
        "height": 1992,
        "top": 0,
        "left": 0
      },
      {
        "image": require("./images/Phones/Apple iPhone 11/Device/Apple iPhone 11 White.png"),
        "value": "./images/Phones/Apple iPhone 11/Device/Apple iPhone 11 White.png",
        "label": "Apple iPhone 11 White",
        "width": 1028,
        "height": 1992,
        "top": 0,
        "left": 0
      },
      {
        "image": require("./images/Phones/Apple iPhone 11/Device/Apple iPhone 11 Yellow.png"),
        "value": "./images/Phones/Apple iPhone 11/Device/Apple iPhone 11 Yellow.png",
        "label": "Apple iPhone 11 Yellow",
        "width": 1028,
        "height": 1992,
        "top": 0,
        "left": 0
      },
      {
        "image": require("./images/Phones/Apple iPhone 11/Device with Shadow/Apple iPhone 11 Black.png"),
        "value": "./images/Phones/Apple iPhone 11/Device with Shadow/Apple iPhone 11 Black.png",
        "label": "Apple iPhone 11 Black with shadow",
        "width": 1028,
        "height": 1992,
        "top": 0,
        "left": 0
      },
      {
        "image": require("./images/Phones/Apple iPhone 11/Device with Shadow/Apple iPhone 11 Green.png"),
        "value": "./images/Phones/Apple iPhone 11/Device with Shadow/Apple iPhone 11 Green.png",
        "label": "Apple iPhone 11 Green with shadow",
        "width": 1028,
        "height": 1992,
        "top": 0,
        "left": 0
      },
      {
        "image": require("./images/Phones/Apple iPhone 11/Device with Shadow/Apple iPhone 11 Purple.png"),
        "value": "./images/Phones/Apple iPhone 11/Device with Shadow/Apple iPhone 11 Purple.png",
        "label": "Apple iPhone 11 Purple with shadow",
        "width": 1028,
        "height": 1992,
        "top": 0,
        "left": 0
      },
      {
        "image": require("./images/Phones/Apple iPhone 11/Device with Shadow/Apple iPhone 11 Red.png"),
        "value": "./images/Phones/Apple iPhone 11/Device with Shadow/Apple iPhone 11 Red.png",
        "label": "Apple iPhone 11 Red with shadow",
        "width": 1028,
        "height": 1992,
        "top": 0,
        "left": 0
      },
      {
        "image": require("./images/Phones/Apple iPhone 11/Device with Shadow/Apple iPhone 11 White.png"),
        "value": "./images/Phones/Apple iPhone 11/Device with Shadow/Apple iPhone 11 White.png",
        "label": "Apple iPhone 11 White with shadow",
        "width": 1028,
        "height": 1992,
        "top": 0,
        "left": 0
      },
      {
        "image": require("./images/Phones/Apple iPhone 11/Device with Shadow/Apple iPhone 11 Yellow.png"),
        "value": "./images/Phones/Apple iPhone 11/Device with Shadow/Apple iPhone 11 Yellow.png",
        "label": "Apple iPhone 11 Yellow with shadow",
        "width": 1028,
        "height": 1992,
        "top": 0,
        "left": 0
      },
      {
        "image": require("./images/Phones/Apple iPhone 11 Pro/Device/Apple iPhone 11 Pro Gold.png"),
        "value": "./images/Phones/Apple iPhone 11 Pro/Device/Apple iPhone 11 Pro Gold.png",
        "label": "Apple iPhone 11 Pro Gold",
        "width": 1385,
        "height": 2696,
        "top": 0,
        "left": 0
      },
      {
        "image": require("./images/Phones/Apple iPhone 11 Pro/Device/Apple iPhone 11 Pro Midnight Green.png"),
        "value": "./images/Phones/Apple iPhone 11 Pro/Device/Apple iPhone 11 Pro Midnight Green.png",
        "label": "Apple iPhone 11 Pro Midnight Green",
        "width": 1385,
        "height": 2696,
        "top": 0,
        "left": 0
      },
      {
        "image": require("./images/Phones/Apple iPhone 11 Pro/Device/Apple iPhone 11 Pro Silver.png"),
        "value": "./images/Phones/Apple iPhone 11 Pro/Device/Apple iPhone 11 Pro Silver.png",
        "label": "Apple iPhone 11 Pro Silver",
        "width": 1385,
        "height": 2696,
        "top": 0,
        "left": 0
      },
      {
        "image": require("./images/Phones/Apple iPhone 11 Pro/Device/Apple iPhone 11 Pro Space Grey.png"),
        "value": "./images/Phones/Apple iPhone 11 Pro/Device/Apple iPhone 11 Pro Space Grey.png",
        "label": "Apple iPhone 11 Pro Space Grey",
        "width": 1385,
        "height": 2696,
        "top": 0,
        "left": 0
      },
      {
        "image": require("./images/Phones/Apple iPhone 11 Pro/Device with Shadow/Apple iPhone 11 Pro Gold.png"),
        "value": "./images/Phones/Apple iPhone 11 Pro/Device with Shadow/Apple iPhone 11 Pro Gold.png",
        "label": "Apple iPhone 11 Pro Gold with shadow",
        "width": 1385,
        "height": 2696,
        "top": 0,
        "left": 0
      },
      {
        "image": require("./images/Phones/Apple iPhone 11 Pro/Device with Shadow/Apple iPhone 11 Pro Midnight Green.png"),
        "value": "./images/Phones/Apple iPhone 11 Pro/Device with Shadow/Apple iPhone 11 Pro Midnight Green.png",
        "label": "Apple iPhone 11 Pro Midnight Green with shadow",
        "width": 1385,
        "height": 2696,
        "top": 0,
        "left": 0
      },
      {
        "image": require("./images/Phones/Apple iPhone 11 Pro/Device with Shadow/Apple iPhone 11 Pro Silver.png"),
        "value": "./images/Phones/Apple iPhone 11 Pro/Device with Shadow/Apple iPhone 11 Pro Silver.png",
        "label": "Apple iPhone 11 Pro Silver with shadow",
        "width": 1385,
        "height": 2696,
        "top": 0,
        "left": 0
      },
      {
        "image": require("./images/Phones/Apple iPhone 11 Pro/Device with Shadow/Apple iPhone 11 Pro Space Grey.png"),
        "value": "./images/Phones/Apple iPhone 11 Pro/Device with Shadow/Apple iPhone 11 Pro Space Grey.png",
        "label": "Apple iPhone 11 Pro Space Grey with shadow",
        "width": 1385,
        "height": 2696,
        "top": 0,
        "left": 0
      },
      {
        "image": require("./images/Phones/Apple iPhone 11 Pro Max/Device/Apple iPhone 11 Pro Max Gold.png"),
        "value": "./images/Phones/Apple iPhone 11 Pro Max/Device/Apple iPhone 11 Pro Max Gold.png",
        "label": "Apple iPhone 11 Pro Max Gold",
        "width": 1502,
        "height": 2948,
        "top": 0,
        "left": 0
      },
      {
        "image": require("./images/Phones/Apple iPhone 11 Pro Max/Device/Apple iPhone 11 Pro Max Midnight Green.png"),
        "value": "./images/Phones/Apple iPhone 11 Pro Max/Device/Apple iPhone 11 Pro Max Midnight Green.png",
        "label": "Apple iPhone 11 Pro Max Midnight Green",
        "width": 1502,
        "height": 2948,
        "top": 0,
        "left": 0
      },
      {
        "image": require("./images/Phones/Apple iPhone 11 Pro Max/Device/Apple iPhone 11 Pro Max Silver.png"),
        "value": "./images/Phones/Apple iPhone 11 Pro Max/Device/Apple iPhone 11 Pro Max Silver.png",
        "label": "Apple iPhone 11 Pro Max Silver",
        "width": 1502,
        "height": 2948,
        "top": 0,
        "left": 0
      },
      {
        "image": require("./images/Phones/Apple iPhone 11 Pro Max/Device/Apple iPhone 11 Pro Max Space Grey.png"),
        "value": "./images/Phones/Apple iPhone 11 Pro Max/Device/Apple iPhone 11 Pro Max Space Grey.png",
        "label": "Apple iPhone 11 Pro Max Space Grey",
        "width": 1502,
        "height": 2948,
        "top": 0,
        "left": 0
      },
      {
        "image": require("./images/Phones/Apple iPhone 11 Pro Max/Device with Shadow/Apple iPhone 11 Pro Max Gold.png"),
        "value": "./images/Phones/Apple iPhone 11 Pro Max/Device with Shadow/Apple iPhone 11 Pro Max Gold.png",
        "label": "Apple iPhone 11 Pro Max Gold with shadow",
        "width": 1502,
        "height": 2948,
        "top": 0,
        "left": 0
      },
      {
        "image": require("./images/Phones/Apple iPhone 11 Pro Max/Device with Shadow/Apple iPhone 11 Pro Max Midnight Green.png"),
        "value": "./images/Phones/Apple iPhone 11 Pro Max/Device with Shadow/Apple iPhone 11 Pro Max Midnight Green.png",
        "label": "Apple iPhone 11 Pro Max Midnight Green with shadow",
        "width": 1502,
        "height": 2948,
        "top": 0,
        "left": 0
      },
      {
        "image": require("./images/Phones/Apple iPhone 11 Pro Max/Device with Shadow/Apple iPhone 11 Pro Max Silver.png"),
        "value": "./images/Phones/Apple iPhone 11 Pro Max/Device with Shadow/Apple iPhone 11 Pro Max Silver.png",
        "label": "Apple iPhone 11 Pro Max Silver with shadow",
        "width": 1502,
        "height": 2948,
        "top": 0,
        "left": 0
      },
      {
        "image": require("./images/Phones/Apple iPhone 11 Pro Max/Device with Shadow/Apple iPhone 11 Pro Max Space Grey.png"),
        "value": "./images/Phones/Apple iPhone 11 Pro Max/Device with Shadow/Apple iPhone 11 Pro Max Space Grey.png",
        "label": "Apple iPhone 11 Pro Max Space Grey with shadow",
        "width": 1502,
        "height": 2948,
        "top": 0,
        "left": 0
      },
      {
        "image": require("./images/Phones/Apple iPhone 5c/Device/Apple iPhone 5c Blue.png"),
        "value": "./images/Phones/Apple iPhone 5c/Device/Apple iPhone 5c Blue.png",
        "label": "Apple iPhone 5c Blue",
        "width": 767,
        "height": 1605,
        "top": 239,
        "left": 67
      },
      {
        "image": require("./images/Phones/Apple iPhone 5c/Device/Apple iPhone 5c Green.png"),
        "value": "./images/Phones/Apple iPhone 5c/Device/Apple iPhone 5c Green.png",
        "label": "Apple iPhone 5c Green",
        "width": 767,
        "height": 1605,
        "top": 239,
        "left": 67
      },
      {
        "image": require("./images/Phones/Apple iPhone 5c/Device/Apple iPhone 5c Red.png"),
        "value": "./images/Phones/Apple iPhone 5c/Device/Apple iPhone 5c Red.png",
        "label": "Apple iPhone 5c Red",
        "width": 767,
        "height": 1605,
        "top": 239,
        "left": 67
      },
      {
        "image": require("./images/Phones/Apple iPhone 5c/Device/Apple iPhone 5c White.png"),
        "value": "./images/Phones/Apple iPhone 5c/Device/Apple iPhone 5c White.png",
        "label": "Apple iPhone 5c White",
        "width": 767,
        "height": 1605,
        "top": 239,
        "left": 67
      },
      {
        "image": require("./images/Phones/Apple iPhone 5c/Device/Apple iPhone 5c Yellow.png"),
        "value": "./images/Phones/Apple iPhone 5c/Device/Apple iPhone 5c Yellow.png",
        "label": "Apple iPhone 5c Yellow",
        "width": 767,
        "height": 1605,
        "top": 239,
        "left": 67
      },
      {
        "image": require("./images/Phones/Apple iPhone 5c/Device with Shadow/Apple iPhone 5c Blue.png"),
        "value": "./images/Phones/Apple iPhone 5c/Device with Shadow/Apple iPhone 5c Blue.png",
        "label": "Apple iPhone 5c Blue with shadow",
        "width": 767,
        "height": 1631,
        "top": 239,
        "left": 67
      },
      {
        "image": require("./images/Phones/Apple iPhone 5c/Device with Shadow/Apple iPhone 5c Green.png"),
        "value": "./images/Phones/Apple iPhone 5c/Device with Shadow/Apple iPhone 5c Green.png",
        "label": "Apple iPhone 5c Green with shadow",
        "width": 767,
        "height": 1631,
        "top": 239,
        "left": 67
      },
      {
        "image": require("./images/Phones/Apple iPhone 5c/Device with Shadow/Apple iPhone 5c Red.png"),
        "value": "./images/Phones/Apple iPhone 5c/Device with Shadow/Apple iPhone 5c Red.png",
        "label": "Apple iPhone 5c Red with shadow",
        "width": 767,
        "height": 1631,
        "top": 239,
        "left": 67
      },
      {
        "image": require("./images/Phones/Apple iPhone 5c/Device with Shadow/Apple iPhone 5c White.png"),
        "value": "./images/Phones/Apple iPhone 5c/Device with Shadow/Apple iPhone 5c White.png",
        "label": "Apple iPhone 5c White with shadow",
        "width": 767,
        "height": 1631,
        "top": 239,
        "left": 67
      },
      {
        "image": require("./images/Phones/Apple iPhone 5c/Device with Shadow/Apple iPhone 5c Yellow.png"),
        "value": "./images/Phones/Apple iPhone 5c/Device with Shadow/Apple iPhone 5c Yellow.png",
        "label": "Apple iPhone 5c Yellow with shadow",
        "width": 767,
        "height": 1631,
        "top": 239,
        "left": 67
      },
      {
        "image": require("./images/Phones/Apple iPhone 5s/Device/Apple iPhone 5s Gold.png"),
        "value": "./images/Phones/Apple iPhone 5s/Device/Apple iPhone 5s Gold.png",
        "label": "Apple iPhone 5s Gold",
        "width": 760,
        "height": 1597,
        "top": 238,
        "left": 64
      },
      {
        "image": require("./images/Phones/Apple iPhone 5s/Device/Apple iPhone 5s Silver.png"),
        "value": "./images/Phones/Apple iPhone 5s/Device/Apple iPhone 5s Silver.png",
        "label": "Apple iPhone 5s Silver",
        "width": 760,
        "height": 1597,
        "top": 238,
        "left": 64
      },
      {
        "image": require("./images/Phones/Apple iPhone 5s/Device/Apple iPhone 5s Space Gray.png"),
        "value": "./images/Phones/Apple iPhone 5s/Device/Apple iPhone 5s Space Gray.png",
        "label": "Apple iPhone 5s Space Gray",
        "width": 760,
        "height": 1597,
        "top": 238,
        "left": 64
      },
      {
        "image": require("./images/Phones/Apple iPhone 5s/Device with Shadow/Apple iPhone 5s Gold.png"),
        "value": "./images/Phones/Apple iPhone 5s/Device with Shadow/Apple iPhone 5s Gold.png",
        "label": "Apple iPhone 5s Gold with shadow",
        "width": 760,
        "height": 1623,
        "top": 238,
        "left": 64
      },
      {
        "image": require("./images/Phones/Apple iPhone 5s/Device with Shadow/Apple iPhone 5s Silver.png"),
        "value": "./images/Phones/Apple iPhone 5s/Device with Shadow/Apple iPhone 5s Silver.png",
        "label": "Apple iPhone 5s Silver with shadow",
        "width": 760,
        "height": 1623,
        "top": 238,
        "left": 64
      },
      {
        "image": require("./images/Phones/Apple iPhone 5s/Device with Shadow/Apple iPhone 5s Space Gray.png"),
        "value": "./images/Phones/Apple iPhone 5s/Device with Shadow/Apple iPhone 5s Space Gray.png",
        "label": "Apple iPhone 5s Space Gray with shadow",
        "width": 760,
        "height": 1623,
        "top": 238,
        "left": 64
      },
      {
        "image": require("./images/Phones/Apple iPhone 6s/Device/Apple iPhone 6s Gold.png"),
        "value": "./images/Phones/Apple iPhone 6s/Device/Apple iPhone 6s Gold.png",
        "label": "Apple iPhone 6s Gold",
        "width": 990,
        "height": 1934,
        "top": 300,
        "left": 120
      },
      {
        "image": require("./images/Phones/Apple iPhone 6s/Device/Apple iPhone 6s Rose Gold.png"),
        "value": "./images/Phones/Apple iPhone 6s/Device/Apple iPhone 6s Rose Gold.png",
        "label": "Apple iPhone 6s Rose Gold",
        "width": 990,
        "height": 1934,
        "top": 300,
        "left": 120
      },
      {
        "image": require("./images/Phones/Apple iPhone 6s/Device/Apple iPhone 6s Silver.png"),
        "value": "./images/Phones/Apple iPhone 6s/Device/Apple iPhone 6s Silver.png",
        "label": "Apple iPhone 6s Silver",
        "width": 990,
        "height": 1934,
        "top": 300,
        "left": 120
      },
      {
        "image": require("./images/Phones/Apple iPhone 6s/Device/Apple iPhone 6s Space Gray.png"),
        "value": "./images/Phones/Apple iPhone 6s/Device/Apple iPhone 6s Space Gray.png",
        "label": "Apple iPhone 6s Space Gray",
        "width": 990,
        "height": 1934,
        "top": 300,
        "left": 120
      },
      {
        "image": require("./images/Phones/Apple iPhone 6s/Device with Shadow/Apple iPhone 6s Gold.png"),
        "value": "./images/Phones/Apple iPhone 6s/Device with Shadow/Apple iPhone 6s Gold.png",
        "label": "Apple iPhone 6s Gold with shadow",
        "width": 990,
        "height": 1934,
        "top": 300,
        "left": 120
      },
      {
        "image": require("./images/Phones/Apple iPhone 6s/Device with Shadow/Apple iPhone 6s Rose Gold.png"),
        "value": "./images/Phones/Apple iPhone 6s/Device with Shadow/Apple iPhone 6s Rose Gold.png",
        "label": "Apple iPhone 6s Rose Gold with shadow",
        "width": 990,
        "height": 1934,
        "top": 300,
        "left": 120
      },
      {
        "image": require("./images/Phones/Apple iPhone 6s/Device with Shadow/Apple iPhone 6s Silver.png"),
        "value": "./images/Phones/Apple iPhone 6s/Device with Shadow/Apple iPhone 6s Silver.png",
        "label": "Apple iPhone 6s Silver with shadow",
        "width": 990,
        "height": 1934,
        "top": 300,
        "left": 120
      },
      {
        "image": require("./images/Phones/Apple iPhone 6s/Device with Shadow/Apple iPhone 6s Space Gray.png"),
        "value": "./images/Phones/Apple iPhone 6s/Device with Shadow/Apple iPhone 6s Space Gray.png",
        "label": "Apple iPhone 6s Space Gray with shadow",
        "width": 990,
        "height": 1934,
        "top": 300,
        "left": 120
      },
      {
        "image": require("./images/Phones/Apple iPhone 6s Plus/Device/Apple iPhone 6s Plus Gold.png"),
        "value": "./images/Phones/Apple iPhone 6s Plus/Device/Apple iPhone 6s Plus Gold.png",
        "label": "Apple iPhone 6s Plus Gold",
        "width": 1446,
        "height": 2948,
        "top": 300,
        "left": 120
      },
      {
        "image": require("./images/Phones/Apple iPhone 6s Plus/Device/Apple iPhone 6s Plus Rose Gold.png"),
        "value": "./images/Phones/Apple iPhone 6s Plus/Device/Apple iPhone 6s Plus Rose Gold.png",
        "label": "Apple iPhone 6s Plus Rose Gold",
        "width": 1446,
        "height": 2948,
        "top": 300,
        "left": 120
      },
      {
        "image": require("./images/Phones/Apple iPhone 6s Plus/Device/Apple iPhone 6s Plus Silver.png"),
        "value": "./images/Phones/Apple iPhone 6s Plus/Device/Apple iPhone 6s Plus Silver.png",
        "label": "Apple iPhone 6s Plus Silver",
        "width": 1446,
        "height": 2948,
        "top": 300,
        "left": 120
      },
      {
        "image": require("./images/Phones/Apple iPhone 6s Plus/Device/Apple iPhone 6s Plus Space Gray.png"),
        "value": "./images/Phones/Apple iPhone 6s Plus/Device/Apple iPhone 6s Plus Space Gray.png",
        "label": "Apple iPhone 6s Plus Space Gray",
        "width": 1446,
        "height": 2948,
        "top": 300,
        "left": 120
      },
      {
        "image": require("./images/Phones/Apple iPhone 6s Plus/Device with Shadow/Apple iPhone 6s Plus Gold.png"),
        "value": "./images/Phones/Apple iPhone 6s Plus/Device with Shadow/Apple iPhone 6s Plus Gold.png",
        "label": "Apple iPhone 6s Plus Gold with shadow",
        "width": 1446,
        "height": 3001,
        "top": 300,
        "left": 120
      },
      {
        "image": require("./images/Phones/Apple iPhone 6s Plus/Device with Shadow/Apple iPhone 6s Plus Rose Gold.png"),
        "value": "./images/Phones/Apple iPhone 6s Plus/Device with Shadow/Apple iPhone 6s Plus Rose Gold.png",
        "label": "Apple iPhone 6s Plus Rose Gold with shadow",
        "width": 1446,
        "height": 3001,
        "top": 300,
        "left": 120
      },
      {
        "image": require("./images/Phones/Apple iPhone 6s Plus/Device with Shadow/Apple iPhone 6s Plus Silver.png"),
        "value": "./images/Phones/Apple iPhone 6s Plus/Device with Shadow/Apple iPhone 6s Plus Silver.png",
        "label": "Apple iPhone 6s Plus Silver with shadow",
        "width": 1446,
        "height": 3001,
        "top": 300,
        "left": 120
      },
      {
        "image": require("./images/Phones/Apple iPhone 6s Plus/Device with Shadow/Apple iPhone 6s Plus Space Gray.png"),
        "value": "./images/Phones/Apple iPhone 6s Plus/Device with Shadow/Apple iPhone 6s Plus Space Gray.png",
        "label": "Apple iPhone 6s Plus Space Gray with shadow",
        "width": 1446,
        "height": 3001,
        "top": 300,
        "left": 120
      },
      {
        "image": require("./images/Phones/Apple iPhone 7/Device/Apple iPhone 7 Gold.png"),
        "value": "./images/Phones/Apple iPhone 7/Device/Apple iPhone 7 Gold.png",
        "label": "Apple iPhone 7 Gold",
        "width": 990,
        "height": 1934,
        "top": 300,
        "left": 120
      },
      {
        "image": require("./images/Phones/Apple iPhone 7/Device/Apple iPhone 7 Jet Black.png"),
        "value": "./images/Phones/Apple iPhone 7/Device/Apple iPhone 7 Jet Black.png",
        "label": "Apple iPhone 7 Jet Black",
        "width": 990,
        "height": 1934,
        "top": 300,
        "left": 120
      },
      {
        "image": require("./images/Phones/Apple iPhone 7/Device/Apple iPhone 7 Matte Black.png"),
        "value": "./images/Phones/Apple iPhone 7/Device/Apple iPhone 7 Matte Black.png",
        "label": "Apple iPhone 7 Matte Black",
        "width": 990,
        "height": 1934,
        "top": 300,
        "left": 120
      },
      {
        "image": require("./images/Phones/Apple iPhone 7/Device/Apple iPhone 7 Rose Gold.png"),
        "value": "./images/Phones/Apple iPhone 7/Device/Apple iPhone 7 Rose Gold.png",
        "label": "Apple iPhone 7 Rose Gold",
        "width": 990,
        "height": 1934,
        "top": 300,
        "left": 120
      },
      {
        "image": require("./images/Phones/Apple iPhone 7/Device/Apple iPhone 7 Silver.png"),
        "value": "./images/Phones/Apple iPhone 7/Device/Apple iPhone 7 Silver.png",
        "label": "Apple iPhone 7 Silver",
        "width": 990,
        "height": 1934,
        "top": 300,
        "left": 120
      },
      {
        "image": require("./images/Phones/Apple iPhone 7/Device with Shadow/Apple iPhone 7 Gold.png"),
        "value": "./images/Phones/Apple iPhone 7/Device with Shadow/Apple iPhone 7 Gold.png",
        "label": "Apple iPhone 7 Gold with shadow",
        "width": 990,
        "height": 1934,
        "top": 300,
        "left": 120
      },
      {
        "image": require("./images/Phones/Apple iPhone 7/Device with Shadow/Apple iPhone 7 Jet Black.png"),
        "value": "./images/Phones/Apple iPhone 7/Device with Shadow/Apple iPhone 7 Jet Black.png",
        "label": "Apple iPhone 7 Jet Black with shadow",
        "width": 990,
        "height": 1934,
        "top": 300,
        "left": 120
      },
      {
        "image": require("./images/Phones/Apple iPhone 7/Device with Shadow/Apple iPhone 7 Matte Black.png"),
        "value": "./images/Phones/Apple iPhone 7/Device with Shadow/Apple iPhone 7 Matte Black.png",
        "label": "Apple iPhone 7 Matte Black with shadow",
        "width": 990,
        "height": 1934,
        "top": 300,
        "left": 120
      },
      {
        "image": require("./images/Phones/Apple iPhone 7/Device with Shadow/Apple iPhone 7 Rose Gold.png"),
        "value": "./images/Phones/Apple iPhone 7/Device with Shadow/Apple iPhone 7 Rose Gold.png",
        "label": "Apple iPhone 7 Rose Gold with shadow",
        "width": 990,
        "height": 1934,
        "top": 300,
        "left": 120
      },
      {
        "image": require("./images/Phones/Apple iPhone 7/Device with Shadow/Apple iPhone 7 Silver.png"),
        "value": "./images/Phones/Apple iPhone 7/Device with Shadow/Apple iPhone 7 Silver.png",
        "label": "Apple iPhone 7 Silver with shadow",
        "width": 990,
        "height": 1934,
        "top": 300,
        "left": 120
      },
      {
        "image": require("./images/Phones/Apple iPhone 7 Plus/Device/Apple iPhone 7 Plus Gold.png"),
        "value": "./images/Phones/Apple iPhone 7 Plus/Device/Apple iPhone 7 Plus Gold.png",
        "label": "Apple iPhone 7 Plus Gold",
        "width": 1842,
        "height": 3408,
        "top": 300,
        "left": 120
      },
      {
        "image": require("./images/Phones/Apple iPhone 7 Plus/Device/Apple iPhone 7 Plus Jet Black.png"),
        "value": "./images/Phones/Apple iPhone 7 Plus/Device/Apple iPhone 7 Plus Jet Black.png",
        "label": "Apple iPhone 7 Plus Jet Black",
        "width": 1842,
        "height": 3408,
        "top": 300,
        "left": 120
      },
      {
        "image": require("./images/Phones/Apple iPhone 7 Plus/Device/Apple iPhone 7 Plus Matte Black.png"),
        "value": "./images/Phones/Apple iPhone 7 Plus/Device/Apple iPhone 7 Plus Matte Black.png",
        "label": "Apple iPhone 7 Plus Matte Black",
        "width": 1842,
        "height": 3408,
        "top": 300,
        "left": 120
      },
      {
        "image": require("./images/Phones/Apple iPhone 7 Plus/Device/Apple iPhone 7 Plus Rose Gold.png"),
        "value": "./images/Phones/Apple iPhone 7 Plus/Device/Apple iPhone 7 Plus Rose Gold.png",
        "label": "Apple iPhone 7 Plus Rose Gold",
        "width": 1842,
        "height": 3408,
        "top": 300,
        "left": 120
      },
      {
        "image": require("./images/Phones/Apple iPhone 7 Plus/Device/Apple iPhone 7 Plus Silver.png"),
        "value": "./images/Phones/Apple iPhone 7 Plus/Device/Apple iPhone 7 Plus Silver.png",
        "label": "Apple iPhone 7 Plus Silver",
        "width": 1842,
        "height": 3408,
        "top": 300,
        "left": 120
      },
      {
        "image": require("./images/Phones/Apple iPhone 7 Plus/Device with Shadow/Apple iPhone 7 Plus Gold.png"),
        "value": "./images/Phones/Apple iPhone 7 Plus/Device with Shadow/Apple iPhone 7 Plus Gold.png",
        "label": "Apple iPhone 7 Plus Gold with shadow",
        "width": 1842,
        "height": 3408,
        "top": 300,
        "left": 120
      },
      {
        "image": require("./images/Phones/Apple iPhone 7 Plus/Device with Shadow/Apple iPhone 7 Plus Jet Black.png"),
        "value": "./images/Phones/Apple iPhone 7 Plus/Device with Shadow/Apple iPhone 7 Plus Jet Black.png",
        "label": "Apple iPhone 7 Plus Jet Black with shadow",
        "width": 1842,
        "height": 3408,
        "top": 300,
        "left": 120
      },
      {
        "image": require("./images/Phones/Apple iPhone 7 Plus/Device with Shadow/Apple iPhone 7 Plus Matte Black.png"),
        "value": "./images/Phones/Apple iPhone 7 Plus/Device with Shadow/Apple iPhone 7 Plus Matte Black.png",
        "label": "Apple iPhone 7 Plus Matte Black with shadow",
        "width": 1842,
        "height": 3408,
        "top": 300,
        "left": 120
      },
      {
        "image": require("./images/Phones/Apple iPhone 7 Plus/Device with Shadow/Apple iPhone 7 Plus Rose Gold.png"),
        "value": "./images/Phones/Apple iPhone 7 Plus/Device with Shadow/Apple iPhone 7 Plus Rose Gold.png",
        "label": "Apple iPhone 7 Plus Rose Gold with shadow",
        "width": 1842,
        "height": 3408,
        "top": 300,
        "left": 120
      },
      {
        "image": require("./images/Phones/Apple iPhone 7 Plus/Device with Shadow/Apple iPhone 7 Plus Silver.png"),
        "value": "./images/Phones/Apple iPhone 7 Plus/Device with Shadow/Apple iPhone 7 Plus Silver.png",
        "label": "Apple iPhone 7 Plus Silver with shadow",
        "width": 1842,
        "height": 3408,
        "top": 300,
        "left": 120
      },
      {
        "image": require("./images/Phones/Apple iPhone 8/Device/Apple iPhone 8 Gold.png"),
        "value": "./images/Phones/Apple iPhone 8/Device/Apple iPhone 8 Gold.png",
        "label": "Apple iPhone 8 Gold",
        "width": 950,
        "height": 1894,
        "top": 280,
        "left": 100
      },
      {
        "image": require("./images/Phones/Apple iPhone 8/Device/Apple iPhone 8 Silver.png"),
        "value": "./images/Phones/Apple iPhone 8/Device/Apple iPhone 8 Silver.png",
        "label": "Apple iPhone 8 Silver",
        "width": 950,
        "height": 1894,
        "top": 280,
        "left": 100
      },
      {
        "image": require("./images/Phones/Apple iPhone 8/Device/Apple iPhone 8 Space Grey.png"),
        "value": "./images/Phones/Apple iPhone 8/Device/Apple iPhone 8 Space Grey.png",
        "label": "Apple iPhone 8 Space Grey",
        "width": 950,
        "height": 1894,
        "top": 280,
        "left": 100
      },
      {
        "image": require("./images/Phones/Apple iPhone 8/Device with Shadow/Apple iPhone 8 Gold.png"),
        "value": "./images/Phones/Apple iPhone 8/Device with Shadow/Apple iPhone 8 Gold.png",
        "label": "Apple iPhone 8 Gold with shadow",
        "width": 950,
        "height": 1894,
        "top": 280,
        "left": 100
      },
      {
        "image": require("./images/Phones/Apple iPhone 8/Device with Shadow/Apple iPhone 8 Silver.png"),
        "value": "./images/Phones/Apple iPhone 8/Device with Shadow/Apple iPhone 8 Silver.png",
        "label": "Apple iPhone 8 Silver with shadow",
        "width": 950,
        "height": 1894,
        "top": 280,
        "left": 100
      },
      {
        "image": require("./images/Phones/Apple iPhone 8/Device with Shadow/Apple iPhone 8 Space Grey.png"),
        "value": "./images/Phones/Apple iPhone 8/Device with Shadow/Apple iPhone 8 Space Grey.png",
        "label": "Apple iPhone 8 Space Grey with shadow",
        "width": 950,
        "height": 1894,
        "top": 280,
        "left": 100
      },
      {
        "image": require("./images/Phones/Apple iPhone 8 Plus/Device/Apple iPhone 8 Plus Gold.png"),
        "value": "./images/Phones/Apple iPhone 8 Plus/Device/Apple iPhone 8 Plus Gold.png",
        "label": "Apple iPhone 8 Plus Gold",
        "width": 1642,
        "height": 3008,
        "top": 280,
        "left": 100
      },
      {
        "image": require("./images/Phones/Apple iPhone 8 Plus/Device/Apple iPhone 8 Plus Silver.png"),
        "value": "./images/Phones/Apple iPhone 8 Plus/Device/Apple iPhone 8 Plus Silver.png",
        "label": "Apple iPhone 8 Plus Silver",
        "width": 1642,
        "height": 3008,
        "top": 280,
        "left": 100
      },
      {
        "image": require("./images/Phones/Apple iPhone 8 Plus/Device/Apple iPhone 8 Plus Space Grey.png"),
        "value": "./images/Phones/Apple iPhone 8 Plus/Device/Apple iPhone 8 Plus Space Grey.png",
        "label": "Apple iPhone 8 Plus Space Grey",
        "width": 1642,
        "height": 3008,
        "top": 280,
        "left": 100
      },
      {
        "image": require("./images/Phones/Apple iPhone 8 Plus/Device with Shadow/Apple iPhone 8 Plus Gold.png"),
        "value": "./images/Phones/Apple iPhone 8 Plus/Device with Shadow/Apple iPhone 8 Plus Gold.png",
        "label": "Apple iPhone 8 Plus Gold with shadow",
        "width": 1642,
        "height": 3008,
        "top": 280,
        "left": 100
      },
      {
        "image": require("./images/Phones/Apple iPhone 8 Plus/Device with Shadow/Apple iPhone 8 Plus Silver.png"),
        "value": "./images/Phones/Apple iPhone 8 Plus/Device with Shadow/Apple iPhone 8 Plus Silver.png",
        "label": "Apple iPhone 8 Plus Silver with shadow",
        "width": 1642,
        "height": 3008,
        "top": 280,
        "left": 100
      },
      {
        "image": require("./images/Phones/Apple iPhone 8 Plus/Device with Shadow/Apple iPhone 8 Plus Space Grey.png"),
        "value": "./images/Phones/Apple iPhone 8 Plus/Device with Shadow/Apple iPhone 8 Plus Space Grey.png",
        "label": "Apple iPhone 8 Plus Space Grey with shadow",
        "width": 1642,
        "height": 3008,
        "top": 280,
        "left": 100
      },
      {
        "image": require("./images/Phones/Apple iPhone SE/Device/Apple iPhone SE Gold.png"),
        "value": "./images/Phones/Apple iPhone SE/Device/Apple iPhone SE Gold.png",
        "label": "Apple iPhone SE Gold",
        "width": 840,
        "height": 1696,
        "top": 280,
        "left": 100
      },
      {
        "image": require("./images/Phones/Apple iPhone SE/Device/Apple iPhone SE Rose Gold.png"),
        "value": "./images/Phones/Apple iPhone SE/Device/Apple iPhone SE Rose Gold.png",
        "label": "Apple iPhone SE Rose Gold",
        "width": 840,
        "height": 1696,
        "top": 280,
        "left": 100
      },
      {
        "image": require("./images/Phones/Apple iPhone SE/Device/Apple iPhone SE Silver.png"),
        "value": "./images/Phones/Apple iPhone SE/Device/Apple iPhone SE Silver.png",
        "label": "Apple iPhone SE Silver",
        "width": 840,
        "height": 1696,
        "top": 280,
        "left": 100
      },
      {
        "image": require("./images/Phones/Apple iPhone SE/Device/Apple iPhone SE Space Gray.png"),
        "value": "./images/Phones/Apple iPhone SE/Device/Apple iPhone SE Space Gray.png",
        "label": "Apple iPhone SE Space Gray",
        "width": 840,
        "height": 1696,
        "top": 280,
        "left": 100
      },
      {
        "image": require("./images/Phones/Apple iPhone SE/Device with Shadow/Apple iPhone SE Gold.png"),
        "value": "./images/Phones/Apple iPhone SE/Device with Shadow/Apple iPhone SE Gold.png",
        "label": "Apple iPhone SE Gold with shadow",
        "width": 840,
        "height": 1696,
        "top": 280,
        "left": 100
      },
      {
        "image": require("./images/Phones/Apple iPhone SE/Device with Shadow/Apple iPhone SE Rose Gold.png"),
        "value": "./images/Phones/Apple iPhone SE/Device with Shadow/Apple iPhone SE Rose Gold.png",
        "label": "Apple iPhone SE Rose Gold with shadow",
        "width": 840,
        "height": 1696,
        "top": 280,
        "left": 100
      },
      {
        "image": require("./images/Phones/Apple iPhone SE/Device with Shadow/Apple iPhone SE Silver.png"),
        "value": "./images/Phones/Apple iPhone SE/Device with Shadow/Apple iPhone SE Silver.png",
        "label": "Apple iPhone SE Silver with shadow",
        "width": 840,
        "height": 1696,
        "top": 280,
        "left": 100
      },
      {
        "image": require("./images/Phones/Apple iPhone SE/Device with Shadow/Apple iPhone SE Space Gray.png"),
        "value": "./images/Phones/Apple iPhone SE/Device with Shadow/Apple iPhone SE Space Gray.png",
        "label": "Apple iPhone SE Space Gray with shadow",
        "width": 840,
        "height": 1696,
        "top": 280,
        "left": 100
      },
      {
        "image": require("./images/Phones/Apple iPhone X/Device/Apple iPhone X Silver.png"),
        "value": "./images/Phones/Apple iPhone X/Device/Apple iPhone X Silver.png",
        "label": "Apple iPhone X Silver",
        "width": 1405,
        "height": 2796,
        "top": 180,
        "left": 140
      },
      {
        "image": require("./images/Phones/Apple iPhone X/Device/Apple iPhone X Space Grey.png"),
        "value": "./images/Phones/Apple iPhone X/Device/Apple iPhone X Space Grey.png",
        "label": "Apple iPhone X Space Grey",
        "width": 1405,
        "height": 2796,
        "top": 180,
        "left": 140
      },
      {
        "image": require("./images/Phones/Apple iPhone X/Device with Shadow/Apple iPhone X Silver.png"),
        "value": "./images/Phones/Apple iPhone X/Device with Shadow/Apple iPhone X Silver.png",
        "label": "Apple iPhone X Silver with shadow",
        "width": 1407,
        "height": 2796,
        "top": 180,
        "left": 140
      },
      {
        "image": require("./images/Phones/Apple iPhone X/Device with Shadow/Apple iPhone X Space Grey.png"),
        "value": "./images/Phones/Apple iPhone X/Device with Shadow/Apple iPhone X Space Grey.png",
        "label": "Apple iPhone X Space Grey with shadow",
        "width": 1407,
        "height": 2796,
        "top": 180,
        "left": 140
      },
      {
        "image": require("./images/Phones/Apple iPhone XR/Device/Apple iPhone XR Blue.png"),
        "value": "./images/Phones/Apple iPhone XR/Device/Apple iPhone XR Blue.png",
        "label": "Apple iPhone XR Blue",
        "width": 1048,
        "height": 2025,
        "top": 110,
        "left": 110
      },
      {
        "image": require("./images/Phones/Apple iPhone XR/Device/Apple iPhone XR Coral.png"),
        "value": "./images/Phones/Apple iPhone XR/Device/Apple iPhone XR Coral.png",
        "label": "Apple iPhone XR Coral",
        "width": 1048,
        "height": 2025,
        "top": 110,
        "left": 110
      },
      {
        "image": require("./images/Phones/Apple iPhone XR/Device/Apple iPhone XR Red.png"),
        "value": "./images/Phones/Apple iPhone XR/Device/Apple iPhone XR Red.png",
        "label": "Apple iPhone XR Red",
        "width": 1048,
        "height": 2025,
        "top": 110,
        "left": 110
      },
      {
        "image": require("./images/Phones/Apple iPhone XR/Device/Apple iPhone XR Silver.png"),
        "value": "./images/Phones/Apple iPhone XR/Device/Apple iPhone XR Silver.png",
        "label": "Apple iPhone XR Silver",
        "width": 1048,
        "height": 2025,
        "top": 110,
        "left": 110
      },
      {
        "image": require("./images/Phones/Apple iPhone XR/Device/Apple iPhone XR Space Grey.png"),
        "value": "./images/Phones/Apple iPhone XR/Device/Apple iPhone XR Space Grey.png",
        "label": "Apple iPhone XR Space Grey",
        "width": 1048,
        "height": 2025,
        "top": 110,
        "left": 110
      },
      {
        "image": require("./images/Phones/Apple iPhone XR/Device/Apple iPhone XR Yellow.png"),
        "value": "./images/Phones/Apple iPhone XR/Device/Apple iPhone XR Yellow.png",
        "label": "Apple iPhone XR Yellow",
        "width": 1048,
        "height": 2025,
        "top": 110,
        "left": 110
      },
      {
        "image": require("./images/Phones/Apple iPhone XR/Device with Shadow/Apple iPhone XR Blue.png"),
        "value": "./images/Phones/Apple iPhone XR/Device with Shadow/Apple iPhone XR Blue.png",
        "label": "Apple iPhone XR Blue with shadow",
        "width": 1048,
        "height": 2025,
        "top": 110,
        "left": 110
      },
      {
        "image": require("./images/Phones/Apple iPhone XR/Device with Shadow/Apple iPhone XR Coral.png"),
        "value": "./images/Phones/Apple iPhone XR/Device with Shadow/Apple iPhone XR Coral.png",
        "label": "Apple iPhone XR Coral with shadow",
        "width": 1048,
        "height": 2025,
        "top": 110,
        "left": 110
      },
      {
        "image": require("./images/Phones/Apple iPhone XR/Device with Shadow/Apple iPhone XR Red.png"),
        "value": "./images/Phones/Apple iPhone XR/Device with Shadow/Apple iPhone XR Red.png",
        "label": "Apple iPhone XR Red with shadow",
        "width": 1048,
        "height": 2025,
        "top": 110,
        "left": 110
      },
      {
        "image": require("./images/Phones/Apple iPhone XR/Device with Shadow/Apple iPhone XR Silver.png"),
        "value": "./images/Phones/Apple iPhone XR/Device with Shadow/Apple iPhone XR Silver.png",
        "label": "Apple iPhone XR Silver with shadow",
        "width": 1048,
        "height": 2025,
        "top": 110,
        "left": 110
      },
      {
        "image": require("./images/Phones/Apple iPhone XR/Device with Shadow/Apple iPhone XR Space Grey.png"),
        "value": "./images/Phones/Apple iPhone XR/Device with Shadow/Apple iPhone XR Space Grey.png",
        "label": "Apple iPhone XR Space Grey with shadow",
        "width": 1048,
        "height": 2025,
        "top": 110,
        "left": 110
      },
      {
        "image": require("./images/Phones/Apple iPhone XR/Device with Shadow/Apple iPhone XR Yellow.png"),
        "value": "./images/Phones/Apple iPhone XR/Device with Shadow/Apple iPhone XR Yellow.png",
        "label": "Apple iPhone XR Yellow with shadow",
        "width": 1048,
        "height": 2025,
        "top": 110,
        "left": 110
      },
      {
        "image": require("./images/Phones/Apple iPhone XS/Device/Apple iPhone XS Gold.png"),
        "value": "./images/Phones/Apple iPhone XS/Device/Apple iPhone XS Gold.png",
        "label": "Apple iPhone XS Gold",
        "width": 1385,
        "height": 2676,
        "top": 120,
        "left": 130
      },
      {
        "image": require("./images/Phones/Apple iPhone XS/Device/Apple iPhone XS Silver.png"),
        "value": "./images/Phones/Apple iPhone XS/Device/Apple iPhone XS Silver.png",
        "label": "Apple iPhone XS Silver",
        "width": 1385,
        "height": 2676,
        "top": 120,
        "left": 130
      },
      {
        "image": require("./images/Phones/Apple iPhone XS/Device/Apple iPhone XS Space Grey.png"),
        "value": "./images/Phones/Apple iPhone XS/Device/Apple iPhone XS Space Grey.png",
        "label": "Apple iPhone XS Space Grey",
        "width": 1385,
        "height": 2676,
        "top": 120,
        "left": 130
      },
      {
        "image": require("./images/Phones/Apple iPhone XS/Device with Shadow/Apple iPhone XS Gold.png"),
        "value": "./images/Phones/Apple iPhone XS/Device with Shadow/Apple iPhone XS Gold.png",
        "label": "Apple iPhone XS Gold with shadow",
        "width": 1385,
        "height": 2676,
        "top": 120,
        "left": 130
      },
      {
        "image": require("./images/Phones/Apple iPhone XS/Device with Shadow/Apple iPhone XS Silver.png"),
        "value": "./images/Phones/Apple iPhone XS/Device with Shadow/Apple iPhone XS Silver.png",
        "label": "Apple iPhone XS Silver with shadow",
        "width": 1385,
        "height": 2676,
        "top": 120,
        "left": 130
      },
      {
        "image": require("./images/Phones/Apple iPhone XS/Device with Shadow/Apple iPhone XS Space Grey.png"),
        "value": "./images/Phones/Apple iPhone XS/Device with Shadow/Apple iPhone XS Space Grey.png",
        "label": "Apple iPhone XS Space Grey with shadow",
        "width": 1385,
        "height": 2676,
        "top": 120,
        "left": 130
      },
      {
        "image": require("./images/Phones/Apple iPhone XS Max/Device/Apple iPhone XS Max Gold.png"),
        "value": "./images/Phones/Apple iPhone XS Max/Device/Apple iPhone XS Max Gold.png",
        "label": "Apple iPhone XS Max Gold",
        "width": 1522,
        "height": 2968,
        "top": 138,
        "left": 140
      },
      {
        "image": require("./images/Phones/Apple iPhone XS Max/Device/Apple iPhone XS Max Silver.png"),
        "value": "./images/Phones/Apple iPhone XS Max/Device/Apple iPhone XS Max Silver.png",
        "label": "Apple iPhone XS Max Silver",
        "width": 1522,
        "height": 2968,
        "top": 138,
        "left": 140
      },
      {
        "image": require("./images/Phones/Apple iPhone XS Max/Device/Apple iPhone XS Max Space Grey.png"),
        "value": "./images/Phones/Apple iPhone XS Max/Device/Apple iPhone XS Max Space Grey.png",
        "label": "Apple iPhone XS Max Space Grey",
        "width": 1522,
        "height": 2968,
        "top": 138,
        "left": 140
      },
      {
        "image": require("./images/Phones/Apple iPhone XS Max/Device with Shadow/Apple iPhone XS Max Gold.png"),
        "value": "./images/Phones/Apple iPhone XS Max/Device with Shadow/Apple iPhone XS Max Gold.png",
        "label": "Apple iPhone XS Max Gold with shadow",
        "width": 1522,
        "height": 2968,
        "top": 138,
        "left": 140
      },
      {
        "image": require("./images/Phones/Apple iPhone XS Max/Device with Shadow/Apple iPhone XS Max Silver.png"),
        "value": "./images/Phones/Apple iPhone XS Max/Device with Shadow/Apple iPhone XS Max Silver.png",
        "label": "Apple iPhone XS Max Silver with shadow",
        "width": 1522,
        "height": 2968,
        "top": 138,
        "left": 140
      },
      {
        "image": require("./images/Phones/Apple iPhone XS Max/Device with Shadow/Apple iPhone XS Max Space Grey.png"),
        "value": "./images/Phones/Apple iPhone XS Max/Device with Shadow/Apple iPhone XS Max Space Grey.png",
        "label": "Apple iPhone XS Max Space Grey with shadow",
        "width": 1522,
        "height": 2968,
        "top": 138,
        "left": 140
      },
      {
        "image": require("./images/Phones/Google Pixel 3/Device/Google Pixel 3 - Clearly White.png"),
        "value": "./images/Phones/Google Pixel 3/Device/Google Pixel 3 - Clearly White.png",
        "label": "Google Pixel 3 - Clearly White",
        "width": 1280,
        "height": 2640,
        "top": 240,
        "left": 100
      },
      {
        "image": require("./images/Phones/Google Pixel 3/Device/Google Pixel 3 - Just Black.png"),
        "value": "./images/Phones/Google Pixel 3/Device/Google Pixel 3 - Just Black.png",
        "label": "Google Pixel 3 - Just Black",
        "width": 1280,
        "height": 2640,
        "top": 240,
        "left": 100
      },
      {
        "image": require("./images/Phones/Google Pixel 3/Device/Google Pixel 3 - Not Pink.png"),
        "value": "./images/Phones/Google Pixel 3/Device/Google Pixel 3 - Not Pink.png",
        "label": "Google Pixel 3 - Not Pink",
        "width": 1280,
        "height": 2640,
        "top": 240,
        "left": 100
      },
      {
        "image": require("./images/Phones/Google Pixel 3/Device with Shadow/Google Pixel 3 - Clearly White.png"),
        "value": "./images/Phones/Google Pixel 3/Device with Shadow/Google Pixel 3 - Clearly White.png",
        "label": "Google Pixel 3 - Clearly White with shadow",
        "width": 1280,
        "height": 2640,
        "top": 240,
        "left": 100
      },
      {
        "image": require("./images/Phones/Google Pixel 3/Device with Shadow/Google Pixel 3 - Just Black.png"),
        "value": "./images/Phones/Google Pixel 3/Device with Shadow/Google Pixel 3 - Just Black.png",
        "label": "Google Pixel 3 - Just Black with shadow",
        "width": 1280,
        "height": 2640,
        "top": 240,
        "left": 100
      },
      {
        "image": require("./images/Phones/Google Pixel 3/Device with Shadow/Google Pixel 3 - Not Pink.png"),
        "value": "./images/Phones/Google Pixel 3/Device with Shadow/Google Pixel 3 - Not Pink.png",
        "label": "Google Pixel 3 - Not Pink with shadow",
        "width": 1280,
        "height": 2640,
        "top": 240,
        "left": 100
      },
      {
        "image": require("./images/Phones/Google Pixel 3 XL/Device/Google Pixel 3 XL - Clearly White.png"),
        "value": "./images/Phones/Google Pixel 3 XL/Device/Google Pixel 3 XL - Clearly White.png",
        "label": "Google Pixel 3 XL - Clearly White",
        "width": 1740,
        "height": 3409,
        "top": 150,
        "left": 150
      },
      {
        "image": require("./images/Phones/Google Pixel 3 XL/Device/Google Pixel 3 XL - Just Black.png"),
        "value": "./images/Phones/Google Pixel 3 XL/Device/Google Pixel 3 XL - Just Black.png",
        "label": "Google Pixel 3 XL - Just Black",
        "width": 1740,
        "height": 3409,
        "top": 150,
        "left": 150
      },
      {
        "image": require("./images/Phones/Google Pixel 3 XL/Device/Google Pixel 3 XL - Not Pink.png"),
        "value": "./images/Phones/Google Pixel 3 XL/Device/Google Pixel 3 XL - Not Pink.png",
        "label": "Google Pixel 3 XL - Not Pink",
        "width": 1740,
        "height": 3409,
        "top": 150,
        "left": 150
      },
      {
        "image": require("./images/Phones/Google Pixel 3 XL/Device with Shadow/Google Pixel 3 XL - Clearly White.png"),
        "value": "./images/Phones/Google Pixel 3 XL/Device with Shadow/Google Pixel 3 XL - Clearly White.png",
        "label": "Google Pixel 3 XL - Clearly White with shadow",
        "width": 1740,
        "height": 3409,
        "top": 150,
        "left": 150
      },
      {
        "image": require("./images/Phones/Google Pixel 3 XL/Device with Shadow/Google Pixel 3 XL - Just Black.png"),
        "value": "./images/Phones/Google Pixel 3 XL/Device with Shadow/Google Pixel 3 XL - Just Black.png",
        "label": "Google Pixel 3 XL - Just Black with shadow",
        "width": 1740,
        "height": 3409,
        "top": 150,
        "left": 150
      },
      {
        "image": require("./images/Phones/Google Pixel 3 XL/Device with Shadow/Google Pixel 3 XL - Not Pink.png"),
        "value": "./images/Phones/Google Pixel 3 XL/Device with Shadow/Google Pixel 3 XL - Not Pink.png",
        "label": "Google Pixel 3 XL - Not Pink with shadow",
        "width": 1740,
        "height": 3409,
        "top": 150,
        "left": 150
      },
      {
        "image": require("./images/Phones/Google Pixel 4/Device/Google Pixel 4 Clearly White.png"),
        "value": "./images/Phones/Google Pixel 4/Device/Google Pixel 4 Clearly White.png",
        "label": "Google Pixel 4 Clearly White",
        "width": 1280,
        "height": 2680,
        "top": 0,
        "left": 0
      },
      {
        "image": require("./images/Phones/Google Pixel 4/Device/Google Pixel 4 Just Black.png"),
        "value": "./images/Phones/Google Pixel 4/Device/Google Pixel 4 Just Black.png",
        "label": "Google Pixel 4 Just Black",
        "width": 1280,
        "height": 2680,
        "top": 0,
        "left": 0
      },
      {
        "image": require("./images/Phones/Google Pixel 4/Device/Google Pixel 4 Oh So Orange.png"),
        "value": "./images/Phones/Google Pixel 4/Device/Google Pixel 4 Oh So Orange.png",
        "label": "Google Pixel 4 Oh So Orange",
        "width": 1280,
        "height": 2680,
        "top": 0,
        "left": 0
      },
      {
        "image": require("./images/Phones/Google Pixel 4/Device with Shadow/Google Pixel 4 Clearly White.png"),
        "value": "./images/Phones/Google Pixel 4/Device with Shadow/Google Pixel 4 Clearly White.png",
        "label": "Google Pixel 4 Clearly White with shadow",
        "width": 1280,
        "height": 2680,
        "top": 0,
        "left": 0
      },
      {
        "image": require("./images/Phones/Google Pixel 4/Device with Shadow/Google Pixel 4 Just Black.png"),
        "value": "./images/Phones/Google Pixel 4/Device with Shadow/Google Pixel 4 Just Black.png",
        "label": "Google Pixel 4 Just Black with shadow",
        "width": 1280,
        "height": 2680,
        "top": 0,
        "left": 0
      },
      {
        "image": require("./images/Phones/Google Pixel 4/Device with Shadow/Google Pixel 4 Oh So Orange.png"),
        "value": "./images/Phones/Google Pixel 4/Device with Shadow/Google Pixel 4 Oh So Orange.png",
        "label": "Google Pixel 4 Oh So Orange with shadow",
        "width": 1280,
        "height": 2680,
        "top": 0,
        "left": 0
      },
      {
        "image": require("./images/Phones/Google Pixel 4 XL/Device/Google Pixel 4 XL Clearly White.png"),
        "value": "./images/Phones/Google Pixel 4 XL/Device/Google Pixel 4 XL Clearly White.png",
        "label": "Google Pixel 4 XL Clearly White",
        "width": 1640,
        "height": 3540,
        "top": 0,
        "left": 0
      },
      {
        "image": require("./images/Phones/Google Pixel 4 XL/Device/Google Pixel 4 XL Just Black.png"),
        "value": "./images/Phones/Google Pixel 4 XL/Device/Google Pixel 4 XL Just Black.png",
        "label": "Google Pixel 4 XL Just Black",
        "width": 1640,
        "height": 3540,
        "top": 0,
        "left": 0
      },
      {
        "image": require("./images/Phones/Google Pixel 4 XL/Device/Google Pixel 4 XL Oh So Orange.png"),
        "value": "./images/Phones/Google Pixel 4 XL/Device/Google Pixel 4 XL Oh So Orange.png",
        "label": "Google Pixel 4 XL Oh So Orange",
        "width": 1640,
        "height": 3540,
        "top": 0,
        "left": 0
      },
      {
        "image": require("./images/Phones/Google Pixel 4 XL/Device with Shadow/Google Pixel 4 XL Clearly White.png"),
        "value": "./images/Phones/Google Pixel 4 XL/Device with Shadow/Google Pixel 4 XL Clearly White.png",
        "label": "Google Pixel 4 XL Clearly White with shadow",
        "width": 1640,
        "height": 3540,
        "top": 0,
        "left": 0
      },
      {
        "image": require("./images/Phones/Google Pixel 4 XL/Device with Shadow/Google Pixel 4 XL Just Black.png"),
        "value": "./images/Phones/Google Pixel 4 XL/Device with Shadow/Google Pixel 4 XL Just Black.png",
        "label": "Google Pixel 4 XL Just Black with shadow",
        "width": 1640,
        "height": 3540,
        "top": 0,
        "left": 0
      },
      {
        "image": require("./images/Phones/Google Pixel 4 XL/Device with Shadow/Google Pixel 4 XL Oh So Orange.png"),
        "value": "./images/Phones/Google Pixel 4 XL/Device with Shadow/Google Pixel 4 XL Oh So Orange.png",
        "label": "Google Pixel 4 XL Oh So Orange with shadow",
        "width": 1640,
        "height": 3540,
        "top": 0,
        "left": 0
      },
      {
        "image": require("./images/Phones/HTC One A9/Device/HTC One A9 Black.png"),
        "value": "./images/Phones/HTC One A9/Device/HTC One A9 Black.png",
        "label": "HTC One A9 Black",
        "width": 1246,
        "height": 2549,
        "top": 293,
        "left": 85
      },
      {
        "image": require("./images/Phones/HTC One A9/Device/HTC One A9 White.png"),
        "value": "./images/Phones/HTC One A9/Device/HTC One A9 White.png",
        "label": "HTC One A9 White",
        "width": 1246,
        "height": 2549,
        "top": 293,
        "left": 85
      },
      {
        "image": require("./images/Phones/HTC One A9/Device with Shadow/HTC One A9 Black.png"),
        "value": "./images/Phones/HTC One A9/Device with Shadow/HTC One A9 Black.png",
        "label": "HTC One A9 Black with shadow",
        "width": 1251,
        "height": 2597,
        "top": 293,
        "left": 85
      },
      {
        "image": require("./images/Phones/HTC One A9/Device with Shadow/HTC One A9 White.png"),
        "value": "./images/Phones/HTC One A9/Device with Shadow/HTC One A9 White.png",
        "label": "HTC One A9 White with shadow",
        "width": 1251,
        "height": 2597,
        "top": 293,
        "left": 85
      },
      {
        "image": require("./images/Phones/HTC One M8/Device/HTC One M8 Black.png"),
        "value": "./images/Phones/HTC One M8/Device/HTC One M8 Black.png",
        "label": "HTC One M8 Black",
        "width": 1228,
        "height": 2513,
        "top": 267,
        "left": 72
      },
      {
        "image": require("./images/Phones/HTC One M8/Device/HTC One M8 Gold.png"),
        "value": "./images/Phones/HTC One M8/Device/HTC One M8 Gold.png",
        "label": "HTC One M8 Gold",
        "width": 1228,
        "height": 2513,
        "top": 267,
        "left": 72
      },
      {
        "image": require("./images/Phones/HTC One M8/Device/HTC One M8 Silver.png"),
        "value": "./images/Phones/HTC One M8/Device/HTC One M8 Silver.png",
        "label": "HTC One M8 Silver",
        "width": 1228,
        "height": 2513,
        "top": 267,
        "left": 72
      },
      {
        "image": require("./images/Phones/HTC One M8/Device with Shadow/HTC One M8 Black.png"),
        "value": "./images/Phones/HTC One M8/Device with Shadow/HTC One M8 Black.png",
        "label": "HTC One M8 Black with shadow",
        "width": 1228,
        "height": 2559,
        "top": 267,
        "left": 72
      },
      {
        "image": require("./images/Phones/HTC One M8/Device with Shadow/HTC One M8 Gold.png"),
        "value": "./images/Phones/HTC One M8/Device with Shadow/HTC One M8 Gold.png",
        "label": "HTC One M8 Gold with shadow",
        "width": 1228,
        "height": 2559,
        "top": 267,
        "left": 72
      },
      {
        "image": require("./images/Phones/HTC One M8/Device with Shadow/HTC One M8 Silver.png"),
        "value": "./images/Phones/HTC One M8/Device with Shadow/HTC One M8 Silver.png",
        "label": "HTC One M8 Silver with shadow",
        "width": 1228,
        "height": 2559,
        "top": 267,
        "left": 72
      },
      {
        "image": require("./images/Phones/Huawei P8/Device/Huawei P8 Black.png"),
        "value": "./images/Phones/Huawei P8/Device/Huawei P8 Black.png",
        "label": "Huawei P8 Black",
        "width": 1280,
        "height": 2560,
        "top": 320,
        "left": 100
      },
      {
        "image": require("./images/Phones/Huawei P8/Device/Huawei P8 White.png"),
        "value": "./images/Phones/Huawei P8/Device/Huawei P8 White.png",
        "label": "Huawei P8 White",
        "width": 1280,
        "height": 2560,
        "top": 320,
        "left": 100
      },
      {
        "image": require("./images/Phones/Huawei P8/Device with Shadow/Huawei P8 Black.png"),
        "value": "./images/Phones/Huawei P8/Device with Shadow/Huawei P8 Black.png",
        "label": "Huawei P8 Black with shadow",
        "width": 1280,
        "height": 2560,
        "top": 320,
        "left": 100
      },
      {
        "image": require("./images/Phones/Huawei P8/Device with Shadow/Huawei P8 White.png"),
        "value": "./images/Phones/Huawei P8/Device with Shadow/Huawei P8 White.png",
        "label": "Huawei P8 White with shadow",
        "width": 1280,
        "height": 2560,
        "top": 320,
        "left": 100
      },
      {
        "image": require("./images/Phones/Microsoft Lumia 950/Device/Microsoft Lumia 950 Black.png"),
        "value": "./images/Phones/Microsoft Lumia 950/Device/Microsoft Lumia 950 Black.png",
        "label": "Microsoft Lumia 950 Black",
        "width": 1642,
        "height": 3215,
        "top": 366,
        "left": 93
      },
      {
        "image": require("./images/Phones/Microsoft Lumia 950/Device/Microsoft Lumia 950 White.png"),
        "value": "./images/Phones/Microsoft Lumia 950/Device/Microsoft Lumia 950 White.png",
        "label": "Microsoft Lumia 950 White",
        "width": 1642,
        "height": 3215,
        "top": 366,
        "left": 93
      },
      {
        "image": require("./images/Phones/Microsoft Lumia 950/Device with Shadow/Microsoft Lumia 950 Black.png"),
        "value": "./images/Phones/Microsoft Lumia 950/Device with Shadow/Microsoft Lumia 950 Black.png",
        "label": "Microsoft Lumia 950 Black with shadow",
        "width": 1643,
        "height": 3272,
        "top": 366,
        "left": 93
      },
      {
        "image": require("./images/Phones/Microsoft Lumia 950/Device with Shadow/Microsoft Lumia 950 White.png"),
        "value": "./images/Phones/Microsoft Lumia 950/Device with Shadow/Microsoft Lumia 950 White.png",
        "label": "Microsoft Lumia 950 White with shadow",
        "width": 1643,
        "height": 3272,
        "top": 366,
        "left": 93
      },
      {
        "image": require("./images/Phones/Motorola Moto E/Device/Motorola Moto E Black.png"),
        "value": "./images/Phones/Motorola Moto E/Device/Motorola Moto E Black.png",
        "label": "Motorola Moto E Black",
        "width": 658,
        "height": 1265,
        "top": 185,
        "left": 55
      },
      {
        "image": require("./images/Phones/Motorola Moto E/Device/Motorola Moto E White.png"),
        "value": "./images/Phones/Motorola Moto E/Device/Motorola Moto E White.png",
        "label": "Motorola Moto E White",
        "width": 658,
        "height": 1265,
        "top": 185,
        "left": 55
      },
      {
        "image": require("./images/Phones/Motorola Moto E/Device with Shadow/Motorola Moto E Black.png"),
        "value": "./images/Phones/Motorola Moto E/Device with Shadow/Motorola Moto E Black.png",
        "label": "Motorola Moto E Black with shadow",
        "width": 658,
        "height": 1290,
        "top": 185,
        "left": 55
      },
      {
        "image": require("./images/Phones/Motorola Moto E/Device with Shadow/Motorola Moto E White.png"),
        "value": "./images/Phones/Motorola Moto E/Device with Shadow/Motorola Moto E White.png",
        "label": "Motorola Moto E White with shadow",
        "width": 658,
        "height": 1290,
        "top": 185,
        "left": 55
      },
      {
        "image": require("./images/Phones/Motorola Moto G/Device/Motorola Moto G.png"),
        "value": "./images/Phones/Motorola Moto G/Device/Motorola Moto G.png",
        "label": "Motorola Moto G",
        "width": 920,
        "height": 1780,
        "top": 250,
        "left": 100
      },
      {
        "image": require("./images/Phones/Motorola Moto G/Device with Shadow/Motorola Moto G.png"),
        "value": "./images/Phones/Motorola Moto G/Device with Shadow/Motorola Moto G.png",
        "label": "Motorola Moto G with shadow",
        "width": 920,
        "height": 1780,
        "top": 250,
        "left": 100
      },
      {
        "image": require("./images/Phones/Nexus 4/Device/Nexus 4.png"),
        "value": "./images/Phones/Nexus 4/Device/Nexus 4.png",
        "label": "Nexus 4",
        "width": 855,
        "height": 1658,
        "top": 185,
        "left": 41
      },
      {
        "image": require("./images/Phones/Nexus 4/Device with Shadow/Nexus 4.png"),
        "value": "./images/Phones/Nexus 4/Device with Shadow/Nexus 4.png",
        "label": "Nexus 4 with shadow",
        "width": 855,
        "height": 1685,
        "top": 185,
        "left": 41
      },
      {
        "image": require("./images/Phones/Nexus 5X/Device/Nexus 5x.png"),
        "value": "./images/Phones/Nexus 5X/Device/Nexus 5x.png",
        "label": "Nexus 5x",
        "width": 1195,
        "height": 2406,
        "top": 231,
        "left": 53
      },
      {
        "image": require("./images/Phones/Nexus 5X/Device with Shadow/Nexus 5x.png"),
        "value": "./images/Phones/Nexus 5X/Device with Shadow/Nexus 5x.png",
        "label": "Nexus 5x with shadow",
        "width": 1195,
        "height": 2455,
        "top": 231,
        "left": 53
      },
      {
        "image": require("./images/Phones/Nexus 6P/Device/Nexus 6P.png"),
        "value": "./images/Phones/Nexus 6P/Device/Nexus 6P.png",
        "label": "Nexus 6P",
        "width": 1566,
        "height": 3198,
        "top": 329,
        "left": 59
      },
      {
        "image": require("./images/Phones/Nexus 6P/Device with Shadow/Nexus 6P.png"),
        "value": "./images/Phones/Nexus 6P/Device with Shadow/Nexus 6P.png",
        "label": "Nexus 6P with shadow",
        "width": 1566,
        "height": 3260,
        "top": 329,
        "left": 59
      },
      {
        "image": require("./images/Phones/Nokia 220/Device/Nokia 220 Black.png"),
        "value": "./images/Phones/Nokia 220/Device/Nokia 220 Black.png",
        "label": "Nokia 220 Black",
        "width": 320,
        "height": 741,
        "top": 96,
        "left": 40
      },
      {
        "image": require("./images/Phones/Nokia 220/Device/Nokia 220 Blue.png"),
        "value": "./images/Phones/Nokia 220/Device/Nokia 220 Blue.png",
        "label": "Nokia 220 Blue",
        "width": 320,
        "height": 741,
        "top": 96,
        "left": 40
      },
      {
        "image": require("./images/Phones/Nokia 220/Device/Nokia 220 Red.png"),
        "value": "./images/Phones/Nokia 220/Device/Nokia 220 Red.png",
        "label": "Nokia 220 Red",
        "width": 320,
        "height": 741,
        "top": 96,
        "left": 40
      },
      {
        "image": require("./images/Phones/Nokia 220/Device/Nokia 220 White.png"),
        "value": "./images/Phones/Nokia 220/Device/Nokia 220 White.png",
        "label": "Nokia 220 White",
        "width": 320,
        "height": 741,
        "top": 96,
        "left": 40
      },
      {
        "image": require("./images/Phones/Nokia 220/Device/Nokia 220 Yellow.png"),
        "value": "./images/Phones/Nokia 220/Device/Nokia 220 Yellow.png",
        "label": "Nokia 220 Yellow",
        "width": 320,
        "height": 741,
        "top": 96,
        "left": 40
      },
      {
        "image": require("./images/Phones/Nokia 220/Device with Shadow/Nokia 220 Black.png"),
        "value": "./images/Phones/Nokia 220/Device with Shadow/Nokia 220 Black.png",
        "label": "Nokia 220 Black with shadow",
        "width": 320,
        "height": 752,
        "top": 96,
        "left": 40
      },
      {
        "image": require("./images/Phones/Nokia 220/Device with Shadow/Nokia 220 Blue.png"),
        "value": "./images/Phones/Nokia 220/Device with Shadow/Nokia 220 Blue.png",
        "label": "Nokia 220 Blue with shadow",
        "width": 320,
        "height": 752,
        "top": 96,
        "left": 40
      },
      {
        "image": require("./images/Phones/Nokia 220/Device with Shadow/Nokia 220 Red.png"),
        "value": "./images/Phones/Nokia 220/Device with Shadow/Nokia 220 Red.png",
        "label": "Nokia 220 Red with shadow",
        "width": 320,
        "height": 752,
        "top": 96,
        "left": 40
      },
      {
        "image": require("./images/Phones/Nokia 220/Device with Shadow/Nokia 220 White.png"),
        "value": "./images/Phones/Nokia 220/Device with Shadow/Nokia 220 White.png",
        "label": "Nokia 220 White with shadow",
        "width": 320,
        "height": 752,
        "top": 96,
        "left": 40
      },
      {
        "image": require("./images/Phones/Nokia 220/Device with Shadow/Nokia 220 Yellow.png"),
        "value": "./images/Phones/Nokia 220/Device with Shadow/Nokia 220 Yellow.png",
        "label": "Nokia 220 Yellow with shadow",
        "width": 320,
        "height": 752,
        "top": 96,
        "left": 40
      },
      {
        "image": require("./images/Phones/Nokia 230/Device/Nokia 230 Black.png"),
        "value": "./images/Phones/Nokia 230/Device/Nokia 230 Black.png",
        "label": "Nokia 230 Black",
        "width": 296,
        "height": 695,
        "top": 67,
        "left": 28
      },
      {
        "image": require("./images/Phones/Nokia 230/Device/Nokia 230 White.png"),
        "value": "./images/Phones/Nokia 230/Device/Nokia 230 White.png",
        "label": "Nokia 230 White",
        "width": 296,
        "height": 695,
        "top": 67,
        "left": 28
      },
      {
        "image": require("./images/Phones/Nokia 230/Device with Shadow/Nokia 230 Black.png"),
        "value": "./images/Phones/Nokia 230/Device with Shadow/Nokia 230 Black.png",
        "label": "Nokia 230 Black with shadow",
        "width": 296,
        "height": 705,
        "top": 67,
        "left": 28
      },
      {
        "image": require("./images/Phones/Nokia 230/Device with Shadow/Nokia 230 White.png"),
        "value": "./images/Phones/Nokia 230/Device with Shadow/Nokia 230 White.png",
        "label": "Nokia 230 White with shadow",
        "width": 296,
        "height": 705,
        "top": 67,
        "left": 28
      },
      {
        "image": require("./images/Phones/Nokia Asha 230/Device/Nokia Asha 230 Black.png"),
        "value": "./images/Phones/Nokia Asha 230/Device/Nokia Asha 230 Black.png",
        "label": "Nokia Asha 230 Black",
        "width": 321,
        "height": 539,
        "top": 101,
        "left": 39
      },
      {
        "image": require("./images/Phones/Nokia Asha 230/Device/Nokia Asha 230 Blue.png"),
        "value": "./images/Phones/Nokia Asha 230/Device/Nokia Asha 230 Blue.png",
        "label": "Nokia Asha 230 Blue",
        "width": 321,
        "height": 539,
        "top": 101,
        "left": 39
      },
      {
        "image": require("./images/Phones/Nokia Asha 230/Device/Nokia Asha 230 Green.png"),
        "value": "./images/Phones/Nokia Asha 230/Device/Nokia Asha 230 Green.png",
        "label": "Nokia Asha 230 Green",
        "width": 321,
        "height": 539,
        "top": 101,
        "left": 39
      },
      {
        "image": require("./images/Phones/Nokia Asha 230/Device/Nokia Asha 230 Red.png"),
        "value": "./images/Phones/Nokia Asha 230/Device/Nokia Asha 230 Red.png",
        "label": "Nokia Asha 230 Red",
        "width": 321,
        "height": 539,
        "top": 101,
        "left": 39
      },
      {
        "image": require("./images/Phones/Nokia Asha 230/Device/Nokia Asha 230 White.png"),
        "value": "./images/Phones/Nokia Asha 230/Device/Nokia Asha 230 White.png",
        "label": "Nokia Asha 230 White",
        "width": 321,
        "height": 539,
        "top": 101,
        "left": 39
      },
      {
        "image": require("./images/Phones/Nokia Asha 230/Device/Nokia Asha 230 Yellow.png"),
        "value": "./images/Phones/Nokia Asha 230/Device/Nokia Asha 230 Yellow.png",
        "label": "Nokia Asha 230 Yellow",
        "width": 321,
        "height": 539,
        "top": 101,
        "left": 39
      },
      {
        "image": require("./images/Phones/Nokia Asha 230/Device with Shadow/Nokia Asha 230 230 White.png"),
        "value": "./images/Phones/Nokia Asha 230/Device with Shadow/Nokia Asha 230 230 White.png",
        "label": "Nokia Asha 230 230 White with shadow",
        "width": 321,
        "height": 551,
        "top": 101,
        "left": 39
      },
      {
        "image": require("./images/Phones/Nokia Asha 230/Device with Shadow/Nokia Asha 230 Black.png"),
        "value": "./images/Phones/Nokia Asha 230/Device with Shadow/Nokia Asha 230 Black.png",
        "label": "Nokia Asha 230 Black with shadow",
        "width": 321,
        "height": 551,
        "top": 101,
        "left": 39
      },
      {
        "image": require("./images/Phones/Nokia Asha 230/Device with Shadow/Nokia Asha 230 Blue.png"),
        "value": "./images/Phones/Nokia Asha 230/Device with Shadow/Nokia Asha 230 Blue.png",
        "label": "Nokia Asha 230 Blue with shadow",
        "width": 321,
        "height": 551,
        "top": 101,
        "left": 39
      },
      {
        "image": require("./images/Phones/Nokia Asha 230/Device with Shadow/Nokia Asha 230 Green.png"),
        "value": "./images/Phones/Nokia Asha 230/Device with Shadow/Nokia Asha 230 Green.png",
        "label": "Nokia Asha 230 Green with shadow",
        "width": 321,
        "height": 551,
        "top": 101,
        "left": 39
      },
      {
        "image": require("./images/Phones/Nokia Asha 230/Device with Shadow/Nokia Asha 230 Red.png"),
        "value": "./images/Phones/Nokia Asha 230/Device with Shadow/Nokia Asha 230 Red.png",
        "label": "Nokia Asha 230 Red with shadow",
        "width": 321,
        "height": 551,
        "top": 101,
        "left": 39
      },
      {
        "image": require("./images/Phones/Nokia Asha 230/Device with Shadow/Nokia Asha 230 Yellow.png"),
        "value": "./images/Phones/Nokia Asha 230/Device with Shadow/Nokia Asha 230 Yellow.png",
        "label": "Nokia Asha 230 Yellow with shadow",
        "width": 321,
        "height": 551,
        "top": 101,
        "left": 39
      },
      {
        "image": require("./images/Phones/Nokia C3-00/Device/Nokia C3-00.png"),
        "value": "./images/Phones/Nokia C3-00/Device/Nokia C3-00.png",
        "label": "Nokia C3-00",
        "width": 380,
        "height": 751,
        "top": 106,
        "left": 30
      },
      {
        "image": require("./images/Phones/Nokia C3-00/Device with Shadow/Nokia C3-00.png"),
        "value": "./images/Phones/Nokia C3-00/Device with Shadow/Nokia C3-00.png",
        "label": "Nokia C3-00 with shadow",
        "width": 380,
        "height": 763,
        "top": 106,
        "left": 30
      },
      {
        "image": require("./images/Phones/Samsung Galaxy Grand Prime/Device/Samsung Galaxy Grand Prime Black.png"),
        "value": "./images/Phones/Samsung Galaxy Grand Prime/Device/Samsung Galaxy Grand Prime Black.png",
        "label": "Samsung Galaxy Grand Prime Black",
        "width": 700,
        "height": 1360,
        "top": 200,
        "left": 80
      },
      {
        "image": require("./images/Phones/Samsung Galaxy Grand Prime/Device/Samsung Galaxy Grand Prime Gold.png"),
        "value": "./images/Phones/Samsung Galaxy Grand Prime/Device/Samsung Galaxy Grand Prime Gold.png",
        "label": "Samsung Galaxy Grand Prime Gold",
        "width": 700,
        "height": 1360,
        "top": 200,
        "left": 80
      },
      {
        "image": require("./images/Phones/Samsung Galaxy Grand Prime/Device/Samsung Galaxy Grand Prime White.png"),
        "value": "./images/Phones/Samsung Galaxy Grand Prime/Device/Samsung Galaxy Grand Prime White.png",
        "label": "Samsung Galaxy Grand Prime White",
        "width": 700,
        "height": 1360,
        "top": 200,
        "left": 80
      },
      {
        "image": require("./images/Phones/Samsung Galaxy Grand Prime/Device with Shadow/Samsung Galaxy Grand Prime Black.png"),
        "value": "./images/Phones/Samsung Galaxy Grand Prime/Device with Shadow/Samsung Galaxy Grand Prime Black.png",
        "label": "Samsung Galaxy Grand Prime Black with shadow",
        "width": 700,
        "height": 1360,
        "top": 200,
        "left": 80
      },
      {
        "image": require("./images/Phones/Samsung Galaxy Grand Prime/Device with Shadow/Samsung Galaxy Grand Prime Gold.png"),
        "value": "./images/Phones/Samsung Galaxy Grand Prime/Device with Shadow/Samsung Galaxy Grand Prime Gold.png",
        "label": "Samsung Galaxy Grand Prime Gold with shadow",
        "width": 700,
        "height": 1360,
        "top": 200,
        "left": 80
      },
      {
        "image": require("./images/Phones/Samsung Galaxy Grand Prime/Device with Shadow/Samsung Galaxy Grand Prime White.png"),
        "value": "./images/Phones/Samsung Galaxy Grand Prime/Device with Shadow/Samsung Galaxy Grand Prime White.png",
        "label": "Samsung Galaxy Grand Prime White with shadow",
        "width": 700,
        "height": 1360,
        "top": 200,
        "left": 80
      },
      {
        "image": require("./images/Phones/Samsung Galaxy Note 5/Device/Samsung Galaxy Note 5 Black.png"),
        "value": "./images/Phones/Samsung Galaxy Note 5/Device/Samsung Galaxy Note 5 Black.png",
        "label": "Samsung Galaxy Note 5 Black",
        "width": 1568,
        "height": 3117,
        "top": 290,
        "left": 66
      },
      {
        "image": require("./images/Phones/Samsung Galaxy Note 5/Device/Samsung Galaxy Note 5 Gold.png"),
        "value": "./images/Phones/Samsung Galaxy Note 5/Device/Samsung Galaxy Note 5 Gold.png",
        "label": "Samsung Galaxy Note 5 Gold",
        "width": 1568,
        "height": 3117,
        "top": 290,
        "left": 66
      },
      {
        "image": require("./images/Phones/Samsung Galaxy Note 5/Device/Samsung Galaxy Note 5 Pink.png"),
        "value": "./images/Phones/Samsung Galaxy Note 5/Device/Samsung Galaxy Note 5 Pink.png",
        "label": "Samsung Galaxy Note 5 Pink",
        "width": 1568,
        "height": 3117,
        "top": 290,
        "left": 66
      },
      {
        "image": require("./images/Phones/Samsung Galaxy Note 5/Device/Samsung Galaxy Note 5 Silver Titanium.png"),
        "value": "./images/Phones/Samsung Galaxy Note 5/Device/Samsung Galaxy Note 5 Silver Titanium.png",
        "label": "Samsung Galaxy Note 5 Silver Titanium",
        "width": 1568,
        "height": 3117,
        "top": 290,
        "left": 66
      },
      {
        "image": require("./images/Phones/Samsung Galaxy Note 5/Device/Samsung Galaxy Note 5 White.png"),
        "value": "./images/Phones/Samsung Galaxy Note 5/Device/Samsung Galaxy Note 5 White.png",
        "label": "Samsung Galaxy Note 5 White",
        "width": 1568,
        "height": 3117,
        "top": 290,
        "left": 66
      },
      {
        "image": require("./images/Phones/Samsung Galaxy Note 5/Device with Shadow/Samsung Galaxy Note 5 Black.png"),
        "value": "./images/Phones/Samsung Galaxy Note 5/Device with Shadow/Samsung Galaxy Note 5 Black.png",
        "label": "Samsung Galaxy Note 5 Black with shadow",
        "width": 1580,
        "height": 3170,
        "top": 290,
        "left": 66
      },
      {
        "image": require("./images/Phones/Samsung Galaxy Note 5/Device with Shadow/Samsung Galaxy Note 5 Gold.png"),
        "value": "./images/Phones/Samsung Galaxy Note 5/Device with Shadow/Samsung Galaxy Note 5 Gold.png",
        "label": "Samsung Galaxy Note 5 Gold with shadow",
        "width": 1580,
        "height": 3170,
        "top": 290,
        "left": 66
      },
      {
        "image": require("./images/Phones/Samsung Galaxy Note 5/Device with Shadow/Samsung Galaxy Note 5 Pink.png"),
        "value": "./images/Phones/Samsung Galaxy Note 5/Device with Shadow/Samsung Galaxy Note 5 Pink.png",
        "label": "Samsung Galaxy Note 5 Pink with shadow",
        "width": 1580,
        "height": 3170,
        "top": 290,
        "left": 66
      },
      {
        "image": require("./images/Phones/Samsung Galaxy Note 5/Device with Shadow/Samsung Galaxy Note 5 Silver Titanium.png"),
        "value": "./images/Phones/Samsung Galaxy Note 5/Device with Shadow/Samsung Galaxy Note 5 Silver Titanium.png",
        "label": "Samsung Galaxy Note 5 Silver Titanium with shadow",
        "width": 1580,
        "height": 3170,
        "top": 290,
        "left": 66
      },
      {
        "image": require("./images/Phones/Samsung Galaxy Note 5/Device with Shadow/Samsung Galaxy Note 5 White.png"),
        "value": "./images/Phones/Samsung Galaxy Note 5/Device with Shadow/Samsung Galaxy Note 5 White.png",
        "label": "Samsung Galaxy Note 5 White with shadow",
        "width": 1580,
        "height": 3170,
        "top": 290,
        "left": 66
      },
      {
        "image": require("./images/Phones/Samsung Galaxy Note10/Device/Samsung Galaxy Note10 Aura Black.png"),
        "value": "./images/Phones/Samsung Galaxy Note10/Device/Samsung Galaxy Note10 Aura Black.png",
        "label": "Samsung Galaxy Note10 Aura Black",
        "width": 1280,
        "height": 2480,
        "top": 0,
        "left": 0
      },
      {
        "image": require("./images/Phones/Samsung Galaxy Note10/Device/Samsung Galaxy Note10 Aura Glow.png"),
        "value": "./images/Phones/Samsung Galaxy Note10/Device/Samsung Galaxy Note10 Aura Glow.png",
        "label": "Samsung Galaxy Note10 Aura Glow",
        "width": 1280,
        "height": 2480,
        "top": 0,
        "left": 0
      },
      {
        "image": require("./images/Phones/Samsung Galaxy Note10/Device/Samsung Galaxy Note10 Aura Pink.png"),
        "value": "./images/Phones/Samsung Galaxy Note10/Device/Samsung Galaxy Note10 Aura Pink.png",
        "label": "Samsung Galaxy Note10 Aura Pink",
        "width": 1280,
        "height": 2480,
        "top": 0,
        "left": 0
      },
      {
        "image": require("./images/Phones/Samsung Galaxy Note10/Device/Samsung Galaxy Note10 Aura Red.png"),
        "value": "./images/Phones/Samsung Galaxy Note10/Device/Samsung Galaxy Note10 Aura Red.png",
        "label": "Samsung Galaxy Note10 Aura Red",
        "width": 1280,
        "height": 2480,
        "top": 0,
        "left": 0
      },
      {
        "image": require("./images/Phones/Samsung Galaxy Note10/Device/Samsung Galaxy Note10 Aura White.png"),
        "value": "./images/Phones/Samsung Galaxy Note10/Device/Samsung Galaxy Note10 Aura White.png",
        "label": "Samsung Galaxy Note10 Aura White",
        "width": 1280,
        "height": 2480,
        "top": 0,
        "left": 0
      },
      {
        "image": require("./images/Phones/Samsung Galaxy Note10/Device with Shadow/Samsung Galaxy Note10 Aura Black.png"),
        "value": "./images/Phones/Samsung Galaxy Note10/Device with Shadow/Samsung Galaxy Note10 Aura Black.png",
        "label": "Samsung Galaxy Note10 Aura Black with shadow",
        "width": 1280,
        "height": 2480,
        "top": 0,
        "left": 0
      },
      {
        "image": require("./images/Phones/Samsung Galaxy Note10/Device with Shadow/Samsung Galaxy Note10 Aura Glow.png"),
        "value": "./images/Phones/Samsung Galaxy Note10/Device with Shadow/Samsung Galaxy Note10 Aura Glow.png",
        "label": "Samsung Galaxy Note10 Aura Glow with shadow",
        "width": 1280,
        "height": 2480,
        "top": 0,
        "left": 0
      },
      {
        "image": require("./images/Phones/Samsung Galaxy Note10/Device with Shadow/Samsung Galaxy Note10 Aura Pink.png"),
        "value": "./images/Phones/Samsung Galaxy Note10/Device with Shadow/Samsung Galaxy Note10 Aura Pink.png",
        "label": "Samsung Galaxy Note10 Aura Pink with shadow",
        "width": 1280,
        "height": 2480,
        "top": 0,
        "left": 0
      },
      {
        "image": require("./images/Phones/Samsung Galaxy Note10/Device with Shadow/Samsung Galaxy Note10 Aura Red.png"),
        "value": "./images/Phones/Samsung Galaxy Note10/Device with Shadow/Samsung Galaxy Note10 Aura Red.png",
        "label": "Samsung Galaxy Note10 Aura Red with shadow",
        "width": 1280,
        "height": 2480,
        "top": 0,
        "left": 0
      },
      {
        "image": require("./images/Phones/Samsung Galaxy Note10/Device with Shadow/Samsung Galaxy Note10 Aura White.png"),
        "value": "./images/Phones/Samsung Galaxy Note10/Device with Shadow/Samsung Galaxy Note10 Aura White.png",
        "label": "Samsung Galaxy Note10 Aura White with shadow",
        "width": 1280,
        "height": 2480,
        "top": 0,
        "left": 0
      },
      {
        "image": require("./images/Phones/Samsung Galaxy Note10+/Device/Samsung Galaxy Note10+ Aura Black.png"),
        "value": "./images/Phones/Samsung Galaxy Note10+/Device/Samsung Galaxy Note10+ Aura Black.png",
        "label": "Samsung Galaxy Note10+ Aura Black",
        "width": 1640,
        "height": 3240,
        "top": 0,
        "left": 0
      },
      {
        "image": require("./images/Phones/Samsung Galaxy Note10+/Device/Samsung Galaxy Note10+ Aura Blue.png"),
        "value": "./images/Phones/Samsung Galaxy Note10+/Device/Samsung Galaxy Note10+ Aura Blue.png",
        "label": "Samsung Galaxy Note10+ Aura Blue",
        "width": 1640,
        "height": 3240,
        "top": 0,
        "left": 0
      },
      {
        "image": require("./images/Phones/Samsung Galaxy Note10+/Device/Samsung Galaxy Note10+ Aura Glow.png"),
        "value": "./images/Phones/Samsung Galaxy Note10+/Device/Samsung Galaxy Note10+ Aura Glow.png",
        "label": "Samsung Galaxy Note10+ Aura Glow",
        "width": 1640,
        "height": 3240,
        "top": 0,
        "left": 0
      },
      {
        "image": require("./images/Phones/Samsung Galaxy Note10+/Device/Samsung Galaxy Note10+ Aura White.png"),
        "value": "./images/Phones/Samsung Galaxy Note10+/Device/Samsung Galaxy Note10+ Aura White.png",
        "label": "Samsung Galaxy Note10+ Aura White",
        "width": 1640,
        "height": 3240,
        "top": 0,
        "left": 0
      },
      {
        "image": require("./images/Phones/Samsung Galaxy Note10+/Device with Shadow/Samsung Galaxy Note10+ Aura Black.png"),
        "value": "./images/Phones/Samsung Galaxy Note10+/Device with Shadow/Samsung Galaxy Note10+ Aura Black.png",
        "label": "Samsung Galaxy Note10+ Aura Black with shadow",
        "width": 1640,
        "height": 3240,
        "top": 0,
        "left": 0
      },
      {
        "image": require("./images/Phones/Samsung Galaxy Note10+/Device with Shadow/Samsung Galaxy Note10+ Aura Blue.png"),
        "value": "./images/Phones/Samsung Galaxy Note10+/Device with Shadow/Samsung Galaxy Note10+ Aura Blue.png",
        "label": "Samsung Galaxy Note10+ Aura Blue with shadow",
        "width": 1640,
        "height": 3240,
        "top": 0,
        "left": 0
      },
      {
        "image": require("./images/Phones/Samsung Galaxy Note10+/Device with Shadow/Samsung Galaxy Note10+ Aura Glow.png"),
        "value": "./images/Phones/Samsung Galaxy Note10+/Device with Shadow/Samsung Galaxy Note10+ Aura Glow.png",
        "label": "Samsung Galaxy Note10+ Aura Glow with shadow",
        "width": 1640,
        "height": 3240,
        "top": 0,
        "left": 0
      },
      {
        "image": require("./images/Phones/Samsung Galaxy Note10+/Device with Shadow/Samsung Galaxy Note10+ Aura White.png"),
        "value": "./images/Phones/Samsung Galaxy Note10+/Device with Shadow/Samsung Galaxy Note10+ Aura White.png",
        "label": "Samsung Galaxy Note10+ Aura White with shadow",
        "width": 1640,
        "height": 3240,
        "top": 0,
        "left": 0
      },
      {
        "image": require("./images/Phones/Samsung Galaxy S Duos/Device/Samsung Galaxy S Duos.png"),
        "value": "./images/Phones/Samsung Galaxy S Duos/Device/Samsung Galaxy S Duos.png",
        "label": "Samsung Galaxy S Duos",
        "width": 574,
        "height": 1100,
        "top": 156,
        "left": 48
      },
      {
        "image": require("./images/Phones/Samsung Galaxy S Duos/Device with Shadow/Samsung Galaxy S Duos.png"),
        "value": "./images/Phones/Samsung Galaxy S Duos/Device with Shadow/Samsung Galaxy S Duos.png",
        "label": "Samsung Galaxy S Duos with shadow",
        "width": 574,
        "height": 1116,
        "top": 156,
        "left": 48
      },
      {
        "image": require("./images/Phones/Samsung Galaxy S10/Device/Samsung Galaxy S10 Flamingo Pink.png"),
        "value": "./images/Phones/Samsung Galaxy S10/Device/Samsung Galaxy S10 Flamingo Pink.png",
        "label": "Samsung Galaxy S10 Flamingo Pink",
        "width": 1640,
        "height": 3340,
        "top": 0,
        "left": 0
      },
      {
        "image": require("./images/Phones/Samsung Galaxy S10/Device/Samsung Galaxy S10 Prism Black.png"),
        "value": "./images/Phones/Samsung Galaxy S10/Device/Samsung Galaxy S10 Prism Black.png",
        "label": "Samsung Galaxy S10 Prism Black",
        "width": 1640,
        "height": 3340,
        "top": 0,
        "left": 0
      },
      {
        "image": require("./images/Phones/Samsung Galaxy S10/Device/Samsung Galaxy S10 Prism Blue.png"),
        "value": "./images/Phones/Samsung Galaxy S10/Device/Samsung Galaxy S10 Prism Blue.png",
        "label": "Samsung Galaxy S10 Prism Blue",
        "width": 1640,
        "height": 3340,
        "top": 0,
        "left": 0
      },
      {
        "image": require("./images/Phones/Samsung Galaxy S10/Device/Samsung Galaxy S10 Prism Green.png"),
        "value": "./images/Phones/Samsung Galaxy S10/Device/Samsung Galaxy S10 Prism Green.png",
        "label": "Samsung Galaxy S10 Prism Green",
        "width": 1640,
        "height": 3340,
        "top": 0,
        "left": 0
      },
      {
        "image": require("./images/Phones/Samsung Galaxy S10/Device/Samsung Galaxy S10 Prism White.png"),
        "value": "./images/Phones/Samsung Galaxy S10/Device/Samsung Galaxy S10 Prism White.png",
        "label": "Samsung Galaxy S10 Prism White",
        "width": 1640,
        "height": 3340,
        "top": 0,
        "left": 0
      },
      {
        "image": require("./images/Phones/Samsung Galaxy S10/Device with Shadow/Samsung Galaxy S10 Flamingo Pink.png"),
        "value": "./images/Phones/Samsung Galaxy S10/Device with Shadow/Samsung Galaxy S10 Flamingo Pink.png",
        "label": "Samsung Galaxy S10 Flamingo Pink with shadow",
        "width": 1640,
        "height": 3340,
        "top": 0,
        "left": 0
      },
      {
        "image": require("./images/Phones/Samsung Galaxy S10/Device with Shadow/Samsung Galaxy S10 Prism Black.png"),
        "value": "./images/Phones/Samsung Galaxy S10/Device with Shadow/Samsung Galaxy S10 Prism Black.png",
        "label": "Samsung Galaxy S10 Prism Black with shadow",
        "width": 1640,
        "height": 3340,
        "top": 0,
        "left": 0
      },
      {
        "image": require("./images/Phones/Samsung Galaxy S10/Device with Shadow/Samsung Galaxy S10 Prism Blue.png"),
        "value": "./images/Phones/Samsung Galaxy S10/Device with Shadow/Samsung Galaxy S10 Prism Blue.png",
        "label": "Samsung Galaxy S10 Prism Blue with shadow",
        "width": 1640,
        "height": 3340,
        "top": 0,
        "left": 0
      },
      {
        "image": require("./images/Phones/Samsung Galaxy S10/Device with Shadow/Samsung Galaxy S10 Prism Green.png"),
        "value": "./images/Phones/Samsung Galaxy S10/Device with Shadow/Samsung Galaxy S10 Prism Green.png",
        "label": "Samsung Galaxy S10 Prism Green with shadow",
        "width": 1640,
        "height": 3340,
        "top": 0,
        "left": 0
      },
      {
        "image": require("./images/Phones/Samsung Galaxy S10/Device with Shadow/Samsung Galaxy S10 Prism White.png"),
        "value": "./images/Phones/Samsung Galaxy S10/Device with Shadow/Samsung Galaxy S10 Prism White.png",
        "label": "Samsung Galaxy S10 Prism White with shadow",
        "width": 1640,
        "height": 3340,
        "top": 0,
        "left": 0
      },
      {
        "image": require("./images/Phones/Samsung Galaxy S10+/Device/Samsung Galaxy S10+ Ceramic White.png"),
        "value": "./images/Phones/Samsung Galaxy S10+/Device/Samsung Galaxy S10+ Ceramic White.png",
        "label": "Samsung Galaxy S10+ Ceramic White",
        "width": 1640,
        "height": 3340,
        "top": 0,
        "left": 0
      },
      {
        "image": require("./images/Phones/Samsung Galaxy S10+/Device/Samsung Galaxy S10+ Flamingo Pink.png"),
        "value": "./images/Phones/Samsung Galaxy S10+/Device/Samsung Galaxy S10+ Flamingo Pink.png",
        "label": "Samsung Galaxy S10+ Flamingo Pink",
        "width": 1640,
        "height": 3340,
        "top": 0,
        "left": 0
      },
      {
        "image": require("./images/Phones/Samsung Galaxy S10+/Device/Samsung Galaxy S10+ Prism Black.png"),
        "value": "./images/Phones/Samsung Galaxy S10+/Device/Samsung Galaxy S10+ Prism Black.png",
        "label": "Samsung Galaxy S10+ Prism Black",
        "width": 1640,
        "height": 3340,
        "top": 0,
        "left": 0
      },
      {
        "image": require("./images/Phones/Samsung Galaxy S10+/Device/Samsung Galaxy S10+ Prism Blue.png"),
        "value": "./images/Phones/Samsung Galaxy S10+/Device/Samsung Galaxy S10+ Prism Blue.png",
        "label": "Samsung Galaxy S10+ Prism Blue",
        "width": 1640,
        "height": 3340,
        "top": 0,
        "left": 0
      },
      {
        "image": require("./images/Phones/Samsung Galaxy S10+/Device/Samsung Galaxy S10+ Prism Green.png"),
        "value": "./images/Phones/Samsung Galaxy S10+/Device/Samsung Galaxy S10+ Prism Green.png",
        "label": "Samsung Galaxy S10+ Prism Green",
        "width": 1640,
        "height": 3340,
        "top": 0,
        "left": 0
      },
      {
        "image": require("./images/Phones/Samsung Galaxy S10+/Device/Samsung Galaxy S10+ Prism White.png"),
        "value": "./images/Phones/Samsung Galaxy S10+/Device/Samsung Galaxy S10+ Prism White.png",
        "label": "Samsung Galaxy S10+ Prism White",
        "width": 1640,
        "height": 3340,
        "top": 0,
        "left": 0
      },
      {
        "image": require("./images/Phones/Samsung Galaxy S10+/Device with Shadow/Samsung Galaxy S10+ Ceramic White.png"),
        "value": "./images/Phones/Samsung Galaxy S10+/Device with Shadow/Samsung Galaxy S10+ Ceramic White.png",
        "label": "Samsung Galaxy S10+ Ceramic White with shadow",
        "width": 1640,
        "height": 3340,
        "top": 0,
        "left": 0
      },
      {
        "image": require("./images/Phones/Samsung Galaxy S10+/Device with Shadow/Samsung Galaxy S10+ Flamingo Pink.png"),
        "value": "./images/Phones/Samsung Galaxy S10+/Device with Shadow/Samsung Galaxy S10+ Flamingo Pink.png",
        "label": "Samsung Galaxy S10+ Flamingo Pink with shadow",
        "width": 1640,
        "height": 3340,
        "top": 0,
        "left": 0
      },
      {
        "image": require("./images/Phones/Samsung Galaxy S10+/Device with Shadow/Samsung Galaxy S10+ Prism Black.png"),
        "value": "./images/Phones/Samsung Galaxy S10+/Device with Shadow/Samsung Galaxy S10+ Prism Black.png",
        "label": "Samsung Galaxy S10+ Prism Black with shadow",
        "width": 1640,
        "height": 3340,
        "top": 0,
        "left": 0
      },
      {
        "image": require("./images/Phones/Samsung Galaxy S10+/Device with Shadow/Samsung Galaxy S10+ Prism Blue.png"),
        "value": "./images/Phones/Samsung Galaxy S10+/Device with Shadow/Samsung Galaxy S10+ Prism Blue.png",
        "label": "Samsung Galaxy S10+ Prism Blue with shadow",
        "width": 1640,
        "height": 3340,
        "top": 0,
        "left": 0
      },
      {
        "image": require("./images/Phones/Samsung Galaxy S10+/Device with Shadow/Samsung Galaxy S10+ Prism Green.png"),
        "value": "./images/Phones/Samsung Galaxy S10+/Device with Shadow/Samsung Galaxy S10+ Prism Green.png",
        "label": "Samsung Galaxy S10+ Prism Green with shadow",
        "width": 1640,
        "height": 3340,
        "top": 0,
        "left": 0
      },
      {
        "image": require("./images/Phones/Samsung Galaxy S10+/Device with Shadow/Samsung Galaxy S10+ Prism White.png"),
        "value": "./images/Phones/Samsung Galaxy S10+/Device with Shadow/Samsung Galaxy S10+ Prism White.png",
        "label": "Samsung Galaxy S10+ Prism White with shadow",
        "width": 1640,
        "height": 3340,
        "top": 0,
        "left": 0
      },
      {
        "image": require("./images/Phones/Samsung Galaxy S3/Device/Samsung Galaxy S3.png"),
        "value": "./images/Phones/Samsung Galaxy S3/Device/Samsung Galaxy S3.png",
        "label": "Samsung Galaxy S3",
        "width": 920,
        "height": 1680,
        "top": 200,
        "left": 100
      },
      {
        "image": require("./images/Phones/Samsung Galaxy S3/Device with Shadow/Samsung Galaxy S3.png"),
        "value": "./images/Phones/Samsung Galaxy S3/Device with Shadow/Samsung Galaxy S3.png",
        "label": "Samsung Galaxy S3 with shadow",
        "width": 920,
        "height": 1680,
        "top": 200,
        "left": 100
      },
      {
        "image": require("./images/Phones/Samsung Galaxy S5/Device/Samsung Galaxy S5 Black.png"),
        "value": "./images/Phones/Samsung Galaxy S5/Device/Samsung Galaxy S5 Black.png",
        "label": "Samsung Galaxy S5 Black",
        "width": 1320,
        "height": 2518,
        "top": 300,
        "left": 120
      },
      {
        "image": require("./images/Phones/Samsung Galaxy S5/Device/Samsung Galaxy S5 White.png"),
        "value": "./images/Phones/Samsung Galaxy S5/Device/Samsung Galaxy S5 White.png",
        "label": "Samsung Galaxy S5 White",
        "width": 1320,
        "height": 2518,
        "top": 300,
        "left": 120
      },
      {
        "image": require("./images/Phones/Samsung Galaxy S5/Device with Shadow/Samsung Galaxy S5 Black.png"),
        "value": "./images/Phones/Samsung Galaxy S5/Device with Shadow/Samsung Galaxy S5 Black.png",
        "label": "Samsung Galaxy S5 Black with shadow",
        "width": 1320,
        "height": 2518,
        "top": 300,
        "left": 120
      },
      {
        "image": require("./images/Phones/Samsung Galaxy S5/Device with Shadow/Samsung Galaxy S5 White.png"),
        "value": "./images/Phones/Samsung Galaxy S5/Device with Shadow/Samsung Galaxy S5 White.png",
        "label": "Samsung Galaxy S5 White with shadow",
        "width": 1320,
        "height": 2518,
        "top": 300,
        "left": 120
      },
      {
        "image": require("./images/Phones/Samsung Galaxy S7/Device/Samsung Galaxy S7 Black.png"),
        "value": "./images/Phones/Samsung Galaxy S7/Device/Samsung Galaxy S7 Black.png",
        "label": "Samsung Galaxy S7 Black",
        "width": 1720,
        "height": 3360,
        "top": 400,
        "left": 140
      },
      {
        "image": require("./images/Phones/Samsung Galaxy S7/Device/Samsung Galaxy S7 Gold.png"),
        "value": "./images/Phones/Samsung Galaxy S7/Device/Samsung Galaxy S7 Gold.png",
        "label": "Samsung Galaxy S7 Gold",
        "width": 1720,
        "height": 3360,
        "top": 400,
        "left": 140
      },
      {
        "image": require("./images/Phones/Samsung Galaxy S7/Device/Samsung Galaxy S7 Silver.png"),
        "value": "./images/Phones/Samsung Galaxy S7/Device/Samsung Galaxy S7 Silver.png",
        "label": "Samsung Galaxy S7 Silver",
        "width": 1720,
        "height": 3360,
        "top": 400,
        "left": 140
      },
      {
        "image": require("./images/Phones/Samsung Galaxy S7/Device/Samsung Galaxy S7 White.png"),
        "value": "./images/Phones/Samsung Galaxy S7/Device/Samsung Galaxy S7 White.png",
        "label": "Samsung Galaxy S7 White",
        "width": 1720,
        "height": 3360,
        "top": 400,
        "left": 140
      },
      {
        "image": require("./images/Phones/Samsung Galaxy S7/Device with Shadow/Samsung Galaxy S7 Black.png"),
        "value": "./images/Phones/Samsung Galaxy S7/Device with Shadow/Samsung Galaxy S7 Black.png",
        "label": "Samsung Galaxy S7 Black with shadow",
        "width": 1720,
        "height": 3360,
        "top": 400,
        "left": 140
      },
      {
        "image": require("./images/Phones/Samsung Galaxy S7/Device with Shadow/Samsung Galaxy S7 Gold.png"),
        "value": "./images/Phones/Samsung Galaxy S7/Device with Shadow/Samsung Galaxy S7 Gold.png",
        "label": "Samsung Galaxy S7 Gold with shadow",
        "width": 1720,
        "height": 3360,
        "top": 400,
        "left": 140
      },
      {
        "image": require("./images/Phones/Samsung Galaxy S7/Device with Shadow/Samsung Galaxy S7 Silver.png"),
        "value": "./images/Phones/Samsung Galaxy S7/Device with Shadow/Samsung Galaxy S7 Silver.png",
        "label": "Samsung Galaxy S7 Silver with shadow",
        "width": 1720,
        "height": 3360,
        "top": 400,
        "left": 140
      },
      {
        "image": require("./images/Phones/Samsung Galaxy S7/Device with Shadow/Samsung Galaxy S7 White.png"),
        "value": "./images/Phones/Samsung Galaxy S7/Device with Shadow/Samsung Galaxy S7 White.png",
        "label": "Samsung Galaxy S7 White with shadow",
        "width": 1720,
        "height": 3360,
        "top": 400,
        "left": 140
      },
      {
        "image": require("./images/Phones/Samsung Galaxy S8/Device/Samsung Galaxy S8 Arctic Silver.png"),
        "value": "./images/Phones/Samsung Galaxy S8/Device/Samsung Galaxy S8 Arctic Silver.png",
        "label": "Samsung Galaxy S8 Arctic Silver",
        "width": 1640,
        "height": 3600,
        "top": 320,
        "left": 100
      },
      {
        "image": require("./images/Phones/Samsung Galaxy S8/Device/Samsung Galaxy S8 Coral Blue.png"),
        "value": "./images/Phones/Samsung Galaxy S8/Device/Samsung Galaxy S8 Coral Blue.png",
        "label": "Samsung Galaxy S8 Coral Blue",
        "width": 1640,
        "height": 3600,
        "top": 320,
        "left": 100
      },
      {
        "image": require("./images/Phones/Samsung Galaxy S8/Device/Samsung Galaxy S8 Maple Gold.png"),
        "value": "./images/Phones/Samsung Galaxy S8/Device/Samsung Galaxy S8 Maple Gold.png",
        "label": "Samsung Galaxy S8 Maple Gold",
        "width": 1640,
        "height": 3600,
        "top": 320,
        "left": 100
      },
      {
        "image": require("./images/Phones/Samsung Galaxy S8/Device/Samsung Galaxy S8 Midnight Black.png"),
        "value": "./images/Phones/Samsung Galaxy S8/Device/Samsung Galaxy S8 Midnight Black.png",
        "label": "Samsung Galaxy S8 Midnight Black",
        "width": 1640,
        "height": 3600,
        "top": 320,
        "left": 100
      },
      {
        "image": require("./images/Phones/Samsung Galaxy S8/Device/Samsung Galaxy S8 Orchid Gray.png"),
        "value": "./images/Phones/Samsung Galaxy S8/Device/Samsung Galaxy S8 Orchid Gray.png",
        "label": "Samsung Galaxy S8 Orchid Gray",
        "width": 1640,
        "height": 3600,
        "top": 320,
        "left": 100
      },
      {
        "image": require("./images/Phones/Samsung Galaxy S8/Device with Shadow/Samsung Galaxy S8 Arctic Silver.png"),
        "value": "./images/Phones/Samsung Galaxy S8/Device with Shadow/Samsung Galaxy S8 Arctic Silver.png",
        "label": "Samsung Galaxy S8 Arctic Silver with shadow",
        "width": 1640,
        "height": 3600,
        "top": 320,
        "left": 100
      },
      {
        "image": require("./images/Phones/Samsung Galaxy S8/Device with Shadow/Samsung Galaxy S8 Coral Blue.png"),
        "value": "./images/Phones/Samsung Galaxy S8/Device with Shadow/Samsung Galaxy S8 Coral Blue.png",
        "label": "Samsung Galaxy S8 Coral Blue with shadow",
        "width": 1640,
        "height": 3600,
        "top": 320,
        "left": 100
      },
      {
        "image": require("./images/Phones/Samsung Galaxy S8/Device with Shadow/Samsung Galaxy S8 Maple Gold.png"),
        "value": "./images/Phones/Samsung Galaxy S8/Device with Shadow/Samsung Galaxy S8 Maple Gold.png",
        "label": "Samsung Galaxy S8 Maple Gold with shadow",
        "width": 1640,
        "height": 3600,
        "top": 320,
        "left": 100
      },
      {
        "image": require("./images/Phones/Samsung Galaxy S8/Device with Shadow/Samsung Galaxy S8 Midnight Black.png"),
        "value": "./images/Phones/Samsung Galaxy S8/Device with Shadow/Samsung Galaxy S8 Midnight Black.png",
        "label": "Samsung Galaxy S8 Midnight Black with shadow",
        "width": 1640,
        "height": 3600,
        "top": 320,
        "left": 100
      },
      {
        "image": require("./images/Phones/Samsung Galaxy S8/Device with Shadow/Samsung Galaxy S8 Orchid Gray.png"),
        "value": "./images/Phones/Samsung Galaxy S8/Device with Shadow/Samsung Galaxy S8 Orchid Gray.png",
        "label": "Samsung Galaxy S8 Orchid Gray with shadow",
        "width": 1640,
        "height": 3600,
        "top": 320,
        "left": 100
      },
      {
        "image": require("./images/Phones/Samsung Galaxy S9/Device/Samsung Galaxy S9 Burgundy Red.png"),
        "value": "./images/Phones/Samsung Galaxy S9/Device/Samsung Galaxy S9 Burgundy Red.png",
        "label": "Samsung Galaxy S9 Burgundy Red",
        "width": 1640,
        "height": 3440,
        "top": 240,
        "left": 100
      },
      {
        "image": require("./images/Phones/Samsung Galaxy S9/Device/Samsung Galaxy S9 Coral Blue.png"),
        "value": "./images/Phones/Samsung Galaxy S9/Device/Samsung Galaxy S9 Coral Blue.png",
        "label": "Samsung Galaxy S9 Coral Blue",
        "width": 1640,
        "height": 3440,
        "top": 240,
        "left": 100
      },
      {
        "image": require("./images/Phones/Samsung Galaxy S9/Device/Samsung Galaxy S9 Lilac Purple.png"),
        "value": "./images/Phones/Samsung Galaxy S9/Device/Samsung Galaxy S9 Lilac Purple.png",
        "label": "Samsung Galaxy S9 Lilac Purple",
        "width": 1640,
        "height": 3440,
        "top": 240,
        "left": 100
      },
      {
        "image": require("./images/Phones/Samsung Galaxy S9/Device/Samsung Galaxy S9 Midnight Black.png"),
        "value": "./images/Phones/Samsung Galaxy S9/Device/Samsung Galaxy S9 Midnight Black.png",
        "label": "Samsung Galaxy S9 Midnight Black",
        "width": 1640,
        "height": 3440,
        "top": 240,
        "left": 100
      },
      {
        "image": require("./images/Phones/Samsung Galaxy S9/Device/Samsung Galaxy S9 Sunrise Gold.png"),
        "value": "./images/Phones/Samsung Galaxy S9/Device/Samsung Galaxy S9 Sunrise Gold.png",
        "label": "Samsung Galaxy S9 Sunrise Gold",
        "width": 1640,
        "height": 3440,
        "top": 240,
        "left": 100
      },
      {
        "image": require("./images/Phones/Samsung Galaxy S9/Device/Samsung Galaxy S9 Titanium Gray.png"),
        "value": "./images/Phones/Samsung Galaxy S9/Device/Samsung Galaxy S9 Titanium Gray.png",
        "label": "Samsung Galaxy S9 Titanium Gray",
        "width": 1640,
        "height": 3440,
        "top": 240,
        "left": 100
      },
      {
        "image": require("./images/Phones/Samsung Galaxy S9/Device with Shadow/Samsung Galaxy S9 Burgundy Red.png"),
        "value": "./images/Phones/Samsung Galaxy S9/Device with Shadow/Samsung Galaxy S9 Burgundy Red.png",
        "label": "Samsung Galaxy S9 Burgundy Red with shadow",
        "width": 1640,
        "height": 3440,
        "top": 240,
        "left": 100
      },
      {
        "image": require("./images/Phones/Samsung Galaxy S9/Device with Shadow/Samsung Galaxy S9 Coral Blue.png"),
        "value": "./images/Phones/Samsung Galaxy S9/Device with Shadow/Samsung Galaxy S9 Coral Blue.png",
        "label": "Samsung Galaxy S9 Coral Blue with shadow",
        "width": 1640,
        "height": 3440,
        "top": 240,
        "left": 100
      },
      {
        "image": require("./images/Phones/Samsung Galaxy S9/Device with Shadow/Samsung Galaxy S9 Lilac Purple.png"),
        "value": "./images/Phones/Samsung Galaxy S9/Device with Shadow/Samsung Galaxy S9 Lilac Purple.png",
        "label": "Samsung Galaxy S9 Lilac Purple with shadow",
        "width": 1640,
        "height": 3440,
        "top": 240,
        "left": 100
      },
      {
        "image": require("./images/Phones/Samsung Galaxy S9/Device with Shadow/Samsung Galaxy S9 Midnight Black.png"),
        "value": "./images/Phones/Samsung Galaxy S9/Device with Shadow/Samsung Galaxy S9 Midnight Black.png",
        "label": "Samsung Galaxy S9 Midnight Black with shadow",
        "width": 1640,
        "height": 3440,
        "top": 240,
        "left": 100
      },
      {
        "image": require("./images/Phones/Samsung Galaxy S9/Device with Shadow/Samsung Galaxy S9 Sunrise Gold.png"),
        "value": "./images/Phones/Samsung Galaxy S9/Device with Shadow/Samsung Galaxy S9 Sunrise Gold.png",
        "label": "Samsung Galaxy S9 Sunrise Gold with shadow",
        "width": 1640,
        "height": 3440,
        "top": 240,
        "left": 100
      },
      {
        "image": require("./images/Phones/Samsung Galaxy S9/Device with Shadow/Samsung Galaxy S9 Titanium Gray.png"),
        "value": "./images/Phones/Samsung Galaxy S9/Device with Shadow/Samsung Galaxy S9 Titanium Gray.png",
        "label": "Samsung Galaxy S9 Titanium Gray with shadow",
        "width": 1640,
        "height": 3440,
        "top": 240,
        "left": 100
      },
      {
        "image": require("./images/Phones/Samsung Galaxy Y/Device/Samsung Galaxy Y Black.png"),
        "value": "./images/Phones/Samsung Galaxy Y/Device/Samsung Galaxy Y Black.png",
        "label": "Samsung Galaxy Y Black",
        "width": 313,
        "height": 553,
        "top": 116,
        "left": 37
      },
      {
        "image": require("./images/Phones/Samsung Galaxy Y/Device/Samsung Galaxy Y White.png"),
        "value": "./images/Phones/Samsung Galaxy Y/Device/Samsung Galaxy Y White.png",
        "label": "Samsung Galaxy Y White",
        "width": 313,
        "height": 553,
        "top": 116,
        "left": 37
      },
      {
        "image": require("./images/Phones/Samsung Galaxy Y/Device with Shadow/Samsung Galaxy Y Black.png"),
        "value": "./images/Phones/Samsung Galaxy Y/Device with Shadow/Samsung Galaxy Y Black.png",
        "label": "Samsung Galaxy Y Black with shadow",
        "width": 313,
        "height": 563,
        "top": 116,
        "left": 37
      },
      {
        "image": require("./images/Phones/Samsung Galaxy Y/Device with Shadow/Samsung Galaxy Y White.png"),
        "value": "./images/Phones/Samsung Galaxy Y/Device with Shadow/Samsung Galaxy Y White.png",
        "label": "Samsung Galaxy Y White with shadow",
        "width": 313,
        "height": 563,
        "top": 116,
        "left": 37
      },
      {
        "image": require("./images/Phones/Xiaomi Mi Mix Alpha/Device/Xiaomi Mi Mix Alpha Back.png"),
        "value": "./images/Phones/Xiaomi Mi Mix Alpha/Device/Xiaomi Mi Mix Alpha Back.png",
        "label": "Xiaomi Mi Mix Alpha Back",
        "width": 1286,
        "height": 2450,
        "top": 0,
        "left": 0
      },
      {
        "image": require("./images/Phones/Xiaomi Mi Mix Alpha/Device/Xiaomi Mi Mix Alpha Front.png"),
        "value": "./images/Phones/Xiaomi Mi Mix Alpha/Device/Xiaomi Mi Mix Alpha Front.png",
        "label": "Xiaomi Mi Mix Alpha Front",
        "width": 1286,
        "height": 2450,
        "top": 0,
        "left": 0
      },
      {
        "image": require("./images/Phones/Xiaomi Mi Mix Alpha/Device/Xiaomi Mi Mix Alpha Side.png"),
        "value": "./images/Phones/Xiaomi Mi Mix Alpha/Device/Xiaomi Mi Mix Alpha Side.png",
        "label": "Xiaomi Mi Mix Alpha Side",
        "width": 352,
        "height": 2450,
        "top": 0,
        "left": 0
      },
      {
        "image": require("./images/Phones/Xiaomi Mi Mix Alpha/Device with Shadow/Xiaomi Mi Mix Alpha Back.png"),
        "value": "./images/Phones/Xiaomi Mi Mix Alpha/Device with Shadow/Xiaomi Mi Mix Alpha Back.png",
        "label": "Xiaomi Mi Mix Alpha Back with shadow",
        "width": 1286,
        "height": 2450,
        "top": 0,
        "left": 0
      },
      {
        "image": require("./images/Phones/Xiaomi Mi Mix Alpha/Device with Shadow/Xiaomi Mi Mix Alpha Front.png"),
        "value": "./images/Phones/Xiaomi Mi Mix Alpha/Device with Shadow/Xiaomi Mi Mix Alpha Front.png",
        "label": "Xiaomi Mi Mix Alpha Front with shadow",
        "width": 1286,
        "height": 2450,
        "top": 0,
        "left": 0
      },
      {
        "image": require("./images/Phones/Xiaomi Mi Mix Alpha/Device with Shadow/Xiaomi Mi Mix Alpha Side.png"),
        "value": "./images/Phones/Xiaomi Mi Mix Alpha/Device with Shadow/Xiaomi Mi Mix Alpha Side.png",
        "label": "Xiaomi Mi Mix Alpha Side with shadow",
        "width": 352,
        "height": 2450,
        "top": 0,
        "left": 0
      }
    ]
  },
  {
    "value": "Tablets",
    "label": "Tablets",
    "options": [
      {
        "image": require("./images/Tablets/Apple iPad/Device/Apple iPad Gold.png"),
        "value": "./images/Tablets/Apple iPad/Device/Apple iPad Gold.png",
        "label": "Apple iPad Gold",
        "width": 1920,
        "height": 2710,
        "top": 0,
        "left": 0
      },
      {
        "image": require("./images/Tablets/Apple iPad/Device/Apple iPad Silver.png"),
        "value": "./images/Tablets/Apple iPad/Device/Apple iPad Silver.png",
        "label": "Apple iPad Silver",
        "width": 1920,
        "height": 2710,
        "top": 0,
        "left": 0
      },
      {
        "image": require("./images/Tablets/Apple iPad/Device/Apple iPad Space Grey.png"),
        "value": "./images/Tablets/Apple iPad/Device/Apple iPad Space Grey.png",
        "label": "Apple iPad Space Grey",
        "width": 1920,
        "height": 2710,
        "top": 0,
        "left": 0
      },
      {
        "image": require("./images/Tablets/Apple iPad/Device with Shadow/Apple iPad Gold.png"),
        "value": "./images/Tablets/Apple iPad/Device with Shadow/Apple iPad Gold.png",
        "label": "Apple iPad Gold with shadow",
        "width": 1920,
        "height": 2710,
        "top": 0,
        "left": 0
      },
      {
        "image": require("./images/Tablets/Apple iPad/Device with Shadow/Apple iPad Silver.png"),
        "value": "./images/Tablets/Apple iPad/Device with Shadow/Apple iPad Silver.png",
        "label": "Apple iPad Silver with shadow",
        "width": 1920,
        "height": 2710,
        "top": 0,
        "left": 0
      },
      {
        "image": require("./images/Tablets/Apple iPad/Device with Shadow/Apple iPad Space Grey.png"),
        "value": "./images/Tablets/Apple iPad/Device with Shadow/Apple iPad Space Grey.png",
        "label": "Apple iPad Space Grey with shadow",
        "width": 1920,
        "height": 2710,
        "top": 0,
        "left": 0
      },
      {
        "image": require("./images/Tablets/Apple iPad Air/Device/Apple iPad Air Gold.png"),
        "value": "./images/Tablets/Apple iPad Air/Device/Apple iPad Air Gold.png",
        "label": "Apple iPad Air Gold",
        "width": 1946,
        "height": 2748,
        "top": 0,
        "left": 0
      },
      {
        "image": require("./images/Tablets/Apple iPad Air/Device/Apple iPad Air Silver.png"),
        "value": "./images/Tablets/Apple iPad Air/Device/Apple iPad Air Silver.png",
        "label": "Apple iPad Air Silver",
        "width": 1946,
        "height": 2748,
        "top": 0,
        "left": 0
      },
      {
        "image": require("./images/Tablets/Apple iPad Air/Device/Apple iPad Air Space Grey.png"),
        "value": "./images/Tablets/Apple iPad Air/Device/Apple iPad Air Space Grey.png",
        "label": "Apple iPad Air Space Grey",
        "width": 1946,
        "height": 2748,
        "top": 0,
        "left": 0
      },
      {
        "image": require("./images/Tablets/Apple iPad Air/Device with Shadow/Apple iPad Air Gold.png"),
        "value": "./images/Tablets/Apple iPad Air/Device with Shadow/Apple iPad Air Gold.png",
        "label": "Apple iPad Air Gold with shadow",
        "width": 1946,
        "height": 2748,
        "top": 0,
        "left": 0
      },
      {
        "image": require("./images/Tablets/Apple iPad Air/Device with Shadow/Apple iPad Air Silver.png"),
        "value": "./images/Tablets/Apple iPad Air/Device with Shadow/Apple iPad Air Silver.png",
        "label": "Apple iPad Air Silver with shadow",
        "width": 1946,
        "height": 2748,
        "top": 0,
        "left": 0
      },
      {
        "image": require("./images/Tablets/Apple iPad Air/Device with Shadow/Apple iPad Air Space Grey.png"),
        "value": "./images/Tablets/Apple iPad Air/Device with Shadow/Apple iPad Air Space Grey.png",
        "label": "Apple iPad Air Space Grey with shadow",
        "width": 1946,
        "height": 2748,
        "top": 0,
        "left": 0
      },
      {
        "image": require("./images/Tablets/Apple iPad Mini/Device/Apple iPad Mini Gold.png"),
        "value": "./images/Tablets/Apple iPad Mini/Device/Apple iPad Mini Gold.png",
        "label": "Apple iPad Mini Gold",
        "width": 1836,
        "height": 2708,
        "top": 0,
        "left": 0
      },
      {
        "image": require("./images/Tablets/Apple iPad Mini/Device/Apple iPad Mini Silver.png"),
        "value": "./images/Tablets/Apple iPad Mini/Device/Apple iPad Mini Silver.png",
        "label": "Apple iPad Mini Silver",
        "width": 1836,
        "height": 2708,
        "top": 0,
        "left": 0
      },
      {
        "image": require("./images/Tablets/Apple iPad Mini/Device/Apple iPad Mini Space Grey.png"),
        "value": "./images/Tablets/Apple iPad Mini/Device/Apple iPad Mini Space Grey.png",
        "label": "Apple iPad Mini Space Grey",
        "width": 1836,
        "height": 2708,
        "top": 0,
        "left": 0
      },
      {
        "image": require("./images/Tablets/Apple iPad Mini/Device with Shadow/Apple iPad Mini Gold.png"),
        "value": "./images/Tablets/Apple iPad Mini/Device with Shadow/Apple iPad Mini Gold.png",
        "label": "Apple iPad Mini Gold with shadow",
        "width": 1836,
        "height": 2708,
        "top": 0,
        "left": 0
      },
      {
        "image": require("./images/Tablets/Apple iPad Mini/Device with Shadow/Apple iPad Mini Silver.png"),
        "value": "./images/Tablets/Apple iPad Mini/Device with Shadow/Apple iPad Mini Silver.png",
        "label": "Apple iPad Mini Silver with shadow",
        "width": 1836,
        "height": 2708,
        "top": 0,
        "left": 0
      },
      {
        "image": require("./images/Tablets/Apple iPad Mini/Device with Shadow/Apple iPad Mini Space Grey.png"),
        "value": "./images/Tablets/Apple iPad Mini/Device with Shadow/Apple iPad Mini Space Grey.png",
        "label": "Apple iPad Mini Space Grey with shadow",
        "width": 1836,
        "height": 2708,
        "top": 0,
        "left": 0
      },
      {
        "image": require("./images/Tablets/Apple iPad Pro/Device/Device with Pencil/Apple iPad Pro 11\" Silver - Landscape.png"),
        "value": "./images/Tablets/Apple iPad Pro/Device/Device with Pencil/Apple iPad Pro 11\" Silver - Landscape.png",
        "label": "Apple iPad Pro 11\" Silver - Landscape",
        "width": 2788,
        "height": 2068,
        "top": 350,
        "left": 200
      },
      {
        "image": require("./images/Tablets/Apple iPad Pro/Device/Device with Pencil/Apple iPad Pro 11\" Silver - Portrait.png"),
        "value": "./images/Tablets/Apple iPad Pro/Device/Device with Pencil/Apple iPad Pro 11\" Silver - Portrait.png",
        "label": "Apple iPad Pro 11\" Silver - Portrait",
        "width": 2068,
        "height": 2788,
        "top": 350,
        "left": 200
      },
      {
        "image": require("./images/Tablets/Apple iPad Pro/Device/Device with Pencil/Apple iPad Pro 11\" Space Gray - Landscape.png"),
        "value": "./images/Tablets/Apple iPad Pro/Device/Device with Pencil/Apple iPad Pro 11\" Space Gray - Landscape.png",
        "label": "Apple iPad Pro 11\" Space Gray - Landscape",
        "width": 2788,
        "height": 2068,
        "top": 350,
        "left": 200
      },
      {
        "image": require("./images/Tablets/Apple iPad Pro/Device/Device with Pencil/Apple iPad Pro 11\" Space Gray - Portrait.png"),
        "value": "./images/Tablets/Apple iPad Pro/Device/Device with Pencil/Apple iPad Pro 11\" Space Gray - Portrait.png",
        "label": "Apple iPad Pro 11\" Space Gray - Portrait",
        "width": 2068,
        "height": 2788,
        "top": 350,
        "left": 200
      },
      {
        "image": require("./images/Tablets/Apple iPad Pro/Device/Device with Pencil/Apple iPad Pro 13\" Silver - Landscape.png"),
        "value": "./images/Tablets/Apple iPad Pro/Device/Device with Pencil/Apple iPad Pro 13\" Silver - Landscape.png",
        "label": "Apple iPad Pro 13\" Silver - Landscape",
        "width": 3132,
        "height": 2448,
        "top": 350,
        "left": 200
      },
      {
        "image": require("./images/Tablets/Apple iPad Pro/Device/Device with Pencil/Apple iPad Pro 13\" Silver - Portrait.png"),
        "value": "./images/Tablets/Apple iPad Pro/Device/Device with Pencil/Apple iPad Pro 13\" Silver - Portrait.png",
        "label": "Apple iPad Pro 13\" Silver - Portrait",
        "width": 2448,
        "height": 3132,
        "top": 350,
        "left": 200
      },
      {
        "image": require("./images/Tablets/Apple iPad Pro/Device/Device with Pencil/Apple iPad Pro 13\" Space Gray - Landscape.png"),
        "value": "./images/Tablets/Apple iPad Pro/Device/Device with Pencil/Apple iPad Pro 13\" Space Gray - Landscape.png",
        "label": "Apple iPad Pro 13\" Space Gray - Landscape",
        "width": 3132,
        "height": 2448,
        "top": 350,
        "left": 200
      },
      {
        "image": require("./images/Tablets/Apple iPad Pro/Device/Device with Pencil/Apple iPad Pro 13\" Space Gray - Portrait.png"),
        "value": "./images/Tablets/Apple iPad Pro/Device/Device with Pencil/Apple iPad Pro 13\" Space Gray - Portrait.png",
        "label": "Apple iPad Pro 13\" Space Gray - Portrait",
        "width": 2448,
        "height": 3132,
        "top": 350,
        "left": 200
      },
      {
        "image": require("./images/Tablets/Apple iPad Pro/Device/Device without Pencil/Apple iPad Pro 11\" Silver - Landscape.png"),
        "value": "./images/Tablets/Apple iPad Pro/Device/Device without Pencil/Apple iPad Pro 11\" Silver - Landscape.png",
        "label": "Apple iPad Pro 11\" Silver - Landscape",
        "width": 2788,
        "height": 2068,
        "top": 350,
        "left": 200
      },
      {
        "image": require("./images/Tablets/Apple iPad Pro/Device/Device without Pencil/Apple iPad Pro 11\" Silver - Portrait.png"),
        "value": "./images/Tablets/Apple iPad Pro/Device/Device without Pencil/Apple iPad Pro 11\" Silver - Portrait.png",
        "label": "Apple iPad Pro 11\" Silver - Portrait",
        "width": 2068,
        "height": 2788,
        "top": 350,
        "left": 200
      },
      {
        "image": require("./images/Tablets/Apple iPad Pro/Device/Device without Pencil/Apple iPad Pro 11\" Space Gray - Landscape.png"),
        "value": "./images/Tablets/Apple iPad Pro/Device/Device without Pencil/Apple iPad Pro 11\" Space Gray - Landscape.png",
        "label": "Apple iPad Pro 11\" Space Gray - Landscape",
        "width": 2788,
        "height": 2068,
        "top": 350,
        "left": 200
      },
      {
        "image": require("./images/Tablets/Apple iPad Pro/Device/Device without Pencil/Apple iPad Pro 11\" Space Gray - Portrait.png"),
        "value": "./images/Tablets/Apple iPad Pro/Device/Device without Pencil/Apple iPad Pro 11\" Space Gray - Portrait.png",
        "label": "Apple iPad Pro 11\" Space Gray - Portrait",
        "width": 2068,
        "height": 2788,
        "top": 350,
        "left": 200
      },
      {
        "image": require("./images/Tablets/Apple iPad Pro/Device/Device without Pencil/Apple iPad Pro 13\" Silver - Landscape.png"),
        "value": "./images/Tablets/Apple iPad Pro/Device/Device without Pencil/Apple iPad Pro 13\" Silver - Landscape.png",
        "label": "Apple iPad Pro 13\" Silver - Landscape",
        "width": 3132,
        "height": 2448,
        "top": 350,
        "left": 200
      },
      {
        "image": require("./images/Tablets/Apple iPad Pro/Device/Device without Pencil/Apple iPad Pro 13\" Silver - Portrait.png"),
        "value": "./images/Tablets/Apple iPad Pro/Device/Device without Pencil/Apple iPad Pro 13\" Silver - Portrait.png",
        "label": "Apple iPad Pro 13\" Silver - Portrait",
        "width": 2448,
        "height": 3132,
        "top": 350,
        "left": 200
      },
      {
        "image": require("./images/Tablets/Apple iPad Pro/Device/Device without Pencil/Apple iPad Pro 13\" Space Gray - Landscape.png"),
        "value": "./images/Tablets/Apple iPad Pro/Device/Device without Pencil/Apple iPad Pro 13\" Space Gray - Landscape.png",
        "label": "Apple iPad Pro 13\" Space Gray - Landscape",
        "width": 3132,
        "height": 2448,
        "top": 350,
        "left": 200
      },
      {
        "image": require("./images/Tablets/Apple iPad Pro/Device/Device without Pencil/Apple iPad Pro 13\" Space Gray - Portrait.png"),
        "value": "./images/Tablets/Apple iPad Pro/Device/Device without Pencil/Apple iPad Pro 13\" Space Gray - Portrait.png",
        "label": "Apple iPad Pro 13\" Space Gray - Portrait",
        "width": 2448,
        "height": 3132,
        "top": 350,
        "left": 200
      },
      {
        "image": require("./images/Tablets/Apple iPad Pro/Device with Shadow/Device with Pencil/Apple iPad Pro 11\" Silver - Landscape.png"),
        "value": "./images/Tablets/Apple iPad Pro/Device with Shadow/Device with Pencil/Apple iPad Pro 11\" Silver - Landscape.png",
        "label": "Apple iPad Pro 11\" Silver - Landscape",
        "width": 2788,
        "height": 2068,
        "top": 350,
        "left": 200
      },
      {
        "image": require("./images/Tablets/Apple iPad Pro/Device with Shadow/Device with Pencil/Apple iPad Pro 11\" Silver - Portrait.png"),
        "value": "./images/Tablets/Apple iPad Pro/Device with Shadow/Device with Pencil/Apple iPad Pro 11\" Silver - Portrait.png",
        "label": "Apple iPad Pro 11\" Silver - Portrait",
        "width": 2068,
        "height": 2788,
        "top": 350,
        "left": 200
      },
      {
        "image": require("./images/Tablets/Apple iPad Pro/Device with Shadow/Device with Pencil/Apple iPad Pro 11\" Space Gray - Landscape.png"),
        "value": "./images/Tablets/Apple iPad Pro/Device with Shadow/Device with Pencil/Apple iPad Pro 11\" Space Gray - Landscape.png",
        "label": "Apple iPad Pro 11\" Space Gray - Landscape",
        "width": 2788,
        "height": 2068,
        "top": 350,
        "left": 200
      },
      {
        "image": require("./images/Tablets/Apple iPad Pro/Device with Shadow/Device with Pencil/Apple iPad Pro 11\" Space Gray - Portrait.png"),
        "value": "./images/Tablets/Apple iPad Pro/Device with Shadow/Device with Pencil/Apple iPad Pro 11\" Space Gray - Portrait.png",
        "label": "Apple iPad Pro 11\" Space Gray - Portrait",
        "width": 2068,
        "height": 2788,
        "top": 350,
        "left": 200
      },
      {
        "image": require("./images/Tablets/Apple iPad Pro/Device with Shadow/Device with Pencil/Apple iPad Pro 13\" Silver - Landscape.png"),
        "value": "./images/Tablets/Apple iPad Pro/Device with Shadow/Device with Pencil/Apple iPad Pro 13\" Silver - Landscape.png",
        "label": "Apple iPad Pro 13\" Silver - Landscape",
        "width": 3132,
        "height": 2448,
        "top": 350,
        "left": 200
      },
      {
        "image": require("./images/Tablets/Apple iPad Pro/Device with Shadow/Device with Pencil/Apple iPad Pro 13\" Silver - Portrait.png"),
        "value": "./images/Tablets/Apple iPad Pro/Device with Shadow/Device with Pencil/Apple iPad Pro 13\" Silver - Portrait.png",
        "label": "Apple iPad Pro 13\" Silver - Portrait",
        "width": 2448,
        "height": 3132,
        "top": 350,
        "left": 200
      },
      {
        "image": require("./images/Tablets/Apple iPad Pro/Device with Shadow/Device with Pencil/Apple iPad Pro 13\" Space Gray - Landscape.png"),
        "value": "./images/Tablets/Apple iPad Pro/Device with Shadow/Device with Pencil/Apple iPad Pro 13\" Space Gray - Landscape.png",
        "label": "Apple iPad Pro 13\" Space Gray - Landscape",
        "width": 3132,
        "height": 2448,
        "top": 350,
        "left": 200
      },
      {
        "image": require("./images/Tablets/Apple iPad Pro/Device with Shadow/Device with Pencil/Apple iPad Pro 13\" Space Gray - Portrait.png"),
        "value": "./images/Tablets/Apple iPad Pro/Device with Shadow/Device with Pencil/Apple iPad Pro 13\" Space Gray - Portrait.png",
        "label": "Apple iPad Pro 13\" Space Gray - Portrait",
        "width": 2448,
        "height": 3132,
        "top": 350,
        "left": 200
      },
      {
        "image": require("./images/Tablets/Apple iPad Pro/Device with Shadow/Device without Pencil/Apple iPad Pro 11\" Silver - Landscape.png"),
        "value": "./images/Tablets/Apple iPad Pro/Device with Shadow/Device without Pencil/Apple iPad Pro 11\" Silver - Landscape.png",
        "label": "Apple iPad Pro 11\" Silver - Landscape",
        "width": 2788,
        "height": 2068,
        "top": 350,
        "left": 200
      },
      {
        "image": require("./images/Tablets/Apple iPad Pro/Device with Shadow/Device without Pencil/Apple iPad Pro 11\" Silver - Portrait.png"),
        "value": "./images/Tablets/Apple iPad Pro/Device with Shadow/Device without Pencil/Apple iPad Pro 11\" Silver - Portrait.png",
        "label": "Apple iPad Pro 11\" Silver - Portrait",
        "width": 2068,
        "height": 2788,
        "top": 350,
        "left": 200
      },
      {
        "image": require("./images/Tablets/Apple iPad Pro/Device with Shadow/Device without Pencil/Apple iPad Pro 11\" Space Gray - Landscape.png"),
        "value": "./images/Tablets/Apple iPad Pro/Device with Shadow/Device without Pencil/Apple iPad Pro 11\" Space Gray - Landscape.png",
        "label": "Apple iPad Pro 11\" Space Gray - Landscape",
        "width": 2788,
        "height": 2068,
        "top": 350,
        "left": 200
      },
      {
        "image": require("./images/Tablets/Apple iPad Pro/Device with Shadow/Device without Pencil/Apple iPad Pro 11\" Space Gray - Portrait.png"),
        "value": "./images/Tablets/Apple iPad Pro/Device with Shadow/Device without Pencil/Apple iPad Pro 11\" Space Gray - Portrait.png",
        "label": "Apple iPad Pro 11\" Space Gray - Portrait",
        "width": 2068,
        "height": 2788,
        "top": 350,
        "left": 200
      },
      {
        "image": require("./images/Tablets/Apple iPad Pro/Device with Shadow/Device without Pencil/Apple iPad Pro 13\" Silver - Landscape.png"),
        "value": "./images/Tablets/Apple iPad Pro/Device with Shadow/Device without Pencil/Apple iPad Pro 13\" Silver - Landscape.png",
        "label": "Apple iPad Pro 13\" Silver - Landscape",
        "width": 3132,
        "height": 2448,
        "top": 350,
        "left": 200
      },
      {
        "image": require("./images/Tablets/Apple iPad Pro/Device with Shadow/Device without Pencil/Apple iPad Pro 13\" Silver - Portrait.png"),
        "value": "./images/Tablets/Apple iPad Pro/Device with Shadow/Device without Pencil/Apple iPad Pro 13\" Silver - Portrait.png",
        "label": "Apple iPad Pro 13\" Silver - Portrait",
        "width": 2448,
        "height": 3132,
        "top": 350,
        "left": 200
      },
      {
        "image": require("./images/Tablets/Apple iPad Pro/Device with Shadow/Device without Pencil/Apple iPad Pro 13\" Space Gray - Landscape.png"),
        "value": "./images/Tablets/Apple iPad Pro/Device with Shadow/Device without Pencil/Apple iPad Pro 13\" Space Gray - Landscape.png",
        "label": "Apple iPad Pro 13\" Space Gray - Landscape",
        "width": 3132,
        "height": 2448,
        "top": 350,
        "left": 200
      },
      {
        "image": require("./images/Tablets/Apple iPad Pro/Device with Shadow/Device without Pencil/Apple iPad Pro 13\" Space Gray - Portrait.png"),
        "value": "./images/Tablets/Apple iPad Pro/Device with Shadow/Device without Pencil/Apple iPad Pro 13\" Space Gray - Portrait.png",
        "label": "Apple iPad Pro 13\" Space Gray - Portrait",
        "width": 2448,
        "height": 3132,
        "top": 350,
        "left": 200
      },
      {
        "image": require("./images/Tablets/Microsoft Surface 3/Device/Microsoft Surface Pro 3.png"),
        "value": "./images/Tablets/Microsoft Surface 3/Device/Microsoft Surface Pro 3.png",
        "label": "Microsoft Surface Pro 3",
        "width": 2320,
        "height": 1680,
        "top": 200,
        "left": 200
      },
      {
        "image": require("./images/Tablets/Microsoft Surface 3/Device with Shadow/Microsoft Surface Pro 3.png"),
        "value": "./images/Tablets/Microsoft Surface 3/Device with Shadow/Microsoft Surface Pro 3.png",
        "label": "Microsoft Surface Pro 3 with shadow",
        "width": 2320,
        "height": 1680,
        "top": 200,
        "left": 200
      },
      {
        "image": require("./images/Tablets/Microsoft Surface Pro 4/Device/Microsoft Surface Pro 4.png"),
        "value": "./images/Tablets/Microsoft Surface Pro 4/Device/Microsoft Surface Pro 4.png",
        "label": "Microsoft Surface Pro 4",
        "width": 3216,
        "height": 2224,
        "top": 200,
        "left": 240
      },
      {
        "image": require("./images/Tablets/Microsoft Surface Pro 4/Device with Shadow/Microsoft Surface Pro 4.png"),
        "value": "./images/Tablets/Microsoft Surface Pro 4/Device with Shadow/Microsoft Surface Pro 4.png",
        "label": "Microsoft Surface Pro 4 with shadow",
        "width": 3216,
        "height": 2224,
        "top": 200,
        "left": 240
      },
      {
        "image": require("./images/Tablets/Nexus 9/Device/Nexus 9.png"),
        "value": "./images/Tablets/Nexus 9/Device/Nexus 9.png",
        "label": "Nexus 9",
        "width": 1896,
        "height": 2648,
        "top": 300,
        "left": 180
      },
      {
        "image": require("./images/Tablets/Nexus 9/Device with Shadow/Nexus 9.png"),
        "value": "./images/Tablets/Nexus 9/Device with Shadow/Nexus 9.png",
        "label": "Nexus 9 with shadow",
        "width": 1896,
        "height": 2648,
        "top": 300,
        "left": 180
      }
    ]
  },
  {
    "value": "Watches",
    "label": "Watches",
    "options": [
      {
        "image": require("./images/Watches/Apple Watch/Device/38mm/Device Closed/Apple Watch 38mm Black Steel + Black Closed.png"),
        "value": "./images/Watches/Apple Watch/Device/38mm/Device Closed/Apple Watch 38mm Black Steel + Black Closed.png",
        "label": "Apple Watch 38mm Black Steel + Black Closed",
        "width": 472,
        "height": 772,
        "top": 228,
        "left": 100
      },
      {
        "image": require("./images/Watches/Apple Watch/Device/38mm/Device Closed/Apple Watch 38mm Gold + Black Leather Closed.png"),
        "value": "./images/Watches/Apple Watch/Device/38mm/Device Closed/Apple Watch 38mm Gold + Black Leather Closed.png",
        "label": "Apple Watch 38mm Gold + Black Leather Closed",
        "width": 472,
        "height": 796,
        "top": 228,
        "left": 100
      },
      {
        "image": require("./images/Watches/Apple Watch/Device/38mm/Device Closed/Apple Watch 38mm Gold + Midnight Blue Closed.png"),
        "value": "./images/Watches/Apple Watch/Device/38mm/Device Closed/Apple Watch 38mm Gold + Midnight Blue Closed.png",
        "label": "Apple Watch 38mm Gold + Midnight Blue Closed",
        "width": 472,
        "height": 772,
        "top": 228,
        "left": 100
      },
      {
        "image": require("./images/Watches/Apple Watch/Device/38mm/Device Closed/Apple Watch 38mm Rose Gold + Black Leather Closed.png"),
        "value": "./images/Watches/Apple Watch/Device/38mm/Device Closed/Apple Watch 38mm Rose Gold + Black Leather Closed.png",
        "label": "Apple Watch 38mm Rose Gold + Black Leather Closed",
        "width": 472,
        "height": 796,
        "top": 228,
        "left": 100
      },
      {
        "image": require("./images/Watches/Apple Watch/Device/38mm/Device Closed/Apple Watch 38mm Rose Gold + Lavender Closed.png"),
        "value": "./images/Watches/Apple Watch/Device/38mm/Device Closed/Apple Watch 38mm Rose Gold + Lavender Closed.png",
        "label": "Apple Watch 38mm Rose Gold + Lavender Closed",
        "width": 472,
        "height": 772,
        "top": 228,
        "left": 100
      },
      {
        "image": require("./images/Watches/Apple Watch/Device/38mm/Device Closed/Apple Watch 38mm Sport Aluminum + Blue Closed.png"),
        "value": "./images/Watches/Apple Watch/Device/38mm/Device Closed/Apple Watch 38mm Sport Aluminum + Blue Closed.png",
        "label": "Apple Watch 38mm Sport Aluminum + Blue Closed",
        "width": 472,
        "height": 772,
        "top": 228,
        "left": 100
      },
      {
        "image": require("./images/Watches/Apple Watch/Device/38mm/Device Closed/Apple Watch 38mm Sport Aluminum + Fog Closed.png"),
        "value": "./images/Watches/Apple Watch/Device/38mm/Device Closed/Apple Watch 38mm Sport Aluminum + Fog Closed.png",
        "label": "Apple Watch 38mm Sport Aluminum + Fog Closed",
        "width": 472,
        "height": 772,
        "top": 228,
        "left": 100
      },
      {
        "image": require("./images/Watches/Apple Watch/Device/38mm/Device Closed/Apple Watch 38mm Sport Aluminum + Green Closed.png"),
        "value": "./images/Watches/Apple Watch/Device/38mm/Device Closed/Apple Watch 38mm Sport Aluminum + Green Closed.png",
        "label": "Apple Watch 38mm Sport Aluminum + Green Closed",
        "width": 472,
        "height": 772,
        "top": 228,
        "left": 100
      },
      {
        "image": require("./images/Watches/Apple Watch/Device/38mm/Device Closed/Apple Watch 38mm Sport Aluminum + Red Closed.png"),
        "value": "./images/Watches/Apple Watch/Device/38mm/Device Closed/Apple Watch 38mm Sport Aluminum + Red Closed.png",
        "label": "Apple Watch 38mm Sport Aluminum + Red Closed",
        "width": 472,
        "height": 772,
        "top": 228,
        "left": 100
      },
      {
        "image": require("./images/Watches/Apple Watch/Device/38mm/Device Closed/Apple Watch 38mm Sport Aluminum + Walnut Closed.png"),
        "value": "./images/Watches/Apple Watch/Device/38mm/Device Closed/Apple Watch 38mm Sport Aluminum + Walnut Closed.png",
        "label": "Apple Watch 38mm Sport Aluminum + Walnut Closed",
        "width": 472,
        "height": 772,
        "top": 228,
        "left": 100
      },
      {
        "image": require("./images/Watches/Apple Watch/Device/38mm/Device Closed/Apple Watch 38mm Sport Aluminum + White Closed.png"),
        "value": "./images/Watches/Apple Watch/Device/38mm/Device Closed/Apple Watch 38mm Sport Aluminum + White Closed.png",
        "label": "Apple Watch 38mm Sport Aluminum + White Closed",
        "width": 472,
        "height": 772,
        "top": 228,
        "left": 100
      },
      {
        "image": require("./images/Watches/Apple Watch/Device/38mm/Device Closed/Apple Watch 38mm Sport Aluminum Gold + Antique White Closed.png"),
        "value": "./images/Watches/Apple Watch/Device/38mm/Device Closed/Apple Watch 38mm Sport Aluminum Gold + Antique White Closed.png",
        "label": "Apple Watch 38mm Sport Aluminum Gold + Antique White Closed",
        "width": 472,
        "height": 772,
        "top": 228,
        "left": 100
      },
      {
        "image": require("./images/Watches/Apple Watch/Device/38mm/Device Closed/Apple Watch 38mm Sport Aluminum Rose Gold + Stone Closed.png"),
        "value": "./images/Watches/Apple Watch/Device/38mm/Device Closed/Apple Watch 38mm Sport Aluminum Rose Gold + Stone Closed.png",
        "label": "Apple Watch 38mm Sport Aluminum Rose Gold + Stone Closed",
        "width": 472,
        "height": 772,
        "top": 228,
        "left": 100
      },
      {
        "image": require("./images/Watches/Apple Watch/Device/38mm/Device Closed/Apple Watch 38mm Sport Space Gray + Black Closed.png"),
        "value": "./images/Watches/Apple Watch/Device/38mm/Device Closed/Apple Watch 38mm Sport Space Gray + Black Closed.png",
        "label": "Apple Watch 38mm Sport Space Gray + Black Closed",
        "width": 472,
        "height": 772,
        "top": 228,
        "left": 100
      },
      {
        "image": require("./images/Watches/Apple Watch/Device/38mm/Device Closed/Apple Watch 38mm Stainless Steel + Black Leather Closed.png"),
        "value": "./images/Watches/Apple Watch/Device/38mm/Device Closed/Apple Watch 38mm Stainless Steel + Black Leather Closed.png",
        "label": "Apple Watch 38mm Stainless Steel + Black Leather Closed",
        "width": 472,
        "height": 796,
        "top": 228,
        "left": 100
      },
      {
        "image": require("./images/Watches/Apple Watch/Device/38mm/Device Closed/Apple Watch 38mm Steel + White Closed.png"),
        "value": "./images/Watches/Apple Watch/Device/38mm/Device Closed/Apple Watch 38mm Steel + White Closed.png",
        "label": "Apple Watch 38mm Steel + White Closed",
        "width": 472,
        "height": 772,
        "top": 228,
        "left": 100
      },
      {
        "image": require("./images/Watches/Apple Watch/Device/38mm/Device Open/Apple Watch 38mm Black Steel + Black Open.png"),
        "value": "./images/Watches/Apple Watch/Device/38mm/Device Open/Apple Watch 38mm Black Steel + Black Open.png",
        "label": "Apple Watch 38mm Black Steel + Black Open",
        "width": 472,
        "height": 3540,
        "top": 1600,
        "left": 100
      },
      {
        "image": require("./images/Watches/Apple Watch/Device/38mm/Device Open/Apple Watch 38mm Gold + Midnight Blue Open.png"),
        "value": "./images/Watches/Apple Watch/Device/38mm/Device Open/Apple Watch 38mm Gold + Midnight Blue Open.png",
        "label": "Apple Watch 38mm Gold + Midnight Blue Open",
        "width": 472,
        "height": 3540,
        "top": 1600,
        "left": 100
      },
      {
        "image": require("./images/Watches/Apple Watch/Device/38mm/Device Open/Apple Watch 38mm Rose Gold + Lavender Open.png"),
        "value": "./images/Watches/Apple Watch/Device/38mm/Device Open/Apple Watch 38mm Rose Gold + Lavender Open.png",
        "label": "Apple Watch 38mm Rose Gold + Lavender Open",
        "width": 472,
        "height": 3540,
        "top": 1600,
        "left": 100
      },
      {
        "image": require("./images/Watches/Apple Watch/Device/38mm/Device Open/Apple Watch 38mm Sport Aluminum + Blue Open.png"),
        "value": "./images/Watches/Apple Watch/Device/38mm/Device Open/Apple Watch 38mm Sport Aluminum + Blue Open.png",
        "label": "Apple Watch 38mm Sport Aluminum + Blue Open",
        "width": 472,
        "height": 3540,
        "top": 1600,
        "left": 100
      },
      {
        "image": require("./images/Watches/Apple Watch/Device/38mm/Device Open/Apple Watch 38mm Sport Aluminum + Fog Open.png"),
        "value": "./images/Watches/Apple Watch/Device/38mm/Device Open/Apple Watch 38mm Sport Aluminum + Fog Open.png",
        "label": "Apple Watch 38mm Sport Aluminum + Fog Open",
        "width": 472,
        "height": 3540,
        "top": 1600,
        "left": 100
      },
      {
        "image": require("./images/Watches/Apple Watch/Device/38mm/Device Open/Apple Watch 38mm Sport Aluminum + Green Open.png"),
        "value": "./images/Watches/Apple Watch/Device/38mm/Device Open/Apple Watch 38mm Sport Aluminum + Green Open.png",
        "label": "Apple Watch 38mm Sport Aluminum + Green Open",
        "width": 472,
        "height": 3540,
        "top": 1600,
        "left": 100
      },
      {
        "image": require("./images/Watches/Apple Watch/Device/38mm/Device Open/Apple Watch 38mm Sport Aluminum + Red Open .png"),
        "value": "./images/Watches/Apple Watch/Device/38mm/Device Open/Apple Watch 38mm Sport Aluminum + Red Open .png",
        "label": "Apple Watch 38mm Sport Aluminum + Red Open",
        "width": 472,
        "height": 3540,
        "top": 1600,
        "left": 100
      },
      {
        "image": require("./images/Watches/Apple Watch/Device/38mm/Device Open/Apple Watch 38mm Sport Aluminum + Walnut Open.png"),
        "value": "./images/Watches/Apple Watch/Device/38mm/Device Open/Apple Watch 38mm Sport Aluminum + Walnut Open.png",
        "label": "Apple Watch 38mm Sport Aluminum + Walnut Open",
        "width": 472,
        "height": 3540,
        "top": 1600,
        "left": 100
      },
      {
        "image": require("./images/Watches/Apple Watch/Device/38mm/Device Open/Apple Watch 38mm Sport Aluminum + White Open.png"),
        "value": "./images/Watches/Apple Watch/Device/38mm/Device Open/Apple Watch 38mm Sport Aluminum + White Open.png",
        "label": "Apple Watch 38mm Sport Aluminum + White Open",
        "width": 472,
        "height": 3540,
        "top": 1600,
        "left": 100
      },
      {
        "image": require("./images/Watches/Apple Watch/Device/38mm/Device Open/Apple Watch 38mm Sport Aluminum Gold + Antique White Open.png"),
        "value": "./images/Watches/Apple Watch/Device/38mm/Device Open/Apple Watch 38mm Sport Aluminum Gold + Antique White Open.png",
        "label": "Apple Watch 38mm Sport Aluminum Gold + Antique White Open",
        "width": 472,
        "height": 3540,
        "top": 1600,
        "left": 100
      },
      {
        "image": require("./images/Watches/Apple Watch/Device/38mm/Device Open/Apple Watch 38mm Sport Aluminum Rose Gold + Stone Open.png"),
        "value": "./images/Watches/Apple Watch/Device/38mm/Device Open/Apple Watch 38mm Sport Aluminum Rose Gold + Stone Open.png",
        "label": "Apple Watch 38mm Sport Aluminum Rose Gold + Stone Open",
        "width": 472,
        "height": 3540,
        "top": 1600,
        "left": 100
      },
      {
        "image": require("./images/Watches/Apple Watch/Device/38mm/Device Open/Apple Watch 38mm Sport Space Gray + Black Open.png"),
        "value": "./images/Watches/Apple Watch/Device/38mm/Device Open/Apple Watch 38mm Sport Space Gray + Black Open.png",
        "label": "Apple Watch 38mm Sport Space Gray + Black Open",
        "width": 472,
        "height": 3540,
        "top": 1600,
        "left": 100
      },
      {
        "image": require("./images/Watches/Apple Watch/Device/38mm/Device Open/Apple Watch 38mm Steel + White Open.png"),
        "value": "./images/Watches/Apple Watch/Device/38mm/Device Open/Apple Watch 38mm Steel + White Open.png",
        "label": "Apple Watch 38mm Steel + White Open",
        "width": 472,
        "height": 3540,
        "top": 1600,
        "left": 100
      },
      {
        "image": require("./images/Watches/Apple Watch/Device/42mm/Device Closed/Apple Watch 42mm Black Steel + Black Closed.png"),
        "value": "./images/Watches/Apple Watch/Device/42mm/Device Closed/Apple Watch 42mm Black Steel + Black Closed.png",
        "label": "Apple Watch 42mm Black Steel + Black Closed",
        "width": 512,
        "height": 990,
        "top": 300,
        "left": 100
      },
      {
        "image": require("./images/Watches/Apple Watch/Device/42mm/Device Closed/Apple Watch 42mm Gold + Black Leather Closed.png"),
        "value": "./images/Watches/Apple Watch/Device/42mm/Device Closed/Apple Watch 42mm Gold + Black Leather Closed.png",
        "label": "Apple Watch 42mm Gold + Black Leather Closed",
        "width": 512,
        "height": 990,
        "top": 300,
        "left": 100
      },
      {
        "image": require("./images/Watches/Apple Watch/Device/42mm/Device Closed/Apple Watch 42mm Gold + Midnight Blue Closed.png"),
        "value": "./images/Watches/Apple Watch/Device/42mm/Device Closed/Apple Watch 42mm Gold + Midnight Blue Closed.png",
        "label": "Apple Watch 42mm Gold + Midnight Blue Closed",
        "width": 512,
        "height": 990,
        "top": 300,
        "left": 100
      },
      {
        "image": require("./images/Watches/Apple Watch/Device/42mm/Device Closed/Apple Watch 42mm Rose Gold + Black Leather Closed.png"),
        "value": "./images/Watches/Apple Watch/Device/42mm/Device Closed/Apple Watch 42mm Rose Gold + Black Leather Closed.png",
        "label": "Apple Watch 42mm Rose Gold + Black Leather Closed",
        "width": 512,
        "height": 990,
        "top": 300,
        "left": 100
      },
      {
        "image": require("./images/Watches/Apple Watch/Device/42mm/Device Closed/Apple Watch 42mm Rose Gold + Lavender Closed.png"),
        "value": "./images/Watches/Apple Watch/Device/42mm/Device Closed/Apple Watch 42mm Rose Gold + Lavender Closed.png",
        "label": "Apple Watch 42mm Rose Gold + Lavender Closed",
        "width": 512,
        "height": 990,
        "top": 300,
        "left": 100
      },
      {
        "image": require("./images/Watches/Apple Watch/Device/42mm/Device Closed/Apple Watch 42mm Sport Aluminum + Blue Closed.png"),
        "value": "./images/Watches/Apple Watch/Device/42mm/Device Closed/Apple Watch 42mm Sport Aluminum + Blue Closed.png",
        "label": "Apple Watch 42mm Sport Aluminum + Blue Closed",
        "width": 512,
        "height": 990,
        "top": 300,
        "left": 100
      },
      {
        "image": require("./images/Watches/Apple Watch/Device/42mm/Device Closed/Apple Watch 42mm Sport Aluminum + Fog Closed.png"),
        "value": "./images/Watches/Apple Watch/Device/42mm/Device Closed/Apple Watch 42mm Sport Aluminum + Fog Closed.png",
        "label": "Apple Watch 42mm Sport Aluminum + Fog Closed",
        "width": 512,
        "height": 990,
        "top": 300,
        "left": 100
      },
      {
        "image": require("./images/Watches/Apple Watch/Device/42mm/Device Closed/Apple Watch 42mm Sport Aluminum + Green Closed.png"),
        "value": "./images/Watches/Apple Watch/Device/42mm/Device Closed/Apple Watch 42mm Sport Aluminum + Green Closed.png",
        "label": "Apple Watch 42mm Sport Aluminum + Green Closed",
        "width": 512,
        "height": 990,
        "top": 300,
        "left": 100
      },
      {
        "image": require("./images/Watches/Apple Watch/Device/42mm/Device Closed/Apple Watch 42mm Sport Aluminum + Red Closed.png"),
        "value": "./images/Watches/Apple Watch/Device/42mm/Device Closed/Apple Watch 42mm Sport Aluminum + Red Closed.png",
        "label": "Apple Watch 42mm Sport Aluminum + Red Closed",
        "width": 512,
        "height": 990,
        "top": 300,
        "left": 100
      },
      {
        "image": require("./images/Watches/Apple Watch/Device/42mm/Device Closed/Apple Watch 42mm Sport Aluminum + Walnut Closed.png"),
        "value": "./images/Watches/Apple Watch/Device/42mm/Device Closed/Apple Watch 42mm Sport Aluminum + Walnut Closed.png",
        "label": "Apple Watch 42mm Sport Aluminum + Walnut Closed",
        "width": 512,
        "height": 990,
        "top": 300,
        "left": 100
      },
      {
        "image": require("./images/Watches/Apple Watch/Device/42mm/Device Closed/Apple Watch 42mm Sport Aluminum + White Closed.png"),
        "value": "./images/Watches/Apple Watch/Device/42mm/Device Closed/Apple Watch 42mm Sport Aluminum + White Closed.png",
        "label": "Apple Watch 42mm Sport Aluminum + White Closed",
        "width": 512,
        "height": 990,
        "top": 300,
        "left": 100
      },
      {
        "image": require("./images/Watches/Apple Watch/Device/42mm/Device Closed/Apple Watch 42mm Sport Aluminum Gold + Antique White Closed.png"),
        "value": "./images/Watches/Apple Watch/Device/42mm/Device Closed/Apple Watch 42mm Sport Aluminum Gold + Antique White Closed.png",
        "label": "Apple Watch 42mm Sport Aluminum Gold + Antique White Closed",
        "width": 512,
        "height": 990,
        "top": 300,
        "left": 100
      },
      {
        "image": require("./images/Watches/Apple Watch/Device/42mm/Device Closed/Apple Watch 42mm Sport Aluminum Rose Gold + Stone Closed.png"),
        "value": "./images/Watches/Apple Watch/Device/42mm/Device Closed/Apple Watch 42mm Sport Aluminum Rose Gold + Stone Closed.png",
        "label": "Apple Watch 42mm Sport Aluminum Rose Gold + Stone Closed",
        "width": 512,
        "height": 990,
        "top": 300,
        "left": 100
      },
      {
        "image": require("./images/Watches/Apple Watch/Device/42mm/Device Closed/Apple Watch 42mm Sport Space Gray + Black Closed.png"),
        "value": "./images/Watches/Apple Watch/Device/42mm/Device Closed/Apple Watch 42mm Sport Space Gray + Black Closed.png",
        "label": "Apple Watch 42mm Sport Space Gray + Black Closed",
        "width": 512,
        "height": 990,
        "top": 300,
        "left": 100
      },
      {
        "image": require("./images/Watches/Apple Watch/Device/42mm/Device Closed/Apple Watch 42mm Stainless Steel + Black Leather Closed.png"),
        "value": "./images/Watches/Apple Watch/Device/42mm/Device Closed/Apple Watch 42mm Stainless Steel + Black Leather Closed.png",
        "label": "Apple Watch 42mm Stainless Steel + Black Leather Closed",
        "width": 512,
        "height": 990,
        "top": 300,
        "left": 100
      },
      {
        "image": require("./images/Watches/Apple Watch/Device/42mm/Device Closed/Apple Watch 42mm Steel + White Closed.png"),
        "value": "./images/Watches/Apple Watch/Device/42mm/Device Closed/Apple Watch 42mm Steel + White Closed.png",
        "label": "Apple Watch 42mm Steel + White Closed",
        "width": 512,
        "height": 990,
        "top": 300,
        "left": 100
      },
      {
        "image": require("./images/Watches/Apple Watch/Device/42mm/Device Open/Apple Watch 42mm Black Steel + Black Open.png"),
        "value": "./images/Watches/Apple Watch/Device/42mm/Device Open/Apple Watch 42mm Black Steel + Black Open.png",
        "label": "Apple Watch 42mm Black Steel + Black Open",
        "width": 512,
        "height": 3930,
        "top": 1770,
        "left": 110
      },
      {
        "image": require("./images/Watches/Apple Watch/Device/42mm/Device Open/Apple Watch 42mm Gold + Midnight Blue Open.png"),
        "value": "./images/Watches/Apple Watch/Device/42mm/Device Open/Apple Watch 42mm Gold + Midnight Blue Open.png",
        "label": "Apple Watch 42mm Gold + Midnight Blue Open",
        "width": 512,
        "height": 3930,
        "top": 1770,
        "left": 110
      },
      {
        "image": require("./images/Watches/Apple Watch/Device/42mm/Device Open/Apple Watch 42mm Rose Gold + Lavender Open.png"),
        "value": "./images/Watches/Apple Watch/Device/42mm/Device Open/Apple Watch 42mm Rose Gold + Lavender Open.png",
        "label": "Apple Watch 42mm Rose Gold + Lavender Open",
        "width": 512,
        "height": 3930,
        "top": 1770,
        "left": 110
      },
      {
        "image": require("./images/Watches/Apple Watch/Device/42mm/Device Open/Apple Watch 42mm Sport Aluminum + Blue Open.png"),
        "value": "./images/Watches/Apple Watch/Device/42mm/Device Open/Apple Watch 42mm Sport Aluminum + Blue Open.png",
        "label": "Apple Watch 42mm Sport Aluminum + Blue Open",
        "width": 512,
        "height": 3930,
        "top": 1770,
        "left": 110
      },
      {
        "image": require("./images/Watches/Apple Watch/Device/42mm/Device Open/Apple Watch 42mm Sport Aluminum + Fog Open.png"),
        "value": "./images/Watches/Apple Watch/Device/42mm/Device Open/Apple Watch 42mm Sport Aluminum + Fog Open.png",
        "label": "Apple Watch 42mm Sport Aluminum + Fog Open",
        "width": 512,
        "height": 3930,
        "top": 1770,
        "left": 110
      },
      {
        "image": require("./images/Watches/Apple Watch/Device/42mm/Device Open/Apple Watch 42mm Sport Aluminum + Green Open.png"),
        "value": "./images/Watches/Apple Watch/Device/42mm/Device Open/Apple Watch 42mm Sport Aluminum + Green Open.png",
        "label": "Apple Watch 42mm Sport Aluminum + Green Open",
        "width": 512,
        "height": 3930,
        "top": 1770,
        "left": 110
      },
      {
        "image": require("./images/Watches/Apple Watch/Device/42mm/Device Open/Apple Watch 42mm Sport Aluminum + Red Open .png"),
        "value": "./images/Watches/Apple Watch/Device/42mm/Device Open/Apple Watch 42mm Sport Aluminum + Red Open .png",
        "label": "Apple Watch 42mm Sport Aluminum + Red Open",
        "width": 512,
        "height": 3930,
        "top": 1770,
        "left": 110
      },
      {
        "image": require("./images/Watches/Apple Watch/Device/42mm/Device Open/Apple Watch 42mm Sport Aluminum + Walnut Open.png"),
        "value": "./images/Watches/Apple Watch/Device/42mm/Device Open/Apple Watch 42mm Sport Aluminum + Walnut Open.png",
        "label": "Apple Watch 42mm Sport Aluminum + Walnut Open",
        "width": 512,
        "height": 3930,
        "top": 1770,
        "left": 110
      },
      {
        "image": require("./images/Watches/Apple Watch/Device/42mm/Device Open/Apple Watch 42mm Sport Aluminum + White Open.png"),
        "value": "./images/Watches/Apple Watch/Device/42mm/Device Open/Apple Watch 42mm Sport Aluminum + White Open.png",
        "label": "Apple Watch 42mm Sport Aluminum + White Open",
        "width": 512,
        "height": 3930,
        "top": 1770,
        "left": 110
      },
      {
        "image": require("./images/Watches/Apple Watch/Device/42mm/Device Open/Apple Watch 42mm Sport Aluminum Gold + Antique White Open.png"),
        "value": "./images/Watches/Apple Watch/Device/42mm/Device Open/Apple Watch 42mm Sport Aluminum Gold + Antique White Open.png",
        "label": "Apple Watch 42mm Sport Aluminum Gold + Antique White Open",
        "width": 512,
        "height": 3930,
        "top": 1770,
        "left": 110
      },
      {
        "image": require("./images/Watches/Apple Watch/Device/42mm/Device Open/Apple Watch 42mm Sport Aluminum Rose Gold + Stone Open.png"),
        "value": "./images/Watches/Apple Watch/Device/42mm/Device Open/Apple Watch 42mm Sport Aluminum Rose Gold + Stone Open.png",
        "label": "Apple Watch 42mm Sport Aluminum Rose Gold + Stone Open",
        "width": 512,
        "height": 3930,
        "top": 1770,
        "left": 110
      },
      {
        "image": require("./images/Watches/Apple Watch/Device/42mm/Device Open/Apple Watch 42mm Sport Space Gray + Black Open.png"),
        "value": "./images/Watches/Apple Watch/Device/42mm/Device Open/Apple Watch 42mm Sport Space Gray + Black Open.png",
        "label": "Apple Watch 42mm Sport Space Gray + Black Open",
        "width": 512,
        "height": 3930,
        "top": 1770,
        "left": 110
      },
      {
        "image": require("./images/Watches/Apple Watch/Device/42mm/Device Open/Apple Watch 42mm Steel + White Open.png"),
        "value": "./images/Watches/Apple Watch/Device/42mm/Device Open/Apple Watch 42mm Steel + White Open.png",
        "label": "Apple Watch 42mm Steel + White Open",
        "width": 512,
        "height": 3930,
        "top": 1770,
        "left": 110
      },
      {
        "image": require("./images/Watches/Apple Watch 2/Device/38mm/Device Closed/Apple Watch 38mm Black Steel + Black Closed.png"),
        "value": "./images/Watches/Apple Watch 2/Device/38mm/Device Closed/Apple Watch 38mm Black Steel + Black Closed.png",
        "label": "Apple Watch 38mm Black Steel + Black Closed",
        "width": 472,
        "height": 820,
        "top": 228,
        "left": 100
      },
      {
        "image": require("./images/Watches/Apple Watch 2/Device/38mm/Device Closed/Apple Watch 38mm Edition Closed.png"),
        "value": "./images/Watches/Apple Watch 2/Device/38mm/Device Closed/Apple Watch 38mm Edition Closed.png",
        "label": "Apple Watch 38mm Edition Closed",
        "width": 472,
        "height": 820,
        "top": 228,
        "left": 100
      },
      {
        "image": require("./images/Watches/Apple Watch 2/Device/38mm/Device Closed/Apple Watch 38mm Rose Gold Aluminum + Midnight Blue Closed.png"),
        "value": "./images/Watches/Apple Watch 2/Device/38mm/Device Closed/Apple Watch 38mm Rose Gold Aluminum + Midnight Blue Closed.png",
        "label": "Apple Watch 38mm Rose Gold Aluminum + Midnight Blue Closed",
        "width": 472,
        "height": 820,
        "top": 228,
        "left": 100
      },
      {
        "image": require("./images/Watches/Apple Watch 2/Device/38mm/Device Closed/Apple Watch 38mm Silver Aluminum + Cocoa Closed.png"),
        "value": "./images/Watches/Apple Watch 2/Device/38mm/Device Closed/Apple Watch 38mm Silver Aluminum + Cocoa Closed.png",
        "label": "Apple Watch 38mm Silver Aluminum + Cocoa Closed",
        "width": 472,
        "height": 820,
        "top": 228,
        "left": 100
      },
      {
        "image": require("./images/Watches/Apple Watch 2/Device/38mm/Device Closed/Apple Watch 38mm Silver Aluminum + Concrete Closed.png"),
        "value": "./images/Watches/Apple Watch 2/Device/38mm/Device Closed/Apple Watch 38mm Silver Aluminum + Concrete Closed.png",
        "label": "Apple Watch 38mm Silver Aluminum + Concrete Closed",
        "width": 472,
        "height": 820,
        "top": 228,
        "left": 100
      },
      {
        "image": require("./images/Watches/Apple Watch 2/Device/38mm/Device Closed/Apple Watch 38mm Silver Aluminum + Flat Silver Volt Nike Closed.png"),
        "value": "./images/Watches/Apple Watch 2/Device/38mm/Device Closed/Apple Watch 38mm Silver Aluminum + Flat Silver Volt Nike Closed.png",
        "label": "Apple Watch 38mm Silver Aluminum + Flat Silver Volt Nike Closed",
        "width": 472,
        "height": 820,
        "top": 228,
        "left": 100
      },
      {
        "image": require("./images/Watches/Apple Watch 2/Device/38mm/Device Closed/Apple Watch 38mm Silver Aluminum + Flat Silver White Nike Closed.png"),
        "value": "./images/Watches/Apple Watch 2/Device/38mm/Device Closed/Apple Watch 38mm Silver Aluminum + Flat Silver White Nike Closed.png",
        "label": "Apple Watch 38mm Silver Aluminum + Flat Silver White Nike Closed",
        "width": 472,
        "height": 820,
        "top": 228,
        "left": 100
      },
      {
        "image": require("./images/Watches/Apple Watch 2/Device/38mm/Device Closed/Apple Watch 38mm Silver Aluminum + Ocean Blue Closed.png"),
        "value": "./images/Watches/Apple Watch 2/Device/38mm/Device Closed/Apple Watch 38mm Silver Aluminum + Ocean Blue Closed.png",
        "label": "Apple Watch 38mm Silver Aluminum + Ocean Blue Closed",
        "width": 472,
        "height": 820,
        "top": 228,
        "left": 100
      },
      {
        "image": require("./images/Watches/Apple Watch 2/Device/38mm/Device Closed/Apple Watch 38mm Silver Aluminum + Red Closed.png"),
        "value": "./images/Watches/Apple Watch 2/Device/38mm/Device Closed/Apple Watch 38mm Silver Aluminum + Red Closed.png",
        "label": "Apple Watch 38mm Silver Aluminum + Red Closed",
        "width": 472,
        "height": 820,
        "top": 228,
        "left": 100
      },
      {
        "image": require("./images/Watches/Apple Watch 2/Device/38mm/Device Closed/Apple Watch 38mm Silver Aluminum + Turquoise Closed.png"),
        "value": "./images/Watches/Apple Watch 2/Device/38mm/Device Closed/Apple Watch 38mm Silver Aluminum + Turquoise Closed.png",
        "label": "Apple Watch 38mm Silver Aluminum + Turquoise Closed",
        "width": 472,
        "height": 820,
        "top": 228,
        "left": 100
      },
      {
        "image": require("./images/Watches/Apple Watch 2/Device/38mm/Device Closed/Apple Watch 38mm Silver Aluminum + White Closed.png"),
        "value": "./images/Watches/Apple Watch 2/Device/38mm/Device Closed/Apple Watch 38mm Silver Aluminum + White Closed.png",
        "label": "Apple Watch 38mm Silver Aluminum + White Closed",
        "width": 472,
        "height": 820,
        "top": 228,
        "left": 100
      },
      {
        "image": require("./images/Watches/Apple Watch 2/Device/38mm/Device Closed/Apple Watch 38mm Silver Aluminum + Yellow Closed.png"),
        "value": "./images/Watches/Apple Watch 2/Device/38mm/Device Closed/Apple Watch 38mm Silver Aluminum + Yellow Closed.png",
        "label": "Apple Watch 38mm Silver Aluminum + Yellow Closed",
        "width": 472,
        "height": 820,
        "top": 228,
        "left": 100
      },
      {
        "image": require("./images/Watches/Apple Watch 2/Device/38mm/Device Closed/Apple Watch 38mm Space Gray Aluminum + Black Closed.png"),
        "value": "./images/Watches/Apple Watch 2/Device/38mm/Device Closed/Apple Watch 38mm Space Gray Aluminum + Black Closed.png",
        "label": "Apple Watch 38mm Space Gray Aluminum + Black Closed",
        "width": 472,
        "height": 820,
        "top": 228,
        "left": 100
      },
      {
        "image": require("./images/Watches/Apple Watch 2/Device/38mm/Device Closed/Apple Watch 38mm Space Gray Aluminum + Black Cool Gray Nike Closed.png"),
        "value": "./images/Watches/Apple Watch 2/Device/38mm/Device Closed/Apple Watch 38mm Space Gray Aluminum + Black Cool Gray Nike Closed.png",
        "label": "Apple Watch 38mm Space Gray Aluminum + Black Cool Gray Nike Closed",
        "width": 472,
        "height": 820,
        "top": 228,
        "left": 100
      },
      {
        "image": require("./images/Watches/Apple Watch 2/Device/38mm/Device Closed/Apple Watch 38mm Space Gray Aluminum + Black Volt Nike Closed.png"),
        "value": "./images/Watches/Apple Watch 2/Device/38mm/Device Closed/Apple Watch 38mm Space Gray Aluminum + Black Volt Nike Closed.png",
        "label": "Apple Watch 38mm Space Gray Aluminum + Black Volt Nike Closed",
        "width": 472,
        "height": 820,
        "top": 228,
        "left": 100
      },
      {
        "image": require("./images/Watches/Apple Watch 2/Device/38mm/Device Closed/Apple Watch 38mm Sport Aluminum + Walnut Closed.png"),
        "value": "./images/Watches/Apple Watch 2/Device/38mm/Device Closed/Apple Watch 38mm Sport Aluminum + Walnut Closed.png",
        "label": "Apple Watch 38mm Sport Aluminum + Walnut Closed",
        "width": 472,
        "height": 820,
        "top": 228,
        "left": 100
      },
      {
        "image": require("./images/Watches/Apple Watch 2/Device/38mm/Device Closed/Apple Watch 38mm Steel + White Closed.png"),
        "value": "./images/Watches/Apple Watch 2/Device/38mm/Device Closed/Apple Watch 38mm Steel + White Closed.png",
        "label": "Apple Watch 38mm Steel + White Closed",
        "width": 472,
        "height": 820,
        "top": 228,
        "left": 100
      },
      {
        "image": require("./images/Watches/Apple Watch 2/Device/38mm/Device Open/Apple Watch 38mm Black Steel + Black Open.png"),
        "value": "./images/Watches/Apple Watch 2/Device/38mm/Device Open/Apple Watch 38mm Black Steel + Black Open.png",
        "label": "Apple Watch 38mm Black Steel + Black Open",
        "width": 472,
        "height": 3540,
        "top": 1600,
        "left": 100
      },
      {
        "image": require("./images/Watches/Apple Watch 2/Device/38mm/Device Open/Apple Watch 38mm Edition Open.png"),
        "value": "./images/Watches/Apple Watch 2/Device/38mm/Device Open/Apple Watch 38mm Edition Open.png",
        "label": "Apple Watch 38mm Edition Open",
        "width": 472,
        "height": 3540,
        "top": 1600,
        "left": 100
      },
      {
        "image": require("./images/Watches/Apple Watch 2/Device/38mm/Device Open/Apple Watch 38mm Rose Gold Aluminum + Midnight Blue Open.png"),
        "value": "./images/Watches/Apple Watch 2/Device/38mm/Device Open/Apple Watch 38mm Rose Gold Aluminum + Midnight Blue Open.png",
        "label": "Apple Watch 38mm Rose Gold Aluminum + Midnight Blue Open",
        "width": 472,
        "height": 3540,
        "top": 1600,
        "left": 100
      },
      {
        "image": require("./images/Watches/Apple Watch 2/Device/38mm/Device Open/Apple Watch 38mm Silver Aluminum + Cocoa Open.png"),
        "value": "./images/Watches/Apple Watch 2/Device/38mm/Device Open/Apple Watch 38mm Silver Aluminum + Cocoa Open.png",
        "label": "Apple Watch 38mm Silver Aluminum + Cocoa Open",
        "width": 472,
        "height": 3540,
        "top": 1600,
        "left": 100
      },
      {
        "image": require("./images/Watches/Apple Watch 2/Device/38mm/Device Open/Apple Watch 38mm Silver Aluminum + Concrete Open.png"),
        "value": "./images/Watches/Apple Watch 2/Device/38mm/Device Open/Apple Watch 38mm Silver Aluminum + Concrete Open.png",
        "label": "Apple Watch 38mm Silver Aluminum + Concrete Open",
        "width": 472,
        "height": 3540,
        "top": 1600,
        "left": 100
      },
      {
        "image": require("./images/Watches/Apple Watch 2/Device/38mm/Device Open/Apple Watch 38mm Silver Aluminum + Flat Silver Volt Nike Open.png"),
        "value": "./images/Watches/Apple Watch 2/Device/38mm/Device Open/Apple Watch 38mm Silver Aluminum + Flat Silver Volt Nike Open.png",
        "label": "Apple Watch 38mm Silver Aluminum + Flat Silver Volt Nike Open",
        "width": 472,
        "height": 3540,
        "top": 1600,
        "left": 100
      },
      {
        "image": require("./images/Watches/Apple Watch 2/Device/38mm/Device Open/Apple Watch 38mm Silver Aluminum + Flat Silver White Nike Open.png"),
        "value": "./images/Watches/Apple Watch 2/Device/38mm/Device Open/Apple Watch 38mm Silver Aluminum + Flat Silver White Nike Open.png",
        "label": "Apple Watch 38mm Silver Aluminum + Flat Silver White Nike Open",
        "width": 472,
        "height": 3540,
        "top": 1600,
        "left": 100
      },
      {
        "image": require("./images/Watches/Apple Watch 2/Device/38mm/Device Open/Apple Watch 38mm Silver Aluminum + Ocean Blue Open.png"),
        "value": "./images/Watches/Apple Watch 2/Device/38mm/Device Open/Apple Watch 38mm Silver Aluminum + Ocean Blue Open.png",
        "label": "Apple Watch 38mm Silver Aluminum + Ocean Blue Open",
        "width": 472,
        "height": 3540,
        "top": 1600,
        "left": 100
      },
      {
        "image": require("./images/Watches/Apple Watch 2/Device/38mm/Device Open/Apple Watch 38mm Silver Aluminum + Pink Sand Open.png"),
        "value": "./images/Watches/Apple Watch 2/Device/38mm/Device Open/Apple Watch 38mm Silver Aluminum + Pink Sand Open.png",
        "label": "Apple Watch 38mm Silver Aluminum + Pink Sand Open",
        "width": 472,
        "height": 3540,
        "top": 1600,
        "left": 100
      },
      {
        "image": require("./images/Watches/Apple Watch 2/Device/38mm/Device Open/Apple Watch 38mm Silver Aluminum + Red Open.png"),
        "value": "./images/Watches/Apple Watch 2/Device/38mm/Device Open/Apple Watch 38mm Silver Aluminum + Red Open.png",
        "label": "Apple Watch 38mm Silver Aluminum + Red Open",
        "width": 472,
        "height": 3540,
        "top": 1600,
        "left": 100
      },
      {
        "image": require("./images/Watches/Apple Watch 2/Device/38mm/Device Open/Apple Watch 38mm Silver Aluminum + Turquoise Open.png"),
        "value": "./images/Watches/Apple Watch 2/Device/38mm/Device Open/Apple Watch 38mm Silver Aluminum + Turquoise Open.png",
        "label": "Apple Watch 38mm Silver Aluminum + Turquoise Open",
        "width": 472,
        "height": 3540,
        "top": 1600,
        "left": 100
      },
      {
        "image": require("./images/Watches/Apple Watch 2/Device/38mm/Device Open/Apple Watch 38mm Silver Aluminum + White Open.png"),
        "value": "./images/Watches/Apple Watch 2/Device/38mm/Device Open/Apple Watch 38mm Silver Aluminum + White Open.png",
        "label": "Apple Watch 38mm Silver Aluminum + White Open",
        "width": 472,
        "height": 3540,
        "top": 1600,
        "left": 100
      },
      {
        "image": require("./images/Watches/Apple Watch 2/Device/38mm/Device Open/Apple Watch 38mm Silver Aluminum + Yellow Open.png"),
        "value": "./images/Watches/Apple Watch 2/Device/38mm/Device Open/Apple Watch 38mm Silver Aluminum + Yellow Open.png",
        "label": "Apple Watch 38mm Silver Aluminum + Yellow Open",
        "width": 472,
        "height": 3540,
        "top": 1600,
        "left": 100
      },
      {
        "image": require("./images/Watches/Apple Watch 2/Device/38mm/Device Open/Apple Watch 38mm Space Gray Aluminum + Black Cool Gray Nike Open.png"),
        "value": "./images/Watches/Apple Watch 2/Device/38mm/Device Open/Apple Watch 38mm Space Gray Aluminum + Black Cool Gray Nike Open.png",
        "label": "Apple Watch 38mm Space Gray Aluminum + Black Cool Gray Nike Open",
        "width": 472,
        "height": 3540,
        "top": 1600,
        "left": 100
      },
      {
        "image": require("./images/Watches/Apple Watch 2/Device/38mm/Device Open/Apple Watch 38mm Space Gray Aluminum + Black Open.png"),
        "value": "./images/Watches/Apple Watch 2/Device/38mm/Device Open/Apple Watch 38mm Space Gray Aluminum + Black Open.png",
        "label": "Apple Watch 38mm Space Gray Aluminum + Black Open",
        "width": 472,
        "height": 3540,
        "top": 1600,
        "left": 100
      },
      {
        "image": require("./images/Watches/Apple Watch 2/Device/38mm/Device Open/Apple Watch 38mm Space Gray Aluminum + Black Volt Nike Open.png"),
        "value": "./images/Watches/Apple Watch 2/Device/38mm/Device Open/Apple Watch 38mm Space Gray Aluminum + Black Volt Nike Open.png",
        "label": "Apple Watch 38mm Space Gray Aluminum + Black Volt Nike Open",
        "width": 472,
        "height": 3540,
        "top": 1600,
        "left": 100
      },
      {
        "image": require("./images/Watches/Apple Watch 2/Device/38mm/Device Open/Apple Watch 38mm Steel + White Open.png"),
        "value": "./images/Watches/Apple Watch 2/Device/38mm/Device Open/Apple Watch 38mm Steel + White Open.png",
        "label": "Apple Watch 38mm Steel + White Open",
        "width": 472,
        "height": 3540,
        "top": 1600,
        "left": 100
      },
      {
        "image": require("./images/Watches/Apple Watch 2/Device/42mm/Device Closed/Apple Watch 42mm Edition Closed.png"),
        "value": "./images/Watches/Apple Watch 2/Device/42mm/Device Closed/Apple Watch 42mm Edition Closed.png",
        "label": "Apple Watch 42mm Edition Closed",
        "width": 512,
        "height": 950,
        "top": 300,
        "left": 100
      },
      {
        "image": require("./images/Watches/Apple Watch 2/Device/42mm/Device Closed/Apple Watch 42mm Gold Aluminum + Cocoa Closed.png"),
        "value": "./images/Watches/Apple Watch 2/Device/42mm/Device Closed/Apple Watch 42mm Gold Aluminum + Cocoa Closed.png",
        "label": "Apple Watch 42mm Gold Aluminum + Cocoa Closed",
        "width": 512,
        "height": 950,
        "top": 300,
        "left": 100
      },
      {
        "image": require("./images/Watches/Apple Watch 2/Device/42mm/Device Closed/Apple Watch 42mm Rose Gold Aluminum + Midnight Blue Closed.png"),
        "value": "./images/Watches/Apple Watch 2/Device/42mm/Device Closed/Apple Watch 42mm Rose Gold Aluminum + Midnight Blue Closed.png",
        "label": "Apple Watch 42mm Rose Gold Aluminum + Midnight Blue Closed",
        "width": 512,
        "height": 950,
        "top": 300,
        "left": 100
      },
      {
        "image": require("./images/Watches/Apple Watch 2/Device/42mm/Device Closed/Apple Watch 42mm Silver Aluminum + Concrete Closed.png"),
        "value": "./images/Watches/Apple Watch 2/Device/42mm/Device Closed/Apple Watch 42mm Silver Aluminum + Concrete Closed.png",
        "label": "Apple Watch 42mm Silver Aluminum + Concrete Closed",
        "width": 512,
        "height": 950,
        "top": 300,
        "left": 100
      },
      {
        "image": require("./images/Watches/Apple Watch 2/Device/42mm/Device Closed/Apple Watch 42mm Silver Aluminum + Flat Silver Volt Nike Closed.png"),
        "value": "./images/Watches/Apple Watch 2/Device/42mm/Device Closed/Apple Watch 42mm Silver Aluminum + Flat Silver Volt Nike Closed.png",
        "label": "Apple Watch 42mm Silver Aluminum + Flat Silver Volt Nike Closed",
        "width": 512,
        "height": 950,
        "top": 300,
        "left": 100
      },
      {
        "image": require("./images/Watches/Apple Watch 2/Device/42mm/Device Closed/Apple Watch 42mm Silver Aluminum + Flat Silver White Nike Closed.png"),
        "value": "./images/Watches/Apple Watch 2/Device/42mm/Device Closed/Apple Watch 42mm Silver Aluminum + Flat Silver White Nike Closed.png",
        "label": "Apple Watch 42mm Silver Aluminum + Flat Silver White Nike Closed",
        "width": 512,
        "height": 950,
        "top": 300,
        "left": 100
      },
      {
        "image": require("./images/Watches/Apple Watch 2/Device/42mm/Device Closed/Apple Watch 42mm Silver Aluminum + Green Closed.png"),
        "value": "./images/Watches/Apple Watch 2/Device/42mm/Device Closed/Apple Watch 42mm Silver Aluminum + Green Closed.png",
        "label": "Apple Watch 42mm Silver Aluminum + Green Closed",
        "width": 512,
        "height": 950,
        "top": 300,
        "left": 100
      },
      {
        "image": require("./images/Watches/Apple Watch 2/Device/42mm/Device Closed/Apple Watch 42mm Silver Aluminum + Light Pink Closed.png"),
        "value": "./images/Watches/Apple Watch 2/Device/42mm/Device Closed/Apple Watch 42mm Silver Aluminum + Light Pink Closed.png",
        "label": "Apple Watch 42mm Silver Aluminum + Light Pink Closed",
        "width": 512,
        "height": 950,
        "top": 300,
        "left": 100
      },
      {
        "image": require("./images/Watches/Apple Watch 2/Device/42mm/Device Closed/Apple Watch 42mm Silver Aluminum + Ocean Blue Closed.png"),
        "value": "./images/Watches/Apple Watch 2/Device/42mm/Device Closed/Apple Watch 42mm Silver Aluminum + Ocean Blue Closed.png",
        "label": "Apple Watch 42mm Silver Aluminum + Ocean Blue Closed",
        "width": 512,
        "height": 950,
        "top": 300,
        "left": 100
      },
      {
        "image": require("./images/Watches/Apple Watch 2/Device/42mm/Device Closed/Apple Watch 42mm Silver Aluminum + Pink Sand Closed.png"),
        "value": "./images/Watches/Apple Watch 2/Device/42mm/Device Closed/Apple Watch 42mm Silver Aluminum + Pink Sand Closed.png",
        "label": "Apple Watch 42mm Silver Aluminum + Pink Sand Closed",
        "width": 512,
        "height": 950,
        "top": 300,
        "left": 100
      },
      {
        "image": require("./images/Watches/Apple Watch 2/Device/42mm/Device Closed/Apple Watch 42mm Silver Aluminum + Red Closed.png"),
        "value": "./images/Watches/Apple Watch 2/Device/42mm/Device Closed/Apple Watch 42mm Silver Aluminum + Red Closed.png",
        "label": "Apple Watch 42mm Silver Aluminum + Red Closed",
        "width": 512,
        "height": 950,
        "top": 300,
        "left": 100
      },
      {
        "image": require("./images/Watches/Apple Watch 2/Device/42mm/Device Closed/Apple Watch 42mm Silver Aluminum + Turquoise Closed.png"),
        "value": "./images/Watches/Apple Watch 2/Device/42mm/Device Closed/Apple Watch 42mm Silver Aluminum + Turquoise Closed.png",
        "label": "Apple Watch 42mm Silver Aluminum + Turquoise Closed",
        "width": 512,
        "height": 950,
        "top": 300,
        "left": 100
      },
      {
        "image": require("./images/Watches/Apple Watch 2/Device/42mm/Device Closed/Apple Watch 42mm Silver Aluminum + White Closed.png"),
        "value": "./images/Watches/Apple Watch 2/Device/42mm/Device Closed/Apple Watch 42mm Silver Aluminum + White Closed.png",
        "label": "Apple Watch 42mm Silver Aluminum + White Closed",
        "width": 512,
        "height": 950,
        "top": 300,
        "left": 100
      },
      {
        "image": require("./images/Watches/Apple Watch 2/Device/42mm/Device Closed/Apple Watch 42mm Silver Aluminum + Yellow Closed.png"),
        "value": "./images/Watches/Apple Watch 2/Device/42mm/Device Closed/Apple Watch 42mm Silver Aluminum + Yellow Closed.png",
        "label": "Apple Watch 42mm Silver Aluminum + Yellow Closed",
        "width": 512,
        "height": 950,
        "top": 300,
        "left": 100
      },
      {
        "image": require("./images/Watches/Apple Watch 2/Device/42mm/Device Closed/Apple Watch 42mm Space Black Steel + Black Closed.png"),
        "value": "./images/Watches/Apple Watch 2/Device/42mm/Device Closed/Apple Watch 42mm Space Black Steel + Black Closed.png",
        "label": "Apple Watch 42mm Space Black Steel + Black Closed",
        "width": 512,
        "height": 950,
        "top": 300,
        "left": 100
      },
      {
        "image": require("./images/Watches/Apple Watch 2/Device/42mm/Device Closed/Apple Watch 42mm Space Gray Aluminum + Black Closed.png"),
        "value": "./images/Watches/Apple Watch 2/Device/42mm/Device Closed/Apple Watch 42mm Space Gray Aluminum + Black Closed.png",
        "label": "Apple Watch 42mm Space Gray Aluminum + Black Closed",
        "width": 512,
        "height": 950,
        "top": 300,
        "left": 100
      },
      {
        "image": require("./images/Watches/Apple Watch 2/Device/42mm/Device Closed/Apple Watch 42mm Space Gray Aluminum + Black Cool Gray Nike Closed.png"),
        "value": "./images/Watches/Apple Watch 2/Device/42mm/Device Closed/Apple Watch 42mm Space Gray Aluminum + Black Cool Gray Nike Closed.png",
        "label": "Apple Watch 42mm Space Gray Aluminum + Black Cool Gray Nike Closed",
        "width": 512,
        "height": 950,
        "top": 300,
        "left": 100
      },
      {
        "image": require("./images/Watches/Apple Watch 2/Device/42mm/Device Closed/Apple Watch 42mm Space Gray Aluminum + Black Volt Nike Closed.png"),
        "value": "./images/Watches/Apple Watch 2/Device/42mm/Device Closed/Apple Watch 42mm Space Gray Aluminum + Black Volt Nike Closed.png",
        "label": "Apple Watch 42mm Space Gray Aluminum + Black Volt Nike Closed",
        "width": 512,
        "height": 950,
        "top": 300,
        "left": 100
      },
      {
        "image": require("./images/Watches/Apple Watch 2/Device/42mm/Device Closed/Apple Watch 42mm Steel + White Closed.png"),
        "value": "./images/Watches/Apple Watch 2/Device/42mm/Device Closed/Apple Watch 42mm Steel + White Closed.png",
        "label": "Apple Watch 42mm Steel + White Closed",
        "width": 512,
        "height": 950,
        "top": 300,
        "left": 100
      },
      {
        "image": require("./images/Watches/Apple Watch 2/Device/42mm/Device Open/Apple Watch 42mm Edition Open.png"),
        "value": "./images/Watches/Apple Watch 2/Device/42mm/Device Open/Apple Watch 42mm Edition Open.png",
        "label": "Apple Watch 42mm Edition Open",
        "width": 512,
        "height": 3950,
        "top": 1770,
        "left": 110
      },
      {
        "image": require("./images/Watches/Apple Watch 2/Device/42mm/Device Open/Apple Watch 42mm Rose Gold Aluminum + Midnight Blue Open.png"),
        "value": "./images/Watches/Apple Watch 2/Device/42mm/Device Open/Apple Watch 42mm Rose Gold Aluminum + Midnight Blue Open.png",
        "label": "Apple Watch 42mm Rose Gold Aluminum + Midnight Blue Open",
        "width": 512,
        "height": 3950,
        "top": 1770,
        "left": 110
      },
      {
        "image": require("./images/Watches/Apple Watch 2/Device/42mm/Device Open/Apple Watch 42mm Silver Aluminum + Cocoa Open.png"),
        "value": "./images/Watches/Apple Watch 2/Device/42mm/Device Open/Apple Watch 42mm Silver Aluminum + Cocoa Open.png",
        "label": "Apple Watch 42mm Silver Aluminum + Cocoa Open",
        "width": 512,
        "height": 3950,
        "top": 1770,
        "left": 110
      },
      {
        "image": require("./images/Watches/Apple Watch 2/Device/42mm/Device Open/Apple Watch 42mm Silver Aluminum + Concrete Open.png"),
        "value": "./images/Watches/Apple Watch 2/Device/42mm/Device Open/Apple Watch 42mm Silver Aluminum + Concrete Open.png",
        "label": "Apple Watch 42mm Silver Aluminum + Concrete Open",
        "width": 512,
        "height": 3950,
        "top": 1770,
        "left": 110
      },
      {
        "image": require("./images/Watches/Apple Watch 2/Device/42mm/Device Open/Apple Watch 42mm Silver Aluminum + Flat Silver Volt Nike Open.png"),
        "value": "./images/Watches/Apple Watch 2/Device/42mm/Device Open/Apple Watch 42mm Silver Aluminum + Flat Silver Volt Nike Open.png",
        "label": "Apple Watch 42mm Silver Aluminum + Flat Silver Volt Nike Open",
        "width": 512,
        "height": 3950,
        "top": 1770,
        "left": 110
      },
      {
        "image": require("./images/Watches/Apple Watch 2/Device/42mm/Device Open/Apple Watch 42mm Silver Aluminum + Flat Silver White Nike Open.png"),
        "value": "./images/Watches/Apple Watch 2/Device/42mm/Device Open/Apple Watch 42mm Silver Aluminum + Flat Silver White Nike Open.png",
        "label": "Apple Watch 42mm Silver Aluminum + Flat Silver White Nike Open",
        "width": 512,
        "height": 3950,
        "top": 1770,
        "left": 110
      },
      {
        "image": require("./images/Watches/Apple Watch 2/Device/42mm/Device Open/Apple Watch 42mm Silver Aluminum + Green Open.png"),
        "value": "./images/Watches/Apple Watch 2/Device/42mm/Device Open/Apple Watch 42mm Silver Aluminum + Green Open.png",
        "label": "Apple Watch 42mm Silver Aluminum + Green Open",
        "width": 512,
        "height": 3950,
        "top": 1770,
        "left": 110
      },
      {
        "image": require("./images/Watches/Apple Watch 2/Device/42mm/Device Open/Apple Watch 42mm Silver Aluminum + Light Pink Open.png"),
        "value": "./images/Watches/Apple Watch 2/Device/42mm/Device Open/Apple Watch 42mm Silver Aluminum + Light Pink Open.png",
        "label": "Apple Watch 42mm Silver Aluminum + Light Pink Open",
        "width": 512,
        "height": 3950,
        "top": 1770,
        "left": 110
      },
      {
        "image": require("./images/Watches/Apple Watch 2/Device/42mm/Device Open/Apple Watch 42mm Silver Aluminum + Ocean Blue Open.png"),
        "value": "./images/Watches/Apple Watch 2/Device/42mm/Device Open/Apple Watch 42mm Silver Aluminum + Ocean Blue Open.png",
        "label": "Apple Watch 42mm Silver Aluminum + Ocean Blue Open",
        "width": 513,
        "height": 3950,
        "top": 1770,
        "left": 110
      },
      {
        "image": require("./images/Watches/Apple Watch 2/Device/42mm/Device Open/Apple Watch 42mm Silver Aluminum + Pink Sand Open.png"),
        "value": "./images/Watches/Apple Watch 2/Device/42mm/Device Open/Apple Watch 42mm Silver Aluminum + Pink Sand Open.png",
        "label": "Apple Watch 42mm Silver Aluminum + Pink Sand Open",
        "width": 512,
        "height": 3950,
        "top": 1770,
        "left": 110
      },
      {
        "image": require("./images/Watches/Apple Watch 2/Device/42mm/Device Open/Apple Watch 42mm Silver Aluminum + Red Open .png"),
        "value": "./images/Watches/Apple Watch 2/Device/42mm/Device Open/Apple Watch 42mm Silver Aluminum + Red Open .png",
        "label": "Apple Watch 42mm Silver Aluminum + Red Open",
        "width": 512,
        "height": 3950,
        "top": 1770,
        "left": 110
      },
      {
        "image": require("./images/Watches/Apple Watch 2/Device/42mm/Device Open/Apple Watch 42mm Silver Aluminum + Turquoise Open.png"),
        "value": "./images/Watches/Apple Watch 2/Device/42mm/Device Open/Apple Watch 42mm Silver Aluminum + Turquoise Open.png",
        "label": "Apple Watch 42mm Silver Aluminum + Turquoise Open",
        "width": 512,
        "height": 3950,
        "top": 1770,
        "left": 110
      },
      {
        "image": require("./images/Watches/Apple Watch 2/Device/42mm/Device Open/Apple Watch 42mm Silver Aluminum + White Open.png"),
        "value": "./images/Watches/Apple Watch 2/Device/42mm/Device Open/Apple Watch 42mm Silver Aluminum + White Open.png",
        "label": "Apple Watch 42mm Silver Aluminum + White Open",
        "width": 512,
        "height": 3950,
        "top": 1770,
        "left": 110
      },
      {
        "image": require("./images/Watches/Apple Watch 2/Device/42mm/Device Open/Apple Watch 42mm Silver Aluminum + Yellow Open.png"),
        "value": "./images/Watches/Apple Watch 2/Device/42mm/Device Open/Apple Watch 42mm Silver Aluminum + Yellow Open.png",
        "label": "Apple Watch 42mm Silver Aluminum + Yellow Open",
        "width": 512,
        "height": 3950,
        "top": 1770,
        "left": 110
      },
      {
        "image": require("./images/Watches/Apple Watch 2/Device/42mm/Device Open/Apple Watch 42mm Space Black Steel + Black Open.png"),
        "value": "./images/Watches/Apple Watch 2/Device/42mm/Device Open/Apple Watch 42mm Space Black Steel + Black Open.png",
        "label": "Apple Watch 42mm Space Black Steel + Black Open",
        "width": 512,
        "height": 3950,
        "top": 1770,
        "left": 110
      },
      {
        "image": require("./images/Watches/Apple Watch 2/Device/42mm/Device Open/Apple Watch 42mm Space Gray Aluminum + Black Cool Gray Nike Open.png"),
        "value": "./images/Watches/Apple Watch 2/Device/42mm/Device Open/Apple Watch 42mm Space Gray Aluminum + Black Cool Gray Nike Open.png",
        "label": "Apple Watch 42mm Space Gray Aluminum + Black Cool Gray Nike Open",
        "width": 512,
        "height": 3950,
        "top": 1770,
        "left": 110
      },
      {
        "image": require("./images/Watches/Apple Watch 2/Device/42mm/Device Open/Apple Watch 42mm Space Gray Aluminum + Black Open.png"),
        "value": "./images/Watches/Apple Watch 2/Device/42mm/Device Open/Apple Watch 42mm Space Gray Aluminum + Black Open.png",
        "label": "Apple Watch 42mm Space Gray Aluminum + Black Open",
        "width": 512,
        "height": 3950,
        "top": 1770,
        "left": 110
      },
      {
        "image": require("./images/Watches/Apple Watch 2/Device/42mm/Device Open/Apple Watch 42mm Space Gray Aluminum + Black Volt Nike Open.png"),
        "value": "./images/Watches/Apple Watch 2/Device/42mm/Device Open/Apple Watch 42mm Space Gray Aluminum + Black Volt Nike Open.png",
        "label": "Apple Watch 42mm Space Gray Aluminum + Black Volt Nike Open",
        "width": 512,
        "height": 3950,
        "top": 1770,
        "left": 110
      },
      {
        "image": require("./images/Watches/Apple Watch 2/Device/42mm/Device Open/Apple Watch 42mm Steel + White Open.png"),
        "value": "./images/Watches/Apple Watch 2/Device/42mm/Device Open/Apple Watch 42mm Steel + White Open.png",
        "label": "Apple Watch 42mm Steel + White Open",
        "width": 512,
        "height": 3950,
        "top": 1770,
        "left": 110
      },
      {
        "image": require("./images/Watches/Apple Watch Series 5/Device/40mm/Closed/Apple Watch 40mm Gold Aluminum + Pink Sand Closed.png"),
        "value": "./images/Watches/Apple Watch Series 5/Device/40mm/Closed/Apple Watch 40mm Gold Aluminum + Pink Sand Closed.png",
        "label": "Apple Watch 40mm Gold Aluminum + Pink Sand Closed",
        "width": 524,
        "height": 914,
        "top": 0,
        "left": 0
      },
      {
        "image": require("./images/Watches/Apple Watch Series 5/Device/40mm/Closed/Apple Watch 40mm Gold Stainless Steel + Stone Closed.png"),
        "value": "./images/Watches/Apple Watch Series 5/Device/40mm/Closed/Apple Watch 40mm Gold Stainless Steel + Stone Closed.png",
        "label": "Apple Watch 40mm Gold Stainless Steel + Stone Closed",
        "width": 524,
        "height": 914,
        "top": 0,
        "left": 0
      },
      {
        "image": require("./images/Watches/Apple Watch Series 5/Device/40mm/Closed/Apple Watch 40mm Silver Aluminum + Clementine Closed.png"),
        "value": "./images/Watches/Apple Watch Series 5/Device/40mm/Closed/Apple Watch 40mm Silver Aluminum + Clementine Closed.png",
        "label": "Apple Watch 40mm Silver Aluminum + Clementine Closed",
        "width": 524,
        "height": 914,
        "top": 0,
        "left": 0
      },
      {
        "image": require("./images/Watches/Apple Watch Series 5/Device/40mm/Closed/Apple Watch 40mm Space Black Stainless Steel + Alaskan Blue Closed.png"),
        "value": "./images/Watches/Apple Watch Series 5/Device/40mm/Closed/Apple Watch 40mm Space Black Stainless Steel + Alaskan Blue Closed.png",
        "label": "Apple Watch 40mm Space Black Stainless Steel + Alaskan Blue Closed",
        "width": 524,
        "height": 914,
        "top": 0,
        "left": 0
      },
      {
        "image": require("./images/Watches/Apple Watch Series 5/Device/40mm/Closed/Apple Watch 40mm Space Black Titanium + Pine Green Closed.png"),
        "value": "./images/Watches/Apple Watch Series 5/Device/40mm/Closed/Apple Watch 40mm Space Black Titanium + Pine Green Closed.png",
        "label": "Apple Watch 40mm Space Black Titanium + Pine Green Closed",
        "width": 524,
        "height": 914,
        "top": 0,
        "left": 0
      },
      {
        "image": require("./images/Watches/Apple Watch Series 5/Device/40mm/Closed/Apple Watch 40mm Space Grey Aluminum + Black Closed.png"),
        "value": "./images/Watches/Apple Watch Series 5/Device/40mm/Closed/Apple Watch 40mm Space Grey Aluminum + Black Closed.png",
        "label": "Apple Watch 40mm Space Grey Aluminum + Black Closed",
        "width": 524,
        "height": 914,
        "top": 0,
        "left": 0
      },
      {
        "image": require("./images/Watches/Apple Watch Series 5/Device/40mm/Closed/Apple Watch 40mm Stainless Steel + Lemon Cream Closed.png"),
        "value": "./images/Watches/Apple Watch Series 5/Device/40mm/Closed/Apple Watch 40mm Stainless Steel + Lemon Cream Closed.png",
        "label": "Apple Watch 40mm Stainless Steel + Lemon Cream Closed",
        "width": 524,
        "height": 914,
        "top": 0,
        "left": 0
      },
      {
        "image": require("./images/Watches/Apple Watch Series 5/Device/40mm/Closed/Apple Watch 40mm Titanium + Red Closed.png"),
        "value": "./images/Watches/Apple Watch Series 5/Device/40mm/Closed/Apple Watch 40mm Titanium + Red Closed.png",
        "label": "Apple Watch 40mm Titanium + Red Closed",
        "width": 524,
        "height": 914,
        "top": 0,
        "left": 0
      },
      {
        "image": require("./images/Watches/Apple Watch Series 5/Device/40mm/Closed/Apple Watch 40mm White Ceramic + White Closed.png"),
        "value": "./images/Watches/Apple Watch Series 5/Device/40mm/Closed/Apple Watch 40mm White Ceramic + White Closed.png",
        "label": "Apple Watch 40mm White Ceramic + White Closed",
        "width": 524,
        "height": 914,
        "top": 0,
        "left": 0
      },
      {
        "image": require("./images/Watches/Apple Watch Series 5/Device/40mm/Open/Apple Watch 40mm Gold Aluminum + Pink Sand Open.png"),
        "value": "./images/Watches/Apple Watch Series 5/Device/40mm/Open/Apple Watch 40mm Gold Aluminum + Pink Sand Open.png",
        "label": "Apple Watch 40mm Gold Aluminum + Pink Sand Open",
        "width": 524,
        "height": 3794,
        "top": 0,
        "left": 0
      },
      {
        "image": require("./images/Watches/Apple Watch Series 5/Device/40mm/Open/Apple Watch 40mm Gold Stainless Steel + Stone Open.png"),
        "value": "./images/Watches/Apple Watch Series 5/Device/40mm/Open/Apple Watch 40mm Gold Stainless Steel + Stone Open.png",
        "label": "Apple Watch 40mm Gold Stainless Steel + Stone Open",
        "width": 524,
        "height": 3794,
        "top": 0,
        "left": 0
      },
      {
        "image": require("./images/Watches/Apple Watch Series 5/Device/40mm/Open/Apple Watch 40mm Silver Aluminum + Clementine Open.png"),
        "value": "./images/Watches/Apple Watch Series 5/Device/40mm/Open/Apple Watch 40mm Silver Aluminum + Clementine Open.png",
        "label": "Apple Watch 40mm Silver Aluminum + Clementine Open",
        "width": 524,
        "height": 3794,
        "top": 0,
        "left": 0
      },
      {
        "image": require("./images/Watches/Apple Watch Series 5/Device/40mm/Open/Apple Watch 40mm Space Black Stainless Steel + Alaskan Blue Open.png"),
        "value": "./images/Watches/Apple Watch Series 5/Device/40mm/Open/Apple Watch 40mm Space Black Stainless Steel + Alaskan Blue Open.png",
        "label": "Apple Watch 40mm Space Black Stainless Steel + Alaskan Blue Open",
        "width": 524,
        "height": 3794,
        "top": 0,
        "left": 0
      },
      {
        "image": require("./images/Watches/Apple Watch Series 5/Device/40mm/Open/Apple Watch 40mm Space Black Titanium + Pine Green Open.png"),
        "value": "./images/Watches/Apple Watch Series 5/Device/40mm/Open/Apple Watch 40mm Space Black Titanium + Pine Green Open.png",
        "label": "Apple Watch 40mm Space Black Titanium + Pine Green Open",
        "width": 524,
        "height": 3794,
        "top": 0,
        "left": 0
      },
      {
        "image": require("./images/Watches/Apple Watch Series 5/Device/40mm/Open/Apple Watch 40mm Space Grey Aluminum + Black Open.png"),
        "value": "./images/Watches/Apple Watch Series 5/Device/40mm/Open/Apple Watch 40mm Space Grey Aluminum + Black Open.png",
        "label": "Apple Watch 40mm Space Grey Aluminum + Black Open",
        "width": 524,
        "height": 3794,
        "top": 0,
        "left": 0
      },
      {
        "image": require("./images/Watches/Apple Watch Series 5/Device/40mm/Open/Apple Watch 40mm Stainless Steel + Lemon Cream Open.png"),
        "value": "./images/Watches/Apple Watch Series 5/Device/40mm/Open/Apple Watch 40mm Stainless Steel + Lemon Cream Open.png",
        "label": "Apple Watch 40mm Stainless Steel + Lemon Cream Open",
        "width": 524,
        "height": 3794,
        "top": 0,
        "left": 0
      },
      {
        "image": require("./images/Watches/Apple Watch Series 5/Device/40mm/Open/Apple Watch 40mm Titanium + Red Open.png"),
        "value": "./images/Watches/Apple Watch Series 5/Device/40mm/Open/Apple Watch 40mm Titanium + Red Open.png",
        "label": "Apple Watch 40mm Titanium + Red Open",
        "width": 524,
        "height": 3794,
        "top": 0,
        "left": 0
      },
      {
        "image": require("./images/Watches/Apple Watch Series 5/Device/40mm/Open/Apple Watch 40mm White Ceramic + White Open.png"),
        "value": "./images/Watches/Apple Watch Series 5/Device/40mm/Open/Apple Watch 40mm White Ceramic + White Open.png",
        "label": "Apple Watch 40mm White Ceramic + White Open",
        "width": 524,
        "height": 3794,
        "top": 0,
        "left": 0
      },
      {
        "image": require("./images/Watches/Apple Watch Series 5/Device/44mm/Closed/Apple Watch 44mm Gold Aluminum + Pink Sand Closed.png"),
        "value": "./images/Watches/Apple Watch Series 5/Device/44mm/Closed/Apple Watch 44mm Gold Aluminum + Pink Sand Closed.png",
        "label": "Apple Watch 44mm Gold Aluminum + Pink Sand Closed",
        "width": 568,
        "height": 968,
        "top": 0,
        "left": 0
      },
      {
        "image": require("./images/Watches/Apple Watch Series 5/Device/44mm/Closed/Apple Watch 44mm Gold Stainless Steel + Stone Closed.png"),
        "value": "./images/Watches/Apple Watch Series 5/Device/44mm/Closed/Apple Watch 44mm Gold Stainless Steel + Stone Closed.png",
        "label": "Apple Watch 44mm Gold Stainless Steel + Stone Closed",
        "width": 568,
        "height": 968,
        "top": 0,
        "left": 0
      },
      {
        "image": require("./images/Watches/Apple Watch Series 5/Device/44mm/Closed/Apple Watch 44mm Silver Aluminum + Clementine Closed.png"),
        "value": "./images/Watches/Apple Watch Series 5/Device/44mm/Closed/Apple Watch 44mm Silver Aluminum + Clementine Closed.png",
        "label": "Apple Watch 44mm Silver Aluminum + Clementine Closed",
        "width": 568,
        "height": 968,
        "top": 0,
        "left": 0
      },
      {
        "image": require("./images/Watches/Apple Watch Series 5/Device/44mm/Closed/Apple Watch 44mm Space Black Stainless Steel + Alaskan Blue Closed.png"),
        "value": "./images/Watches/Apple Watch Series 5/Device/44mm/Closed/Apple Watch 44mm Space Black Stainless Steel + Alaskan Blue Closed.png",
        "label": "Apple Watch 44mm Space Black Stainless Steel + Alaskan Blue Closed",
        "width": 568,
        "height": 968,
        "top": 0,
        "left": 0
      },
      {
        "image": require("./images/Watches/Apple Watch Series 5/Device/44mm/Closed/Apple Watch 44mm Space Black Titanium + Pine Green Closed.png"),
        "value": "./images/Watches/Apple Watch Series 5/Device/44mm/Closed/Apple Watch 44mm Space Black Titanium + Pine Green Closed.png",
        "label": "Apple Watch 44mm Space Black Titanium + Pine Green Closed",
        "width": 568,
        "height": 968,
        "top": 0,
        "left": 0
      },
      {
        "image": require("./images/Watches/Apple Watch Series 5/Device/44mm/Closed/Apple Watch 44mm Space Grey Aluminum + Black Closed.png"),
        "value": "./images/Watches/Apple Watch Series 5/Device/44mm/Closed/Apple Watch 44mm Space Grey Aluminum + Black Closed.png",
        "label": "Apple Watch 44mm Space Grey Aluminum + Black Closed",
        "width": 568,
        "height": 968,
        "top": 0,
        "left": 0
      },
      {
        "image": require("./images/Watches/Apple Watch Series 5/Device/44mm/Closed/Apple Watch 44mm Stainless Steel + Lemon Cream Closed.png"),
        "value": "./images/Watches/Apple Watch Series 5/Device/44mm/Closed/Apple Watch 44mm Stainless Steel + Lemon Cream Closed.png",
        "label": "Apple Watch 44mm Stainless Steel + Lemon Cream Closed",
        "width": 568,
        "height": 968,
        "top": 0,
        "left": 0
      },
      {
        "image": require("./images/Watches/Apple Watch Series 5/Device/44mm/Closed/Apple Watch 44mm Titanium + Red Closed.png"),
        "value": "./images/Watches/Apple Watch Series 5/Device/44mm/Closed/Apple Watch 44mm Titanium + Red Closed.png",
        "label": "Apple Watch 44mm Titanium + Red Closed",
        "width": 568,
        "height": 968,
        "top": 0,
        "left": 0
      },
      {
        "image": require("./images/Watches/Apple Watch Series 5/Device/44mm/Closed/Apple Watch 44mm White Ceramic + White Closed.png"),
        "value": "./images/Watches/Apple Watch Series 5/Device/44mm/Closed/Apple Watch 44mm White Ceramic + White Closed.png",
        "label": "Apple Watch 44mm White Ceramic + White Closed",
        "width": 568,
        "height": 968,
        "top": 0,
        "left": 0
      },
      {
        "image": require("./images/Watches/Apple Watch Series 5/Device/44mm/Open/Apple Watch 44mm Gold Aluminum + Pink Sand Open.png"),
        "value": "./images/Watches/Apple Watch Series 5/Device/44mm/Open/Apple Watch 44mm Gold Aluminum + Pink Sand Open.png",
        "label": "Apple Watch 44mm Gold Aluminum + Pink Sand Open",
        "width": 568,
        "height": 3848,
        "top": 0,
        "left": 0
      },
      {
        "image": require("./images/Watches/Apple Watch Series 5/Device/44mm/Open/Apple Watch 44mm Gold Stainless Steel + Stone Open.png"),
        "value": "./images/Watches/Apple Watch Series 5/Device/44mm/Open/Apple Watch 44mm Gold Stainless Steel + Stone Open.png",
        "label": "Apple Watch 44mm Gold Stainless Steel + Stone Open",
        "width": 568,
        "height": 3848,
        "top": 0,
        "left": 0
      },
      {
        "image": require("./images/Watches/Apple Watch Series 5/Device/44mm/Open/Apple Watch 44mm Silver Aluminum + Clementine Open.png"),
        "value": "./images/Watches/Apple Watch Series 5/Device/44mm/Open/Apple Watch 44mm Silver Aluminum + Clementine Open.png",
        "label": "Apple Watch 44mm Silver Aluminum + Clementine Open",
        "width": 568,
        "height": 3848,
        "top": 0,
        "left": 0
      },
      {
        "image": require("./images/Watches/Apple Watch Series 5/Device/44mm/Open/Apple Watch 44mm Space Black Stainless Steel + Alaskan Blue Open.png"),
        "value": "./images/Watches/Apple Watch Series 5/Device/44mm/Open/Apple Watch 44mm Space Black Stainless Steel + Alaskan Blue Open.png",
        "label": "Apple Watch 44mm Space Black Stainless Steel + Alaskan Blue Open",
        "width": 568,
        "height": 3848,
        "top": 0,
        "left": 0
      },
      {
        "image": require("./images/Watches/Apple Watch Series 5/Device/44mm/Open/Apple Watch 44mm Space Black Titanium + Pine Green Open.png"),
        "value": "./images/Watches/Apple Watch Series 5/Device/44mm/Open/Apple Watch 44mm Space Black Titanium + Pine Green Open.png",
        "label": "Apple Watch 44mm Space Black Titanium + Pine Green Open",
        "width": 568,
        "height": 3848,
        "top": 0,
        "left": 0
      },
      {
        "image": require("./images/Watches/Apple Watch Series 5/Device/44mm/Open/Apple Watch 44mm Space Grey Aluminum + Black Open.png"),
        "value": "./images/Watches/Apple Watch Series 5/Device/44mm/Open/Apple Watch 44mm Space Grey Aluminum + Black Open.png",
        "label": "Apple Watch 44mm Space Grey Aluminum + Black Open",
        "width": 568,
        "height": 3848,
        "top": 0,
        "left": 0
      },
      {
        "image": require("./images/Watches/Apple Watch Series 5/Device/44mm/Open/Apple Watch 44mm Stainless Steel + Lemon Cream Open.png"),
        "value": "./images/Watches/Apple Watch Series 5/Device/44mm/Open/Apple Watch 44mm Stainless Steel + Lemon Cream Open.png",
        "label": "Apple Watch 44mm Stainless Steel + Lemon Cream Open",
        "width": 568,
        "height": 3848,
        "top": 0,
        "left": 0
      },
      {
        "image": require("./images/Watches/Apple Watch Series 5/Device/44mm/Open/Apple Watch 44mm Titanium + Red Open.png"),
        "value": "./images/Watches/Apple Watch Series 5/Device/44mm/Open/Apple Watch 44mm Titanium + Red Open.png",
        "label": "Apple Watch 44mm Titanium + Red Open",
        "width": 568,
        "height": 3848,
        "top": 0,
        "left": 0
      },
      {
        "image": require("./images/Watches/Apple Watch Series 5/Device/44mm/Open/Apple Watch 44mm White Ceramic + White Open.png"),
        "value": "./images/Watches/Apple Watch Series 5/Device/44mm/Open/Apple Watch 44mm White Ceramic + White Open.png",
        "label": "Apple Watch 44mm White Ceramic + White Open",
        "width": 568,
        "height": 3848,
        "top": 0,
        "left": 0
      },
      {
        "image": require("./images/Watches/Motorola Moto 360/Device Closed/Motorola Moto 360 Men Black + Black Closed.png"),
        "value": "./images/Watches/Motorola Moto 360/Device Closed/Motorola Moto 360 Men Black + Black Closed.png",
        "label": "Motorola Moto 360 Men Black + Black Closed",
        "width": 448,
        "height": 640,
        "top": 139,
        "left": 44
      },
      {
        "image": require("./images/Watches/Motorola Moto 360/Device Closed/Motorola Moto 360 Men Black + Cognac Closed.png"),
        "value": "./images/Watches/Motorola Moto 360/Device Closed/Motorola Moto 360 Men Black + Cognac Closed.png",
        "label": "Motorola Moto 360 Men Black + Cognac Closed",
        "width": 448,
        "height": 640,
        "top": 139,
        "left": 44
      },
      {
        "image": require("./images/Watches/Motorola Moto 360/Device Closed/Motorola Moto 360 Men Gold + Black Closed.png"),
        "value": "./images/Watches/Motorola Moto 360/Device Closed/Motorola Moto 360 Men Gold + Black Closed.png",
        "label": "Motorola Moto 360 Men Gold + Black Closed",
        "width": 448,
        "height": 640,
        "top": 139,
        "left": 44
      },
      {
        "image": require("./images/Watches/Motorola Moto 360/Device Closed/Motorola Moto 360 Men Gold + Cognac Closed.png"),
        "value": "./images/Watches/Motorola Moto 360/Device Closed/Motorola Moto 360 Men Gold + Cognac Closed.png",
        "label": "Motorola Moto 360 Men Gold + Cognac Closed",
        "width": 448,
        "height": 640,
        "top": 139,
        "left": 44
      },
      {
        "image": require("./images/Watches/Motorola Moto 360/Device Closed/Motorola Moto 360 Men Silver + Black Closed.png"),
        "value": "./images/Watches/Motorola Moto 360/Device Closed/Motorola Moto 360 Men Silver + Black Closed.png",
        "label": "Motorola Moto 360 Men Silver + Black Closed",
        "width": 448,
        "height": 640,
        "top": 139,
        "left": 44
      },
      {
        "image": require("./images/Watches/Motorola Moto 360/Device Closed/Motorola Moto 360 Men Silver + Cognac Closed.png"),
        "value": "./images/Watches/Motorola Moto 360/Device Closed/Motorola Moto 360 Men Silver + Cognac Closed.png",
        "label": "Motorola Moto 360 Men Silver + Cognac Closed",
        "width": 448,
        "height": 640,
        "top": 139,
        "left": 44
      },
      {
        "image": require("./images/Watches/Motorola Moto 360/Device Closed/Motorola Moto 360 Women Gold + Blush Closed.png"),
        "value": "./images/Watches/Motorola Moto 360/Device Closed/Motorola Moto 360 Women Gold + Blush Closed.png",
        "label": "Motorola Moto 360 Women Gold + Blush Closed",
        "width": 448,
        "height": 600,
        "top": 139,
        "left": 44
      },
      {
        "image": require("./images/Watches/Motorola Moto 360/Device Closed/Motorola Moto 360 Women Gold + Stone Closed.png"),
        "value": "./images/Watches/Motorola Moto 360/Device Closed/Motorola Moto 360 Women Gold + Stone Closed.png",
        "label": "Motorola Moto 360 Women Gold + Stone Closed",
        "width": 448,
        "height": 600,
        "top": 139,
        "left": 44
      },
      {
        "image": require("./images/Watches/Motorola Moto 360/Device Closed/Motorola Moto 360 Women Rose Gold + Blush Closed.png"),
        "value": "./images/Watches/Motorola Moto 360/Device Closed/Motorola Moto 360 Women Rose Gold + Blush Closed.png",
        "label": "Motorola Moto 360 Women Rose Gold + Blush Closed",
        "width": 448,
        "height": 600,
        "top": 139,
        "left": 44
      },
      {
        "image": require("./images/Watches/Motorola Moto 360/Device Closed/Motorola Moto 360 Women Rose Gold + Stone Grey Closed.png"),
        "value": "./images/Watches/Motorola Moto 360/Device Closed/Motorola Moto 360 Women Rose Gold + Stone Grey Closed.png",
        "label": "Motorola Moto 360 Women Rose Gold + Stone Grey Closed",
        "width": 448,
        "height": 600,
        "top": 139,
        "left": 44
      },
      {
        "image": require("./images/Watches/Motorola Moto 360/Device Closed/Motorola Moto 360 Women Silver + Blush Closed.png"),
        "value": "./images/Watches/Motorola Moto 360/Device Closed/Motorola Moto 360 Women Silver + Blush Closed.png",
        "label": "Motorola Moto 360 Women Silver + Blush Closed",
        "width": 448,
        "height": 600,
        "top": 139,
        "left": 44
      },
      {
        "image": require("./images/Watches/Motorola Moto 360/Device Closed/Motorola Moto 360 Women Silver + Stone Grey Closed.png"),
        "value": "./images/Watches/Motorola Moto 360/Device Closed/Motorola Moto 360 Women Silver + Stone Grey Closed.png",
        "label": "Motorola Moto 360 Women Silver + Stone Grey Closed",
        "width": 448,
        "height": 600,
        "top": 139,
        "left": 44
      },
      {
        "image": require("./images/Watches/Motorola Moto 360/Device Open/Motorola Moto 360 Men Black + Black Open.png"),
        "value": "./images/Watches/Motorola Moto 360/Device Open/Motorola Moto 360 Men Black + Black Open.png",
        "label": "Motorola Moto 360 Men Black + Black Open",
        "width": 448,
        "height": 2424,
        "top": 807,
        "left": 44
      },
      {
        "image": require("./images/Watches/Motorola Moto 360/Device Open/Motorola Moto 360 Men Black + Cognac Open.png"),
        "value": "./images/Watches/Motorola Moto 360/Device Open/Motorola Moto 360 Men Black + Cognac Open.png",
        "label": "Motorola Moto 360 Men Black + Cognac Open",
        "width": 448,
        "height": 2424,
        "top": 807,
        "left": 44
      },
      {
        "image": require("./images/Watches/Motorola Moto 360/Device Open/Motorola Moto 360 Men Gold + Black Open.png"),
        "value": "./images/Watches/Motorola Moto 360/Device Open/Motorola Moto 360 Men Gold + Black Open.png",
        "label": "Motorola Moto 360 Men Gold + Black Open",
        "width": 448,
        "height": 2424,
        "top": 807,
        "left": 44
      },
      {
        "image": require("./images/Watches/Motorola Moto 360/Device Open/Motorola Moto 360 Men Gold + Cognac Open.png"),
        "value": "./images/Watches/Motorola Moto 360/Device Open/Motorola Moto 360 Men Gold + Cognac Open.png",
        "label": "Motorola Moto 360 Men Gold + Cognac Open",
        "width": 448,
        "height": 2424,
        "top": 807,
        "left": 44
      },
      {
        "image": require("./images/Watches/Motorola Moto 360/Device Open/Motorola Moto 360 Men Silver + Black Open.png"),
        "value": "./images/Watches/Motorola Moto 360/Device Open/Motorola Moto 360 Men Silver + Black Open.png",
        "label": "Motorola Moto 360 Men Silver + Black Open",
        "width": 448,
        "height": 2424,
        "top": 807,
        "left": 44
      },
      {
        "image": require("./images/Watches/Motorola Moto 360/Device Open/Motorola Moto 360 Men Silver + Cognac Open.png"),
        "value": "./images/Watches/Motorola Moto 360/Device Open/Motorola Moto 360 Men Silver + Cognac Open.png",
        "label": "Motorola Moto 360 Men Silver + Cognac Open",
        "width": 448,
        "height": 2424,
        "top": 807,
        "left": 44
      },
      {
        "image": require("./images/Watches/Motorola Moto 360/Device Open/Motorola Moto 360 Women Gold + Blush Open.png"),
        "value": "./images/Watches/Motorola Moto 360/Device Open/Motorola Moto 360 Women Gold + Blush Open.png",
        "label": "Motorola Moto 360 Women Gold + Blush Open",
        "width": 448,
        "height": 2314,
        "top": 807,
        "left": 44
      },
      {
        "image": require("./images/Watches/Motorola Moto 360/Device Open/Motorola Moto 360 Women Gold + Stone Open.png"),
        "value": "./images/Watches/Motorola Moto 360/Device Open/Motorola Moto 360 Women Gold + Stone Open.png",
        "label": "Motorola Moto 360 Women Gold + Stone Open",
        "width": 448,
        "height": 2314,
        "top": 807,
        "left": 44
      },
      {
        "image": require("./images/Watches/Motorola Moto 360/Device Open/Motorola Moto 360 Women Rose Gold + Blush Open.png"),
        "value": "./images/Watches/Motorola Moto 360/Device Open/Motorola Moto 360 Women Rose Gold + Blush Open.png",
        "label": "Motorola Moto 360 Women Rose Gold + Blush Open",
        "width": 448,
        "height": 2314,
        "top": 807,
        "left": 44
      },
      {
        "image": require("./images/Watches/Motorola Moto 360/Device Open/Motorola Moto 360 Women Rose Gold + Stone Grey Open.png"),
        "value": "./images/Watches/Motorola Moto 360/Device Open/Motorola Moto 360 Women Rose Gold + Stone Grey Open.png",
        "label": "Motorola Moto 360 Women Rose Gold + Stone Grey Open",
        "width": 448,
        "height": 2314,
        "top": 807,
        "left": 44
      },
      {
        "image": require("./images/Watches/Motorola Moto 360/Device Open/Motorola Moto 360 Women Silver + Blush Open.png"),
        "value": "./images/Watches/Motorola Moto 360/Device Open/Motorola Moto 360 Women Silver + Blush Open.png",
        "label": "Motorola Moto 360 Women Silver + Blush Open",
        "width": 448,
        "height": 2314,
        "top": 807,
        "left": 44
      },
      {
        "image": require("./images/Watches/Motorola Moto 360/Device Open/Motorola Moto 360 Women Silver + Stone Grey Open.png"),
        "value": "./images/Watches/Motorola Moto 360/Device Open/Motorola Moto 360 Women Silver + Stone Grey Open.png",
        "label": "Motorola Moto 360 Women Silver + Stone Grey Open",
        "width": 448,
        "height": 2314,
        "top": 807,
        "left": 44
      },
      {
        "image": require("./images/Watches/Sony SmartWatch 3/Device Closed/Sony SmartWatch 3 Black Closed.png"),
        "value": "./images/Watches/Sony SmartWatch 3/Device Closed/Sony SmartWatch 3 Black Closed.png",
        "label": "Sony SmartWatch 3 Black Closed",
        "width": 448,
        "height": 740,
        "top": 1102,
        "left": 64
      },
      {
        "image": require("./images/Watches/Sony SmartWatch 3/Device Closed/Sony SmartWatch 3 White Closed.png"),
        "value": "./images/Watches/Sony SmartWatch 3/Device Closed/Sony SmartWatch 3 White Closed.png",
        "label": "Sony SmartWatch 3 White Closed",
        "width": 448,
        "height": 740,
        "top": 1102,
        "left": 64
      },
      {
        "image": require("./images/Watches/Sony SmartWatch 3/Device Open/Sony SmartWatch 3 Black Open.png"),
        "value": "./images/Watches/Sony SmartWatch 3/Device Open/Sony SmartWatch 3 Black Open.png",
        "label": "Sony SmartWatch 3 Black Open",
        "width": 448,
        "height": 2600,
        "top": 188,
        "left": 64
      },
      {
        "image": require("./images/Watches/Sony SmartWatch 3/Device Open/Sony SmartWatch 3 White Open.png"),
        "value": "./images/Watches/Sony SmartWatch 3/Device Open/Sony SmartWatch 3 White Open.png",
        "label": "Sony SmartWatch 3 White Open",
        "width": 448,
        "height": 2600,
        "top": 188,
        "left": 64
      }
    ]
  }
]